(function ()
{
    'use strict';

    angular
        .module('app.tokens', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.tokens', {
                url    : '/tokens',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/tokens/tokens.html',
                        controller : 'TokensController as vm'
                    }
                },
                //resolve: {
                //    RequestsData: function (msApi)
                //    {
                //        return msApi.resolve('requests@get');
                //    }
                //}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/tokens');

        // Api
        //msApiProvider.register('requests', ['app/data/requests/data.json']);

        // Navigation
        //msNavigationServiceProvider.saveItem('fuse', {
        //    title : 'SAMPLE',
        //    group : true,
        //    weight: 1
        //});

        msNavigationServiceProvider.saveItem('tokens', {
            title    : 'Tokens',
            icon     : 'icon-account-key',
            state    : 'app.tokens',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'TOKENS.TOKENS_NAV',
            weight   : 1
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.tokens')
        .controller('ControlTokenController', ControlTokenController);

    function ControlTokenController($mdDialog, event, token, action, Notification, CountriesDataISO2, meisterapi, MEISTER){
        var vm = this;
        
		vm.token = token;
		vm.action = action;
		
		vm.countryListAlpha2 = CountriesDataISO2.data;
		
		vm.save = save;
        vm.closeDialog = closeDialog;
		
		function save() {
			if(vm.action === "ADD_OWN") {
				if (vm.token.country_code === "" || vm.token.party === ""){
					Notification.warning({
						message: 'Please Fill in all the required fields!',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
				}
				else {
					var tmpToken = {
						tokenType: "Α",
						clientId: vm.token.country_code + vm.token.party.toUpperCase(),
						setResponseObjectData: true
					};
					
					meisterapi.createOwnToken(tmpToken).then(function (result) {
						Notification.success({
							message: 'Token for client ' + tmpToken.clientId + ' Created Successfully!',
							delay: 3000,
							positionX:"right",
							positionY:"bottom"
						});
						var answer = {
							action: vm.action,
							token: tmpToken,
							status: 'success'
						}
						$mdDialog.hide(answer);
					});
					
				}
			}
			else if(vm.action === "ADD_FOREIGN") {
				if(vm.token.token === "" || vm.token.url === "" || vm.token.credentials_token_owner_ID === "") {
					Notification.warning({
						message: 'Please Fill in all the required fields!',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
				}
				else if (!validateUrl(vm.token.url)){
					Notification.warning({
						message: 'Please enter a valid url address!',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
				}
				else {
					
					var tmpToken = {
						token: vm.token.token,
						url: vm.token.url,
						credentials_token_owner_ID: vm.token.country_code + vm.token.party.toUpperCase()
					};
					
					meisterapi.addForeignToken(tmpToken).then(function (result) {
						Notification.success({
							message: 'Foreign Token from owner ' + tmpToken.ownerId + ' Added Successfully!',
							delay: 3000,
							positionX:"right",
							positionY:"bottom"
						});
						var answer = {
							action: vm.action,
							token: tmpToken,
							status: 'success'
						}
						$mdDialog.hide(answer);
					});
					
				}
			}
			else if(vm.action === "DELETE") {
				
				meisterapi.deleteCredentials(vm.token).then(function (result) {
					Notification.success({
						message: 'Token Deleted Successfully!',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
					var answer = {
						action: vm.action,
						token: vm.token
					}
					$mdDialog.hide(answer);
				});
				
			}
		}
		
		function validateUrl(url) {
			var re = new RegExp('^(http[s]?:\\/\\/){0,1}(www\\.){0,1}[a-zA-Z0-9\\.\\-]+\\.[a-zA-Z]{2,5}[\\.]{0,1}$');
			return re.test(url);
		}
		
		
		function closeDialog() {
			$mdDialog.cancel();
		}
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.platform-users', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.platform-users', {
                url    : '/platform-users',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/platform-users/platform-users.html',
                        controller : 'PlatformUsersController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/platform-users');

        msNavigationServiceProvider.saveItem('platform-users', {
            title    : 'Platform Users',
            icon     : 'icon-people',
            state    : 'app.platform-users',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'PLATFORM_USERS.PLATFORM_USERS_NAV',
            weight   : 1
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.platform-users')
        .controller('ControlPlatformUserController', ControlPlatformUserController);

    function ControlPlatformUserController($mdDialog, event, user, action, Notification, CountriesDataISO2, meisterapi, MEISTER){
        var vm = this;
		vm.countryListAlpha2 = CountriesDataISO2.data;
		
		vm.platformUser = angular.copy(user);
		vm.action = action;
		
		vm.allRoles = [
			{title: 'CPO', value: 'ROLE_CPO'},
			{title: 'DSO', value: 'ROLE_DSO'},
			{title: 'EV Fleet Manager', value: 'ROLE_EV_FLEET_MANAGER'},
			{title: 'Administrator', value: 'ROLE_ADMIN'}
		];
		
		vm.save = save;
        vm.closeDialog = closeDialog;
		
		function save() {
			if(vm.action === "ADD") {
				if(
					vm.platformUser.firstName === "" || 
					vm.platformUser.lastName === "" || 
					vm.platformUser.username === "" || 
					vm.platformUser.password === "" || 
					vm.platformUser.email === "" || 
					vm.platformUser.country_code === "" || 
					vm.platformUser.party_id === "" || 
					vm.platformUser.roles === ""
				) {
					Notification.warning({
						message: 'Please Fill in all the required fields!',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
				}
				else {
					
					vm.platformUser.party_id = vm.platformUser.party_id.toUpperCase();
					
					meisterapi.addPlatformUser(vm.platformUser).then(function (result) {
						Notification.success({
							message: 'User Uploaded Successfully!',
							delay: 3000,
							positionX:"right",
							positionY:"bottom"
						});
						var answer = {
							action:vm.action,
							user: vm.platformUser,
							status: 'success'
						}
						$mdDialog.hide(answer);
					});
					
				}
			}
			else if(vm.action === "EDIT") {
				if(
					vm.platformUser.firstName === "" || 
					vm.platformUser.lastName === "" || 
					vm.platformUser.username === "" || 
					vm.platformUser.password === "" || 
					vm.platformUser.email === "" || 
					vm.platformUser.country_code === "" || 
					vm.platformUser.party_id === "" || 
					vm.platformUser.roles === "" 
				) {
					Notification.warning({
						message: 'Please Fill in all the required fields!',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
				}
				else {
					vm.platformUser.party_id = vm.platformUser.party_id.toUpperCase();
					meisterapi.editPlatformUser(vm.platformUser.id, vm.platformUser).then(function (result) {
						Notification.success({
							message: 'User Uploaded Successfully!',
							delay: 3000,
							positionX:"right",
							positionY:"bottom"
						});
						var answer = {
							action:vm.action,
							user: vm.platformUser,
							status: 'success'
						}
						$mdDialog.hide(answer);
					});
					
				}
			}
			else if(vm.action === "DELETE") {
				
				meisterapi.deletePlatformUser(vm.platformUser.id).then(function (result) {
					Notification.success({
						message: 'User Deleted Successfully!',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
					var answer = {
						action:vm.action,
						user: vm.platformUser,
						status: 'success'
					}
					$mdDialog.hide(answer);
				});
			}
		}
		
		function closeDialog() {
			$mdDialog.cancel();
		}
		
    }
})();
(function () {
    'use strict';

    angular
        .module('app.monitoring', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.monitoring', {
                url    : '/monitoring',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/monitoring/monitoring.html',
                        controller : 'MonitoringController as vm'
                    }
                },
                //resolve: {
                //    MonitoringData: function (msApi) {
                //        return msApi.resolve('monitoring@get');
                //    }
                //}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/monitoring');

        // Api
        //msApiProvider.register('monitoring', ['app/data/monitoring/data.json']);
		msApiProvider.register('countriesiso2', ['app/data/countriesiso2/data.json']);
        msApiProvider.register('countriesiso3', ['app/data/countriesiso3/data.json']);

        msNavigationServiceProvider.saveItem('monitoring', {
            title    : 'Monitoring',
            icon     : 'icon-chart-line',
            state    : 'app.monitoring',
            translate: 'MONITORING.MONITORING_NAV',
            weight   : 1
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.monitoring')
        .controller('ControlChargerController', ControlChargerController);

    function ControlChargerController($mdDialog, event, parkingID, charger, action, Notification, meisterapi, MEISTER){
        var vm = this;
        
		vm.parkingID = parkingID;
		vm.charger = angular.copy(charger);
		vm.action = action;
		
		vm.statuses = ["AVAILABLE", "BLOCKED", "CHARGING", "INOPERATIVE", "OUTOFORDER", "PLANNED", "REMOVED", "RESERVED", "UNKNOWN"];
		vm.capabilities = ["CHARGING_PROFILE_CAPABLE", "CHARGING_PREFERENCES_CAPABLE", "CHIP_CARD_SUPPORT", "CONTACTLESS_CARD_SUPPORT", "CREDIT_CARD_PAYABLE", "DEBIT_CARD_PAYABLE", "PED_TERMINAL", "REMOTE_START_STOP_CAPABLE", "RESERVABLE", "RFID_READER", "TOKEN_GROUP_CAPABLE", "UNLOCK_CAPABLE"];
		
		vm.standards = ["CHADEMO","DOMESTIC_A","DOMESTIC_B","DOMESTIC_C","DOMESTIC_D","DOMESTIC_E","DOMESTIC_F","DOMESTIC_G","DOMESTIC_H","DOMESTIC_I","DOMESTIC_J","DOMESTIC_K","DOMESTIC_L","IEC_60309_2_single_16","IEC_60309_2_three_16","IEC_60309_2_three_32","IEC_60309_2_three_64","IEC_62196_T1","IEC_62196_T1_COMBO","IEC_62196_T2","IEC_62196_T2_COMBO","IEC_62196_T3A","IEC_62196_T3C","PANTOGRAPH_BOTTOM_UP","PANTOGRAPH_TOP_DOWN","TESLA_R","TESLA_S"];
		vm.formats = ["SOCKET", "CABLE"];
		vm.powerTypes = ["AC_1_PHASE", "AC_3_PHASE", "DC"];
		
		vm.save = save;
		vm.addConnector = addConnector;
        vm.closeDialog = closeDialog;
		
		function save() {
			if(vm.action === "ADD") {
				if(vm.charger.status === "") {
					Notification.warning({
						message: 'Please Fill in all the required fields!',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
				}
				else {
					
					meisterapi.newCharger(vm.parkingID, vm.charger).then(function (result) {
						Notification.success({
							message: 'CHARGER Uploaded Successfully!',
							delay: 3000,
							positionX:"right",
							positionY:"bottom"
						});
						var answer = {
							action:vm.action,
							charger: vm.charger,
							status: 'success'
						}
						$mdDialog.hide(answer);
					});
				}
			}
			else if(vm.action === "EDIT") {
				if(vm.charger.status === "") {
					Notification.warning({
						message: 'Please Fill in all the required fields!',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
				}
				else {
					
					meisterapi.editCharger(vm.parkingID, vm.charger).then(function (result) {
						Notification.success({
							message: 'CHARGER Uploaded Successfully!',
							delay: 3000,
							positionX:"right",
							positionY:"bottom"
						});
						var answer = {
							action:vm.action,
							charger: vm.charger,
							status: 'success'
						}
						$mdDialog.hide(answer);
					});
				}
			}
			else if(vm.action === "DELETE") {
				
				meisterapi.deleteCharger(vm.parkingID, vm.charger.uid).then(function (result) {
					Notification.success({
						message: 'CHARGER Uploaded Successfully!',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
					var answer = {
						action:vm.action,
						charger: vm.charger,
						status: 'success'
					}
					$mdDialog.hide(answer);
				});
			}
		}
		
		
		function addConnector() {
			vm.charger.connectors.push({
				id: String(vm.charger.connectors.length + 1),
				locked: "",
				standard: "",
				format: "",
				power_type: "",
				max_voltage: 0,
				voltage: 0,
				max_amperage: 0,
				amperage: 0,
				max_electric_power: 0,
				tarrif_ids: null
			});
			
		}
		
		
		
		
		
		function closeDialog() {
			$mdDialog.cancel();
		}
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.monitoring')
        .controller('ControlParkingController', ControlParkingController);

    function ControlParkingController($mdDialog, event, parking, action, Notification, CountriesDataISO2, CountriesDataISO3, meisterapi, MEISTER){
        var vm = this;
        
		vm.parking = parking;
		vm.action = action;
		
		vm.countryListAlpha2 = CountriesDataISO2.data;
		vm.countryListAlpha3 = CountriesDataISO3.data;
		vm.locationTypes =['ON_STREET','PARKING_GARAGE','UNDERGROUND_GARAGE','PARKING_LOT','OTHER','UNKNOWN'];
		vm.facilities = ['AIRPORT','BIKE_SHARING','BUS_STOP','CAFE','CARPOOL_PARKING','PARKING_LOT','FUEL_STATION','HOTEL','METRO_STATION','MALL','MUSEUM','NATURE','RECREATION_AREA','RESTAURANT','SUPERMARKET','TAXI_STAND','TRAIN_STATION','TRAM_STOP','WIFI'];
		
		vm.save = save;
        vm.closeDialog = closeDialog;
		
		function save() {
			if(vm.action === "ADD") {
				if(vm.parking.name === "") {
					Notification.warning({
						message: 'Please Fill in all the required fields!',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
				}
				else {
					meisterapi.newParking(vm.parking).then(function (result) {	
						Notification.success({
							message: 'PARKING ' + vm.parking.name + ' Uploaded Successfully!',
							delay: 3000,
							positionX:"right",
							positionY:"bottom"
						});
						var answer = {
							action:vm.action,
							parking: vm.parking,
							status: 'success'
						}
						$mdDialog.hide(answer);
					});
				}
			}
			else if(vm.action === "EDIT") {
				if(vm.parking.name === "") {
					Notification.warning({
						message: 'Please Fill in all the required fields!',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
				}
				else {
					meisterapi.updateParking(vm.parking).then(function (result) {
						Notification.success({
							message: 'PARKING ' + vm.parking.name + ' Updated Successfully!',
							delay: 3000,
							positionX:"right",
							positionY:"bottom"
						});
						var answer = {
							action: vm.action,
							parking: vm.parking
						}
						$mdDialog.hide(answer);
					});
				}
			}
			else if(vm.action === "DELETE") {
				meisterapi.deleteParking(vm.parking).then(function (result) {
					Notification.success({
						message: 'PARKING ' + vm.parking.name + ' Deleted Successfully!',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
					var answer = {
						action: vm.action,
						parking: vm.parking
					}
					$mdDialog.hide(answer);
				});
			}
		}
		
		function closeDialog() {
			$mdDialog.cancel();
		}
		
		/*
		
        vm.save=save;
        vm.dName="";
        vm.user=user;
        if(vm.user.hasVerticals)
        {
            vm.currentModule=vm.user.currentModule;
        }
        else
        {
            vm.currentModule="";
        }
        vm.url=url;
        if(vm.action==="Edit")
            vm.dName=vm.dashboard.name;
		
        function save()
        {
            if(vm.action==="New")
            {
                if(vm.dName=="")
                {
                    Notification.warning({
                        message: 'Please Fill in all the required fields!',
                        delay: 3000,
                        positionX:"right",
                        positionY:"bottom"
                        });
                }
                else
                {
                    var newDashboard=
                    {
                        token:generateUUID(),
                        name:vm.dName,
                        type:"",
                        userType:"",
                        userId:vm.user.username,
                        widgets:[],
                        data:{},
                        parent:"",
                        module:vm.currentModule
                    };
                    monsoonapi.callRestService(vm.url, "/dashboards", newDashboard, true, vm.user.authentication, "POST", true, false).then(function(res){
                         Notification.success({
                            message: 'Dashboard '+vm.dName+' Uploaded Successfully!',
                            delay: 3000,
                            positionX:"right",
                            positionY:"bottom"
                        });
                        var answer=
                        {
                            action:vm.action,
                            token:newDashboard.token
                        }
                        $mdDialog.hide(answer);
                    });
                }
            }
            else if(vm.action==="Edit")
            {
                if(vm.dName=="")
                {
                    Notification.warning({
                        message: 'Please Fill in all the required fields!',
                        delay: 3000,
                        positionX:"right",
                        positionY:"bottom"
                        });
                }
                else
                {
                    var newDashboard=
                    {
                        token:vm.dashboard.token,
                        name:vm.dName,
                        type:vm.dashboard.type,
                        userType:vm.dashboard.userType,
                        userId:vm.dashboard.userId,
                        widgets:vm.dashboard.widgets,
                        module:vm.dashboard.module
                    };
                    monsoonapi.callRestService(vm.url, "/dashboards/"+vm.dashboard.token, newDashboard, true, vm.user.authentication, "PUT", true, false).then(function(res){
                         Notification.success({
                            message: 'Dashboard '+vm.dName+' Updated Successfully!',
                            delay: 3000,
                            positionX:"right",
                            positionY:"bottom"
                        });
                        var answer=
                        {
                            action:vm.action,
                            token:newDashboard.token
                        }
                        $mdDialog.hide(answer);
                    });
                }
            }
            else if(vm.action==="Save")
            {
                var newDashboard=
                {
                    token:vm.dashboard.token,
                    name:vm.dashboard.name,
                    type:vm.dashboard.type,
                    userType:vm.dashboard.userType,
                    userId:vm.dashboard.userId,
                    widgets:vm.dashboard.widgets,
                    module:vm.dashboard.module
                };
                monsoonapi.callRestService(vm.url, "/dashboards/"+vm.dashboard.token, newDashboard, true, vm.user.authentication, "PUT", true, false).then(function(res){
                        Notification.success({
                        message: 'Dashboard '+vm.dName+' Saved Successfully!',
                        delay: 3000,
                        positionX:"right",
                        positionY:"bottom"
                    });
                    var answer=
                    {
                        action:vm.action,
                        token:newDashboard.token
                    }
                    $mdDialog.hide(answer);
                });
            }
            else if(vm.action==="Duplicate")
            {
                if(vm.dName=="")
                {
                    Notification.warning({
                        message: 'Please Fill in all the required fields!',
                        delay: 3000,
                        positionX:"right",
                        positionY:"bottom"
                        });
                }
                else
                {
                    var newDashboard=
                    {
                        token:generateUUID(),
                        name:vm.dName,
                        type:"",
                        userType:"",
                        userId:vm.user.username,
                        widgets:vm.dashboard.widgets,
                        module:vm.dashboard.module
                    };
                    monsoonapi.callRestService(vm.url, "/dashboards", newDashboard, true, vm.user.authentication, "POST", true, false).then(function(res){
                         Notification.success({
                            message: 'Dashboard '+vm.dashboard.name+' Duplicated Successfully!',
                            delay: 3000,
                            positionX:"right",
                            positionY:"bottom"
                        });
                        var answer=
                        {
                            action:vm.action,
                            token:newDashboard.token
                        }
                        $mdDialog.hide(answer);
                    });
                }
            }
            else if(vm.action==="Delete")
            {
                if(vm.dashboard.userId==="")
                {
                     monsoonapi.callRestService(vm.url, "/userPreferences/userId/"+vm.user.username+"/", "", true, vm.user.authentication, "GET", true, false).then(function(res){
                        vm.userPreferences=
                        {
                            language:res.data.language,
                            palette:res.data.palette,
                            token:res.data.token,
                            trees:res.data.trees,
                            userId:res.data.userId,
                            removedDashboards:res.data.removedDashboards
                        };
                        vm.userPreferences.removedDashboards.push(vm.dashboard.token);
                        monsoonapi.callRestService(vm.url, "/userPreferences/"+vm.userPreferences.token+"/", vm.userPreferences, true, vm.user.authentication, "PUT", true, false).then(function(res){
                            Notification.success({
                                message: 'Dashboard '+vm.dName+' Deleted Successfully!',
                                delay: 3000,
                                positionX:"right",
                                positionY:"bottom"
                            });
                            var answer=
                            {
                                action:vm.action,
                                token:null
                            }
                            $mdDialog.hide(answer);
                        });
                    });
                }
                else
                {
                    monsoonapi.callRestService(vm.url, "/dashboards/"+vm.dashboard.token, "?force=true", true, vm.user.authentication, "DELETE", true, false).then(function(res){
                        Notification.success({
                        message: 'Dashboard '+vm.dName+' Deleted Successfully!',
                        delay: 3000,
                        positionX:"right",
                        positionY:"bottom"
                    });
                    var answer=
                    {
                        action:vm.action,
                        token:null
                    }
                    $mdDialog.hide(answer);
                });
                }
            }
            else if(vm.action==="Restore")
            {
                monsoonapi.callRestService(vm.url, "/userPreferences/userId/"+vm.user.username+"/", "", true, vm.user.authentication, "GET", true, false).then(function(res){
                    vm.userPreferences=
                    {
                        language:res.data.language,
                        palette:res.data.palette,
                        token:res.data.token,
                        trees:res.data.trees,
                        userId:res.data.userId,
                        removedDashboards:[]
                    };
                    monsoonapi.callRestService(vm.url, "/userPreferences/"+vm.userPreferences.token+"/", vm.userPreferences, true, vm.user.authentication, "PUT", true, false).then(function(res){
                        Notification.success({
                            message: 'Default Dashboards Restored Successfully!',
                            delay: 3000,
                            positionX:"right",
                            positionY:"bottom"
                        });
                        var answer=
                        {
                            action:vm.action,
                            token:null
                        }
                        $mdDialog.hide(answer);
                    });
                });
            }
        }
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        function closeDialog()
        {
            $mdDialog.cancel();
        }
		*/
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.car', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.car', {
                url    : '/cars/car/:carID',
                params: {
                    carID: null
                },
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/car/car.html',
                        controller : 'CarController as vm'
                    }

					/*
                    'main@'                       : {
                        templateUrl: 'app/core/layouts/content-with-toolbar.html',
                        controller : 'MainController as vm'
                    },
                    'toolbar@app.car'                       : {
                        templateUrl: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                        controller : 'ToolbarController as vm'
                    },
                    'content@app.car': {
                        templateUrl: 'app/main/car/car.html',
                        controller : 'CarController as vm'
                        
                    }
					*/


                },
                //resolve: {
                //    CarsData: function (msApi)
                //    {
                //        return msApi.resolve('cars@get');
                //    }
                //}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/car');

        // Api
        //msApiProvider.register('car', ['app/data/cars/data.json']);

        // Navigation
        //msNavigationServiceProvider.saveItem('fuse', {
        //    title : 'SAMPLE',
        //    group : true,
        //    weight: 1
        //});

        // msNavigationServiceProvider.saveItem('cars', {
        //     title    : 'Cars',
        //     icon     : 'icon-car',
        //     state    : 'app.cars',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     translate: 'CARS.CARS_NAV',
        //     weight   : 1
        // });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.car')
        .controller('ControlPlanController', ControlPlanController);

    function ControlPlanController($mdDialog, event, carID, car, charger, action, dates, Notification, meisterapi, MEISTER){
        var vm = this;
        
		vm.carID = carID;
		vm.car = car;
		vm.charger = angular.copy(charger);
		vm.action = action;
		vm.dates = dates;
		
		vm.soc = { initial: vm.car.soc, final: vm.car.soc + 1 };
		
		var duration = moment.duration(moment(vm.dates.endDate).diff(moment(vm.dates.startDate)));
		vm.mins = duration.asMinutes();
		
		vm.calcFinalSoc = calcFinalSoc;
		
		function calcFinalSoc() {
			// [((10/6)*(endD-startD)*Power) + Cap * SoCinit ] / Cap
			var finalSoc = ( ((10/6) * (vm.mins) * vm.charger.maxpower) + (vm.car.batteryCapacity * vm.soc.initial) ) / vm.car.batteryCapacity;
			return ((finalSoc > 100) ? 100 : Math.floor(finalSoc));
		}
		
		vm.save = save;
        vm.closeDialog = closeDialog;
		
		function save() {
			if(vm.action === "SELECT") {
				if(vm.soc.initial === 0 || vm.soc.final === 0) {
					Notification.warning({
						message: 'Please Fill in all the required fields!',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
				}
				else if (vm.soc.initial > vm.soc.final) {
					Notification.warning({
						message: 'Final Soc value must be higher than the initial!',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
				}
				else {
					
					var params = {
						"charger_id": vm.charger.id,
						"connector_id": vm.charger.connectorid,
						"start_date": vm.dates.startDate,
						"end_date": vm.dates.endDate,
						"soc_initial": vm.soc.initial,
						"soc_final": vm.soc.final
					}
					
					meisterapi.addChargePlan(params, vm.carID).then(function (result) {
						Notification.success({
							message: 'Plan Setup is Successful',
							delay: 3000,
							positionX:"right",
							positionY:"bottom"
						});
						var answer = {
							action:vm.action,
							charger: vm.charger,
							status: 'success'
						}
						$mdDialog.hide(answer);
					});
				}
			}
			else if(vm.action === "DELETE") {
				meisterapi.deleteChargePlan(vm.carID).then(function (result) {
					Notification.success({
						message: 'Plan Deleted Successful',
						delay: 3000,
						positionX:"right",
						positionY:"bottom"
					});
					var answer = {
						action: vm.action,
						charger: vm.charger,
						status: 'success'
					}
					$mdDialog.hide(answer);
				});
				
			}
		}
		
		function closeDialog() {
			$mdDialog.cancel();
		}
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.auth_login', {
            url      : '/auth/login',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            data: {
                requireLogin: false
            },
            bodyClass: 'login'
        });
		
		// Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/login');

    }

})();
(function () {
    'use strict';

    angular
        .module('app.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($scope, $rootScope, $translate, $cookies, $window, session, Notification, meisterapi, MEISTER) {
        session.destroy();
        
        var vm = this;
		
        vm.form = {
            username: "",
            password: ""
        };
		
        var lang = $cookies.get("lang");
        if (lang != undefined) {
            $translate.use(lang);
        }
        
        vm.handleLogin = handleLogin;
		vm.openForgotPassDialog = openForgotPassDialog;
        
        function handleLogin() {
            vm.authentication = vm.form.username + ":" + vm.form.password;
            meisterapi.callRestService(MEISTER.api, "/users/authentication", "", true, vm.authentication, "GET").then(function(res) {
				if(res.data.active === true) {
					vm.user = {
						 id:        res.data.id,
						 username:     vm.form.username,
						 password:     vm.form.password,
						 firstname:    res.data.firstName,
						 lastname:     res.data.lastName,
						 email:        res.data.email,
						 active:       res.data.active,
						 creationDate: res.data.creationDate,
						 role:         res.data.roles,
						 country_code: res.data.country_code,
						 party_id:     res.data.party_id
					}
					
					session.setUser(vm.user);
					
					if (res.data.roles === 'ROLE_EV_FLEET_MANAGER'){
						$window.location.href = MEISTER.url + '/cars';
					}
					else if (res.data.roles === 'ROLE_CPO'){
						$window.location.href = MEISTER.url + '/monitoring';
					}
					else if (res.data.roles === 'ROLE_ADMIN') {
						$window.location.href = MEISTER.url + '/platform-users';
					}
					else {
						// DSO ROLE AND UNAUTHORIZED?
					}
					
				}
				else {
					showNotification($translate.instant("LOGIN.USER_AUTHENTICATION"), $translate.instant("LOGIN.INACTIVE"), "Error");
				}
            }, function(reason) {
                showNotification($translate.instant("LOGIN.USER_AUTHENTICATION"), $translate.instant("LOGIN.INVALID"), "Error");
            });
        }
		
		function openForgotPassDialog(ev) { }
		
        function showNotification(title, message, type) {
            if (type === "Error") {
                Notification.error({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Info") {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Warning") {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Success") {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }   
        }
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
				'base64',
				'md.data.table',
				'daterangepicker',
				'angularjs-datetime-picker',
				'angular-notification-icons',
                'ngMap',
				'ui-notification',
				'angularUtils.directives.dirPagination',
				'chart.js'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
	'use strict';
	
	angular
		.module('app.tokens')
		.controller('TokensController', TokensController);
		
	/** @ngInject */
	function TokensController($scope, $rootScope, $filter, $state, $mdDialog, $document, Notification, meisterapi, MEISTER) {
		var vm = this;
		
		vm.tmpResults = [];
		vm.tokensTable = {};
		
		vm.ownerTypes = [
			{name: 'Own', value: 0,},
			{name: 'Foreign', value: 1}
		];
		
		vm.tokenTypes = [
			{name: 'A', value: 0},
			{name: 'B', value: 1},
			{name: 'C', value: 2},
			{name: 'Ref', value: 3}
		];
		
		vm.selectedOwnerType = -1;
		vm.selectedTokenType = -1;
		vm.selectedOwnerID = '';
		vm.selectedClientID = '';
		
		vm.showToken = function(token, ev) {
			$mdDialog.show(
				$mdDialog.alert()
				.parent(angular.element(document.querySelector('#tokens')))
				.clickOutsideToClose(true)
				.title('Token')
				.textContent(token)
				.ariaLabel('Token')
				.ok('Got it!')
				.targetEvent(ev)
			);
		};
		
		vm.controlToken = controlToken;
		
		function controlToken(ev, token, action) {
			var action = action;
			var tmpToken = {};
			
			if (action === 'ADD_OWN' && token === null) {
				tmpToken = {
					country_code: "",
					party: ""
				};
			}
			else if (action === 'ADD_FOREIGN' && token === null) {
				
				tmpToken = {
					token: "",
					url: "",
					country_code: "",
					party: ""
				};
			}
			else {
				tmpToken = token;
			}
			
			$mdDialog.show({
				controller         : 'ControlTokenController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/tokens/dialogs/controlToken/controlToken.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				resolve: {
					CountriesDataISO2: function (msApi) {
						return msApi.resolve('countriesiso2@get');
					}
				},
				locals             : {
					event: ev,
					token: tmpToken,
					action: action
				}
			}).then(function(answer) {	
				if (answer.action === 'ADD_OWN' || answer.action === 'ADD_FOREIGN'){
					getMeasurements();
				}
				else if (answer.action === 'DELETE'){
					getMeasurements();
				}
				else {
					// Do nothing :P
				}
				
				
			});
		}
		
		vm.spinnerHidden = true;
		vm.registerToken = registerToken;
		function registerToken(receiverID) {
			vm.spinnerHidden = false;
			meisterapi.registerToken(receiverID).then(function (result) {
				showNotification("Register Token",result.status_message,"Info");
				getMeasurements();
				vm.spinnerHidden = true;
            });
			
		}
		
		
		function getIndexByToken(token, array){
			for (var i=0; i < array.length; i++) {
				if (array[i].token === token) {
					return i;
				}
			}
		}
		
		
		$scope.$watch(function() {
            return vm.selectedOwnerType;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue){
                vm.selectedOwnerType = newValue;
                init();
            }
        });
		
		$scope.$watch(function() {
            return vm.selectedTokenType;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue){
                vm.selectedTokenType = newValue;
                init();
            }
        });
		
		$scope.$watch(function() {
            return vm.selectedOwnerID;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue){
				if(newValue.length === 5) {
					vm.selectedOwnerID = newValue.toUpperCase();
					init();
				}
				else if (newValue.length === 0){
					vm.selectedOwnerID = '';
					init();
				}
            }
        });
		
		$scope.$watch(function() {
            return vm.selectedClientID;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue){
				if(newValue.length === 5) {
					vm.selectedClientID = newValue.toUpperCase();
					init();
				}
				else if (newValue.length === 0){
					vm.selectedClientID = '';
					init();
				}
            }
        });
		
		init();
		
		function init(){
			vm.tmpResults = [];
			
			vm.tokensTable.limitOptions = [5, 10, 15, {
				label: 'All',
				value: function () {
					return vm.tmpResults.length ? vm.tmpResults.length : 0;
				}
			}];
			vm.tokensTable.options = {
				rowSelection: false,
				multiSelect: false,
				autoSelect: false,
				decapitate: false,
				largeEditDialog: false,
				boundaryLinks: false,
				limitSelect: true,
				pageSelect: true
			};
			vm.tokensTable.query = {
				order: 'credentials_token_client_ID',
				limit: 10,
				page: 1
			};
			vm.tokensTable.filter = {
				search: ''
			};
			
			getMeasurements();
		}
		
		function getMeasurements() {
			meisterapi.getCredentialsByParams(vm.selectedOwnerType,vm.selectedTokenType,vm.selectedOwnerID,vm.selectedClientID).then(function (result) {
				vm.tmpResults = result;
            });
		}
		
		vm.copyTokenToClipboard = copyTokenToClipboard;
		function copyTokenToClipboard(text) {
			window.prompt("Copy to clipboard: Ctrl+C, Enter", text);
		}
		
		function showNotification(title,message,type) {
            if(type==="Error") {
                Notification.error({
                    title:title,
                    message: message,
                    delay: null,
                    startTop: 20,
                    startRight: 10,
                    verticalSpacing: 20,
                    horizontalSpacing: 20,
                    positionX: 'right',
                    positionY: 'bottom',
                });
            }
            else if(type==="Info") {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: null,
                    startTop: 20,
                    startRight: 10,
                    verticalSpacing: 20,
                    horizontalSpacing: 20,
                    positionX: 'right',
                    positionY: 'bottom',
                });
            }
            else if(type==="Warning") {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: null,
                    startTop: 20,
                    startRight: 10,
                    verticalSpacing: 20,
                    horizontalSpacing: 20,
                    positionX: 'right',
                    positionY: 'bottom',
                });
            }
            else if(type==="Success") {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: null,
                    startTop: 20,
                    startRight: 10,
                    verticalSpacing: 20,
                    horizontalSpacing: 20,
                    positionX: 'right',
                    positionY: 'bottom',
                });
            }
        }
		
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.users', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.users', {
                url    : '/users',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/users/users.html',
                        controller : 'UsersController as vm'
                    }
                },
                resolve: {
					CountriesDataISO2: function (msApi) {
						return msApi.resolve('countriesiso2@get');
					}
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/users');

        // Api
        //msApiProvider.register('requests', ['app/data/requests/data.json']);
		msApiProvider.register('countriesiso2', ['app/data/countriesiso2/data.json']);

        // Navigation
        //msNavigationServiceProvider.saveItem('fuse', {
        //    title : 'SAMPLE',
        //    group : true,
        //    weight: 1
        //});

        msNavigationServiceProvider.saveItem('users', {
            title    : 'Customers',
            icon     : 'icon-account-multiple',
            state    : 'app.users',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'USERS.USERS_NAV',
            weight   : 1
        });
    }
})();
(function () {
	'use strict';
	
	angular
		.module('app.users')
		.controller('UsersController', UsersController);
		
	/** @ngInject */
	function UsersController($scope, $rootScope, $filter, $state, CountriesDataISO2, meisterapi, MEISTER) {
		var vm = this;
		
		vm.internalResults = [];
		vm.externalResults = [];
		vm.internalUsersTable = {};
		vm.externalUsersTable = {};
		
		vm.countryListAlpha2 = CountriesDataISO2.data;
		vm.countryListAlpha2.unshift({name:'All',iso2:''});
		
		vm.dates = {startDate: moment().startOf('month'), endDate: moment().endOf('day')};
		
        function translateDateRange() {
            var ranges = {}
            ranges[$filter('translate')("DATERANGE.LAST_7_DAYS")] = [moment().subtract(6, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.LAST_30_DAYS")] = [moment().subtract(29, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.THIS_MONTH")] = [moment().startOf('month'), moment()]
            ranges[$filter('translate')("DATERANGE.LAST_MONTH")] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
            ranges[$filter('translate')("DATERANGE.THIS_YEAR")] = [moment().startOf('year'), moment()];
            
            vm.dateOptions = {
                applyClass: 'md-button md-raised',
                alwaysShowCalendars: true,
                locale: {
                    applyLabel: $filter('translate')("DATERANGE.APPLY"),
                    fromLabel: $filter('translate')("DATERANGE.FROM"),
                    format: "ll",
                    toLabel: $filter('translate')("DATERANGE.TO"),
                    cancelLabel: $filter('translate')("DATERANGE.CANCEL"),
                    customRangeLabel: $filter('translate')("DATERANGE.CUSTOM_RANGE"),
                    daysOfWeek: [
                        $filter('translate')("DATERANGE.SU"),
                        $filter('translate')("DATERANGE.MO"),
                        $filter('translate')("DATERANGE.TU"),
                        $filter('translate')("DATERANGE.WE"),
                        $filter('translate')("DATERANGE.TH"),
                        $filter('translate')("DATERANGE.FR"),
                        $filter('translate')("DATERANGE.SA")
                    ],
                    monthNames: [
                        $filter('translate')("DATERANGE.JANUARY"),
                        $filter('translate')("DATERANGE.FEBRUARY"),
                        $filter('translate')("DATERANGE.MARCH"),
                        $filter('translate')("DATERANGE.APRIL"),
                        $filter('translate')("DATERANGE.MAY"),
                        $filter('translate')("DATERANGE.JUNE"),
                        $filter('translate')("DATERANGE.JULY"),
                        $filter('translate')("DATERANGE.AUGUST"),
                        $filter('translate')("DATERANGE.SEPTEMBER"),
                        $filter('translate')("DATERANGE.OCTOBER"),
                        $filter('translate')("DATERANGE.NOVEMBER"),
                        $filter('translate')("DATERANGE.DECEMBER")
                    ],
                },
                ranges: ranges,
                eventHandlers: {
                    'apply.daterangepicker': vizualizeData
                }
            }
        }
        translateDateRange();
        
        $rootScope.$on('$translateChangeSuccess', function () {
            translateDateRange();
        });
        
        // Make months clickable
        angular.element('body').on('click', '.daterangepicker .month', function() {
			var drp = angular.element('#daterange').data('daterangepicker');
            var momentDate = moment('1 ' + angular.element(this).text(), "D MMM YYYY", 'en');
            drp.setStartDate(momentDate.startOf('month'));
            drp.setEndDate(momentDate.endOf('month'));
            drp.clickApply();
        })
		
		vm.vizualizeData = vizualizeData;
		
		function vizualizeData() {
			init();
		}
		
		init();
		
		function init(){
			vm.tmpResults = [];
			
			vm.internalUsersTable.limitOptions = [5, 10, 15, {
				label: 'All',
				value: function () {
					return vm.tmpResults.length ? vm.tmpResults.length : 0;
				}
			}];
			vm.internalUsersTable.options = {
				rowSelection: false,
				multiSelect: false,
				autoSelect: false,
				decapitate: false,
				largeEditDialog: false,
				boundaryLinks: false,
				limitSelect: true,
				pageSelect: true
			};
			vm.internalUsersTable.query = {
				order: '-last_updated',
				limit: 10,
				page: 1
			};
			vm.internalUsersTable.filter = {
				search: ''
			};
			
			vm.externalUsersTable.limitOptions = [5, 10, 15, {
				label: 'All',
				value: function () {
					return vm.tmpResults.length ? vm.tmpResults.length : 0;
				}
			}];
			vm.externalUsersTable.options = {
				rowSelection: false,
				multiSelect: false,
				autoSelect: false,
				decapitate: false,
				largeEditDialog: false,
				boundaryLinks: false,
				limitSelect: true,
				pageSelect: true
			};
			vm.externalUsersTable.query = {
				order: '-last_updated',
				limit: 10,
				page: 1
			};
			vm.externalUsersTable.filter = {
				search: ''
			};
			
			
			
			getMeasurements();
		}
		
		function getMeasurements() {
			meisterapi.getAllInternalUsersByParams(moment(vm.dates.startDate).utc().format('YYYY-MM-DDTHH:mm:ss.000[Z]'), moment(vm.dates.endDate).utc().format('YYYY-MM-DDTHH:mm:ss.000[Z]')).then(function (result) {
				vm.internalResults = result;
            });
			
			meisterapi.getAllExternalUsersByParams(moment(vm.dates.startDate).utc().format('YYYY-MM-DDTHH:mm:ss.000[Z]'), moment(vm.dates.endDate).utc().format('YYYY-MM-DDTHH:mm:ss.000[Z]')).then(function (result) {
				vm.externalResults = result;
            });
			
		}
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.settings', {
                url    : '/settings',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/settings.html',
                        controller : 'SettingsController as vm'
                    }
                },
                //resolve: {
                //    SettingsData: function (msApi)
                //    {
                //        return msApi.resolve('settings@get');
                //    }
                //}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/settings');

        // Api
        //msApiProvider.register('settings', ['app/data/settings/data.json']);

        // Navigation
        //msNavigationServiceProvider.saveItem('fuse', {
        //    title : 'SAMPLE',
        //    group : true,
        //    weight: 1
        //});

        msNavigationServiceProvider.saveItem('settings', {
            title    : 'Settings',
            icon     : 'icon-cog',
            state    : 'app.settings',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'SETTINGS.SETTINGS_NAV',
            weight   : 1
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('SettingsController', SettingsController);

    /** @ngInject */
    function SettingsController()
{
        var vm = this;
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sessions', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.sessions', {
                url    : '/sessions',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/sessions/sessions.html',
                        controller : 'SessionsController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sessions');

        msNavigationServiceProvider.saveItem('sessions', {
            title    : 'Sessions',
            icon     : 'icon-sitemap',
            state    : 'app.sessions',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'SESSIONS.SESSIONS_NAV',
            weight   : 1
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.sessions')
        .controller('SessionsController', SessionsController);

    /** @ngInject */
    function SessionsController($scope, $rootScope, $state, $filter, session, meisterapi, MEISTER){
        var vm = this;
		
		vm.results = [];
		vm.tmpResults = [];
		vm.sessionsTable = {};
		
		vm.allStatuses = [
			{title: 'All',      value: 'ALL'},
			{title: 'Active', value: 'ACTIVE'},
			{title: 'Completed', value: 'COMPLETED'},
			{title: 'Invalid', value: 'INVALID'},
			{title: 'Pending',  value: 'PENDING'},
			{title: 'Reservation', value: 'RESERVATION'}
		];
		
		vm.selectedStatus = 'ACTIVE';
		
		vm.dates = {startDate: moment().startOf('day'), endDate: moment().endOf('day')};
		
        function translateDateRange() {
            var ranges = {}
            ranges[$filter('translate')("DATERANGE.LAST_7_DAYS")] = [moment().subtract(6, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.LAST_30_DAYS")] = [moment().subtract(29, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.THIS_MONTH")] = [moment().startOf('month'), moment()]
            ranges[$filter('translate')("DATERANGE.LAST_MONTH")] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
            ranges[$filter('translate')("DATERANGE.THIS_YEAR")] = [moment().startOf('year'), moment()];
            
            vm.dateOptions = {
                applyClass: 'md-button md-raised',
                alwaysShowCalendars: true,
                locale: {
                    applyLabel: $filter('translate')("DATERANGE.APPLY"),
                    fromLabel: $filter('translate')("DATERANGE.FROM"),
                    format: "ll",
                    toLabel: $filter('translate')("DATERANGE.TO"),
                    cancelLabel: $filter('translate')("DATERANGE.CANCEL"),
                    customRangeLabel: $filter('translate')("DATERANGE.CUSTOM_RANGE"),
                    daysOfWeek: [
                        $filter('translate')("DATERANGE.SU"),
                        $filter('translate')("DATERANGE.MO"),
                        $filter('translate')("DATERANGE.TU"),
                        $filter('translate')("DATERANGE.WE"),
                        $filter('translate')("DATERANGE.TH"),
                        $filter('translate')("DATERANGE.FR"),
                        $filter('translate')("DATERANGE.SA")
                    ],
                    monthNames: [
                        $filter('translate')("DATERANGE.JANUARY"),
                        $filter('translate')("DATERANGE.FEBRUARY"),
                        $filter('translate')("DATERANGE.MARCH"),
                        $filter('translate')("DATERANGE.APRIL"),
                        $filter('translate')("DATERANGE.MAY"),
                        $filter('translate')("DATERANGE.JUNE"),
                        $filter('translate')("DATERANGE.JULY"),
                        $filter('translate')("DATERANGE.AUGUST"),
                        $filter('translate')("DATERANGE.SEPTEMBER"),
                        $filter('translate')("DATERANGE.OCTOBER"),
                        $filter('translate')("DATERANGE.NOVEMBER"),
                        $filter('translate')("DATERANGE.DECEMBER")
                    ],
                },
                ranges: ranges,
                eventHandlers: {
                    'apply.daterangepicker': vizualizeData
                }
            }
        }
        translateDateRange();
        
        $rootScope.$on('$translateChangeSuccess', function () {
            translateDateRange();
        });
        
        // Make months clickable
        angular.element('body').on('click', '.daterangepicker .month', function() {
            //var lang = $cookies.get('lang');
            //if (lang != undefined) {
                var drp = angular.element('#daterange').data('daterangepicker');
                var momentDate = moment('1 ' + angular.element(this).text(), "D MMM YYYY", lang);
                drp.setStartDate(momentDate.startOf('month'));
                drp.setEndDate(momentDate.endOf('month'));
                drp.clickApply();
            //}
        })
		
		vm.vizualizeData = vizualizeData;
		
		function vizualizeData() {
			init();
		}
		
		$scope.$watch(function() {
            return vm.selectedStatus;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue){
                vm.selectedStatus = newValue;
                init();
            }
        });
		
		init();
		
		function init() {
			vm.tmpResults = [];
			
			vm.sessionsTable.limitOptions = [5, 10, 15, {
				label: 'All',
				value: function () {
					return vm.tmpResults.length ? vm.tmpResults.length : 0;
				}
			}];
			vm.sessionsTable.options = {
				rowSelection: false,
				multiSelect: false,
				autoSelect: false,
				decapitate: false,
				largeEditDialog: false,
				boundaryLinks: false,
				limitSelect: true,
				pageSelect: true
			};
			vm.sessionsTable.query = {
				order: '-last_updated',
				limit: 10,
				page: 1
			};
			vm.sessionsTable.filter = {
				search: ''
			};
			
			
			getAllSessionsByDateByStatus();
		}
		
		function getAllSessionsByDateByStatus() {
			meisterapi.getAllSessionsByDateByStatus(vm.selectedStatus, moment(vm.dates.startDate).utc().format('YYYY-MM-DDTHH:mm:ss.000[Z]'), moment(vm.dates.endDate).utc().format('YYYY-MM-DDTHH:mm:ss.000[Z]')).then(function (results) {
				vm.tmpResults = results;
			});
		}
		
		vm.goToSession = goToSession;
		function goToSession(sessionID) {
			$state.go('app.session', {'sessionID': sessionID})
		}
		
		
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.session', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.session', {
                url    : '/sessions/session/:sessionID',
				params: {
					sessionID: null
				},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/session/session.html',
                        controller : 'SessionController as vm'
                    }
                },
                //resolve: {
                //    RequestsData: function (msApi)
                //    {
                //        return msApi.resolve('requests@get');
                //    }
                //}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/session');

        // Api
        //msApiProvider.register('requests', ['app/data/requests/data.json']);

        // Navigation
        //msNavigationServiceProvider.saveItem('fuse', {
        //    title : 'SAMPLE',
        //    group : true,
        //    weight: 1
        //});

        /*msNavigationServiceProvider.saveItem('request', {
            title    : 'Request',
            icon     : 'icon-bell',
            state    : 'app.request',
            translate: 'REQUEST.REQUEST_NAV',
            weight   : 1
        });
		*/
    }
})();
(function () {
	'use strict';
	
	angular
		.module('app.session')
		.controller('SessionController', SessionController);
		
	/** @ngInject */
	function SessionController($scope, $state, $stateParams, meisterapi, MEISTER) {
		var vm = this;
		
		vm.sessionID = $stateParams.sessionID;
		vm.session = {};
		vm.chargingProfile = {};
		vm.chargingPeriodsTable = {};
		
        vm.colors = [
            "3,169,244",
            "146,39,143",
            "170,198,6",
            "242,135,6",
            "191, 0, 255",
            "0,191,118",
            "102,45,145",
            "236,0,140",
            "0,148,68",
            "249,237,50",
            "239,65,54",
        ];
		
		init();
		
		function init(){
			vm.chargingPeriodsTable.limitOptions = [5, 10, 15, {
				label: 'All',
				value: function () {
					return vm.session.charging_periods.length ? vm.session.charging_periods.length : 0;
				}
			}];
			vm.chargingPeriodsTable.options = {
				rowSelection: false,
				multiSelect: false,
				autoSelect: false,
				decapitate: false,
				largeEditDialog: false,
				boundaryLinks: false,
				limitSelect: true,
				pageSelect: true
			};
			vm.chargingPeriodsTable.query = {
				order: '-timestamp',
				limit: 10,
				page: 1
			};
			vm.chargingPeriodsTable.filter = {
				search: ''
			};
			
			vm.chart = {
				labels: [],
				series: [],
				data: [],
				colors: [],
				options: {
					title: {
						display: true,
						text: 'Charging Profile Period'
					},
					legend: {
                    labels: {
                            fontColor: "rgba(0,0,0,0.6)"
                        },
                        display: true,
                        position: "bottom"
                    },
                    elements: {
						line: {
							tension: 0.000001
						}
					},
                    responsive: true,
                    maintainAspectRatio: false,
					scales: {
						yAxes: [{
							scaleLabel: { 
                                display: false,
                                labelString: 'Limit',
                            }
							
						}],
						xAxes: [{
							scaleLabel: { 
                                display: false,
                                labelString: 'Start Period',
                            }
						}]
					},
					tooltips: {
						mode: 'point',
						callbacks: {
                            label: function(tooltipItem, data) {
                                var unit = vm.chargingProfile.charging_rate_unit;
                                //return parseFloat(tooltipItem.yLabel).toFixed(2) + " " + unit;
								return parseFloat(tooltipItem.yLabel) + " " + unit;
                            }
                        }
					}
				}
			}
			
			getSessionByID(vm.sessionID);
			getChargingProfileBySessionId(vm.sessionID)
			
		}
		
		function getSessionByID(sessionID) {
			meisterapi.getSessionByID(sessionID).then(function (result) {
				vm.session = result;
            });
		}
		
		vm.showChargingProfile = false;
		function getChargingProfileBySessionId(sessionID) {
			meisterapi.getChargingProfileBySession(sessionID).then(function (result) {
				console.log(result);
				vm.chargingProfile = result;
				if (result.charging_profile_period && result.charging_profile_period.length > 0) {
					vm.chart.series.push('Limit');
					vm.chart.data.push([]);
                    vm.chart.colors.push({
                        type:'line',
                        showLine: true,
                        steppedLine: false,
                        lineTension : 0,
                        pointHoverRadius:6,
                        pointRadius:3,
                        borderColor: "rgba(" + vm.colors[0] + ",1)",
                        backgroundColor: "rgba(" + vm.colors[0] + ",0)",
                        pointBorderColor: "rgba(" + vm.colors[0] + ",1)",
                        pointBackgroundColor: "rgba(" + vm.colors[0] + ",1)",
                        pointHoverBorderColor: "rgba(" + vm.colors[0] + ",1)",
                        pointHoverBackgroundColor: "rgba(" + vm.colors[0] + ",1)"
                    });
					for(var i = 0; i < result.charging_profile_period.length; i++) {
						var foo = result.charging_profile_period[i];
						vm.chart.data[0].push(foo.limit);
						vm.chart.labels.push(foo.start_period + 's');
					}
					vm.showChargingProfile = true;
				}
				
            });
			
		}
		
		vm.goBack = goBack;
		
		function goBack() {
			$state.go('app.sessions')
		}
		
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.requests', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.requests', {
                url    : '/requests',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/requests/requests.html',
                        controller : 'RequestsController as vm'
                    }
                },
                //resolve: {
                //    RequestsData: function (msApi)
                //    {
                //        return msApi.resolve('requests@get');
                //    }
                //}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/requests');

        // Api
        //msApiProvider.register('requests', ['app/data/requests/data.json']);

        // Navigation
        //msNavigationServiceProvider.saveItem('fuse', {
        //    title : 'SAMPLE',
        //    group : true,
        //    weight: 1
        //});

        msNavigationServiceProvider.saveItem('requests', {
            title    : 'Requests',
            icon     : 'icon-bell',
            state    : 'app.requests',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'REQUESTS.REQUESTS_NAV',
            weight   : 1
        });
    }
})();
(function () {
	'use strict';
	
	angular
		.module('app.requests')
		.controller('RequestsController', RequestsController);
		
	/** @ngInject */
	function RequestsController($scope, $rootScope, $filter, $state, meisterapi, MEISTER) {
		var vm = this;
		
		vm.tmpResults = [];
		vm.requestsTable = {};
		vm.allStatuses = [
			{title: 'All',      value: 'ALL'},
			{title: 'Pending',  value: 'PENDING'},
			{title: 'Accepted', value: 'ACCEPTED'},
			{title: 'Rejected', value: 'REJECTED'}
		];
		vm.selectedStatus = 'ALL';
		
		vm.dates = {startDate: moment().startOf('month'), endDate: moment().endOf('day')};
		
        function translateDateRange() {
            var ranges = {}
            ranges[$filter('translate')("DATERANGE.LAST_7_DAYS")] = [moment().subtract(6, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.LAST_30_DAYS")] = [moment().subtract(29, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.THIS_MONTH")] = [moment().startOf('month'), moment()]
            ranges[$filter('translate')("DATERANGE.LAST_MONTH")] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
            ranges[$filter('translate')("DATERANGE.THIS_YEAR")] = [moment().startOf('year'), moment()];
            
            vm.dateOptions = {
                applyClass: 'md-button md-raised',
                alwaysShowCalendars: true,
                locale: {
                    applyLabel: $filter('translate')("DATERANGE.APPLY"),
                    fromLabel: $filter('translate')("DATERANGE.FROM"),
                    format: "ll",
                    toLabel: $filter('translate')("DATERANGE.TO"),
                    cancelLabel: $filter('translate')("DATERANGE.CANCEL"),
                    customRangeLabel: $filter('translate')("DATERANGE.CUSTOM_RANGE"),
                    daysOfWeek: [
                        $filter('translate')("DATERANGE.SU"),
                        $filter('translate')("DATERANGE.MO"),
                        $filter('translate')("DATERANGE.TU"),
                        $filter('translate')("DATERANGE.WE"),
                        $filter('translate')("DATERANGE.TH"),
                        $filter('translate')("DATERANGE.FR"),
                        $filter('translate')("DATERANGE.SA")
                    ],
                    monthNames: [
                        $filter('translate')("DATERANGE.JANUARY"),
                        $filter('translate')("DATERANGE.FEBRUARY"),
                        $filter('translate')("DATERANGE.MARCH"),
                        $filter('translate')("DATERANGE.APRIL"),
                        $filter('translate')("DATERANGE.MAY"),
                        $filter('translate')("DATERANGE.JUNE"),
                        $filter('translate')("DATERANGE.JULY"),
                        $filter('translate')("DATERANGE.AUGUST"),
                        $filter('translate')("DATERANGE.SEPTEMBER"),
                        $filter('translate')("DATERANGE.OCTOBER"),
                        $filter('translate')("DATERANGE.NOVEMBER"),
                        $filter('translate')("DATERANGE.DECEMBER")
                    ],
                },
                ranges: ranges,
                eventHandlers: {
                    'apply.daterangepicker': vizualizeData
                }
            }
        }
        translateDateRange();
        
        $rootScope.$on('$translateChangeSuccess', function () {
            translateDateRange();
        });
        
        // Make months clickable
        angular.element('body').on('click', '.daterangepicker .month', function() {
            var drp = angular.element('#daterange').data('daterangepicker');
            var momentDate = moment('1 ' + angular.element(this).text(), "D MMM YYYY", lang);
            drp.setStartDate(momentDate.startOf('month'));
            drp.setEndDate(momentDate.endOf('month'));
            drp.clickApply();
        })
		
		vm.vizualizeData = vizualizeData;
		
		function vizualizeData() {
			init();
		}
		
		$scope.$watch(function() {
            return vm.selectedStatus;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue){
                vm.selectedStatus = newValue;
                init();
            }
        });
		
		$scope.$on('new.cpo.request.broadcast', function(event, args) {
			init();
		});
		
		init();
		
		function init(){
			vm.tmpResults = [];
			
			vm.requestsTable.limitOptions = [5, 10, 15, {
				label: 'All',
				value: function () {
					return vm.tmpResults.length ? vm.tmpResults.length : 0;
				}
			}];
			vm.requestsTable.options = {
				rowSelection: false,
				multiSelect: false,
				autoSelect: false,
				decapitate: false,
				largeEditDialog: false,
				boundaryLinks: false,
				limitSelect: true,
				pageSelect: true
			};
			vm.requestsTable.query = {
				order: '-timestamp',
				limit: 10,
				page: 1
			};
			vm.requestsTable.filter = {
				search: ''
			};
			
			getMeasurements();
		}
		
		function getMeasurements() {
			
			meisterapi.getAllDSORequestsByDateByStatus(vm.selectedStatus, moment(vm.dates.startDate).utc().format('YYYY-MM-DDTHH:mm:ss.000[Z]'), moment(vm.dates.endDate).utc().format('YYYY-MM-DDTHH:mm:ss.000[Z]')).then(function (result) {
				vm.tmpResults = result;
            });
		}
		
		vm.goToRequest = goToRequest;
		
		function goToRequest(requestID) {
			$state.go('app.request', {'requestID': requestID})
		}
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.request', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.request', {
                url    : '/requests/request/:requestID',
				params: {
					requestID: null
				},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/request/request.html',
                        controller : 'RequestController as vm'
                    }
                },
                //resolve: {
                //    RequestsData: function (msApi)
                //    {
                //        return msApi.resolve('requests@get');
                //    }
                //}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/request');

        // Api
        //msApiProvider.register('requests', ['app/data/requests/data.json']);

        // Navigation
        //msNavigationServiceProvider.saveItem('fuse', {
        //    title : 'SAMPLE',
        //    group : true,
        //    weight: 1
        //});

        /*msNavigationServiceProvider.saveItem('request', {
            title    : 'Request',
            icon     : 'icon-bell',
            state    : 'app.request',
            translate: 'REQUEST.REQUEST_NAV',
            weight   : 1
        });
		*/
    }
})();
(function () {
	'use strict';
	
	angular
		.module('app.request')
		.controller('RequestController', RequestController);
		
	/** @ngInject */
	function RequestController($scope, $state, $stateParams, meisterapi, MEISTER) {
		var vm = this;
		
		vm.requestID = $stateParams.requestID;
		vm.request = {};
		
		vm.exchange = {};
		vm.socTable = {};
		vm.historicalTable = {};
		vm.exchangeTable = {};
		
		vm.chartData = [];
		vm.unit = 'kW';
		
		init();
		
		function init(){
			vm.exchangeTable.limitOptions = [5, 10, 15, {
				label: 'All',
				value: function () {
					return vm.exchange.data.length ? vm.exchange.data.length : 0;
				}
			}];
			vm.exchangeTable.options = {
				rowSelection: false,
				multiSelect: false,
				autoSelect: false,
				decapitate: false,
				largeEditDialog: false,
				boundaryLinks: false,
				limitSelect: true,
				pageSelect: true
			};
			vm.exchangeTable.query = {
				order: '-timestamp',
				limit: 10,
				page: 1
			};
			vm.exchangeTable.filter = {
				search: ''
			};
			
			vm.historicalTable.limitOptions = [5, 10, 15, {
				label: 'All',
				value: function () {
					return vm.historicalResult.data.length ? vm.historicalResult.data.length : 0;
				}
			}];
			vm.historicalTable.options = {
				rowSelection: false,
				multiSelect: false,
				autoSelect: false,
				decapitate: false,
				largeEditDialog: false,
				boundaryLinks: false,
				limitSelect: true,
				pageSelect: true
			};
			vm.historicalTable.query = {
				order: '-timestamp',
				limit: 10,
				page: 1
			};
			vm.historicalTable.filter = {
				search: ''
			};
			
			vm.socTable.limitOptions = [5, 10, 15, {
				label: 'All',
				value: function () {
					return vm.exchange.deviations.length ? vm.exchange.deviations.length : 0;
				}
			}];
			vm.socTable.options = {
				rowSelection: false,
				multiSelect: false,
				autoSelect: false,
				decapitate: false,
				largeEditDialog: false,
				boundaryLinks: false,
				limitSelect: true,
				pageSelect: true
			};
			vm.socTable.query = {
				order: '-id',
				limit: 10,
				page: 1
			};
			vm.socTable.filter = {
				search: ''
			};
			
			vm.chart = {
				labels: [],
				series: [],
				data: [],
				colors: [],
				options: {
					title: {
						display: false,
						text: 'Custom Chart Title'
					},
					legend: {
                        labels: {
                            fontColor: "rgba(0,0,0,0.6)"
                        },
                        display: true,
                        position: "bottom"
                    },
                    elements: {
						line: {
							tension: 0.000001
						}
					},
					scales: {
						yAxes: [{
							stacked: true
							
						}],
						xAxes: [{
							stacked: true
						}]
					},
					tooltips: {
						mode: 'point'
					}
				}
			}
			
			getMeasurements();
		}
		
		vm.historicalResult = [];
		
		function getMeasurements() {
			meisterapi.getHistoricalResult(vm.requestID).then(function (result) {
				vm.historicalResult = result;
				//Sort Result Data by date
				if (result.data && result.data.length > 0) {
					result.data.sort(function(a,b) {return (a.timestamp > b.timestamp) ? 1 : ((b.timestamp > a.timestamp) ? -1 : 0);} );
					
					var tmpBar = [];
					var tmpLabels = [];
					for(var i = 0; i < result.data.length; i++) {
						var row = result.data[i];
						var allSeriesIndex = getIndexByValue(row.location+"/"+row.charger+"/"+row.connector, vm.chart.series);
						if (allSeriesIndex === null){
							vm.chart.data.push([]);
							var randomColor = randomRGB();
							var tmpColor = {
								borderWidth: 0,
								lineTension : 0,
								borderColor: "rgba("+randomColor+",0.8)",
								backgroundColor: "rgba("+randomColor+",0.6)",
								pointBorderColor: "rgba("+randomColor+",0.8)",
								pointBackgroundColor: "rgba("+randomColor+",0.8)",
								pointHoverBorderColor: "rgba("+randomColor+",0.8)",
								pointHoverBackgroundColor: "rgba("+randomColor+",0.8)"
							};
							vm.chart.colors.push(tmpColor);
							vm.chart.series.push(row.location+"/"+row.charger+"/"+row.connector);
						}
						
						
						var timestampIndex = getIndexByValue(row.timestamp, tmpLabels);
						if (timestampIndex === null){
							tmpLabels.push(row.timestamp);
						}
						
						var locchrgconIndex = getIndexByLocchrgcon(row.location+"/"+row.charger+"/"+row.connector, tmpBar);
						if (locchrgconIndex != null){
							var tIndex = getIndexByTimestamp(row.timestamp, tmpBar.entries);
							if (tIndex != null){
								tmpBar[locchrgconIndex].entries[tIndex].power += row.power;
							}
							else {
								tmpBar[locchrgconIndex].entries.push({power: row.power,timestamp:row.timestamp});
							}
						}
						else {
							tmpBar.push({locchrgcon: row.location+"/"+row.charger+"/"+row.connector, entries: [{power: row.power, timestamp: row.timestamp}]})
						}
					}
					if (tmpLabels && tmpLabels.length > 0) {
						tmpLabels.sort(function(a,b) {return (a > b) ? 1 : ((b > a) ? -1 : 0);} );
					}
					for(var m = 0; m < tmpLabels.length; m++) {
						var tmpLabel = tmpLabels[m];
						vm.chart.labels.push(moment(tmpLabel).format("HH:mm"));
						for(var i = 0; i < tmpBar.length; i++) {
							var tmpRow = tmpBar[i];
							var tidx = getIndexByTimestamp(tmpLabel, tmpRow.entries);
							if (tidx === null){
								tmpRow.entries.push({power: null, timestamp: tmpLabel});
							}
							tmpRow.entries.sort(function(a,b) {return (a.timestamp > b.timestamp) ? 1 : ((b.timestamp > a.timestamp) ? -1 : 0);} );
						}
					}
					
					for(var i = 0; i < tmpBar.length; i++) {
						var tmpRow = tmpBar[i];
						for(var j = 0; j < tmpRow.entries.length; j++) {
							var entry = tmpRow.entries[j];
							var seriesIndex = getIndexByValue(tmpRow.locchrgcon, vm.chart.series)
							vm.chart.data[seriesIndex].push(entry.power);
						}
					}
				}
            });
			
			meisterapi.getDSORequestById(vm.requestID).then(function (result) {
				vm.request = result;
            });
		}
		
		function randomRGB() {
			var o = Math.round, r = Math.random, s = 255;
			return o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s);
		}
		
		function getIndexByLocchrgcon(locchrgcon, array){
			for (var i=0; i < array.length; i++) {
				if (array[i].locchrgcon === locchrgcon) {
					return i;
				}
			}
			return null;
		}
		
		function getIndexByTimestamp(timestamp, array){
			for (var i=0; i < array.length; i++) {
				if (array[i].timestamp === timestamp) {
					return i;
				}
			}
			return null;
		}
		
		function getIndexByValue(value, array){
			for (var i=0; i < array.length; i++) {
				if (array[i] === value) {
					return i;
				}
			}
			return null;
		}
		
		vm.cpoResponse = cpoResponse;
		
		function cpoResponse(response, requestID) {
			meisterapi.sendCPOResponse(response, requestID).then(function (result) {
				if (result.status == 'OK'){
					$state.go('app.requests');
				}
				else { }
			});
		}
		
		vm.calculate = calculate;
		vm.allowCalculate = true;
		
		function calculate(requestID) {
			vm.allowCalculate = false;
			
			vm.chartX = {
				labels: [],
				series: [],
				data: [],
				colors: [],
				options: {
					title: {
						display: false,
						text: 'Custom Chart Title'
					},
					legend: {
                        labels: {
                                fontColor: "rgba(0,0,0,0.6)"
                            },
                            display: true,
                            position: "bottom"
                        },
                        elements: {
							line: {
								tension: 0.000001
							}
						},
                        //responsive: true,
                        //maintainAspectRatio: false,
					scales: {
						yAxes: [{
							stacked: true
							
						}],
						xAxes: [{
							stacked: true
						}]
					},
					tooltips: {
						mode: 'point',
						/*callbacks: {
                            label: function(tooltipItem, data) {
                                var unit = vm.unit;
                                return parseFloat(tooltipItem.yLabel).toFixed(2) + " " + unit;
                            }
                        }*/
					}
				}
			}
			
			meisterapi.calculate(requestID).then(function (result) {
				if (result.data && result.data.length === 0){
					vm.exchange['message'] = 'No feasible Solution';
					vm.exchange = result;
				}
				else {
					vm.exchange = result;
				}
				
				//Sort Result Data by date
				result.data.sort(function(a,b) {return (a.timestamp > b.timestamp) ? 1 : ((b.timestamp > a.timestamp) ? -1 : 0);} );
				
				var tmpBar = [];
				var tmpLabels = [];
				for(var i = 0; i < result.data.length; i++) {
					var row = result.data[i];
					var allSeriesIndex = getIndexByValue(row.location+"/"+row.charger+"/"+row.connector, vm.chartX.series);
					if (allSeriesIndex === null){
						vm.chartX.data.push([]);
						var randomColor = randomRGB();
						var tmpColor = {
							borderWidth: 0,
							lineTension : 0,
							borderColor: "rgba("+randomColor+",0.8)",
							backgroundColor: "rgba("+randomColor+",0.6)",
							pointBorderColor: "rgba("+randomColor+",0.8)",
							pointBackgroundColor: "rgba("+randomColor+",0.8)",
							pointHoverBorderColor: "rgba("+randomColor+",0.8)",
							pointHoverBackgroundColor: "rgba("+randomColor+",0.8)"
						};
						vm.chartX.colors.push(tmpColor);
						vm.chartX.series.push(row.location+"/"+row.charger+"/"+row.connector);
					}
					
					
					var timestampIndex = getIndexByValue(row.timestamp, tmpLabels);
					if (timestampIndex === null){
						tmpLabels.push(row.timestamp);
					}
					
					var locchrgconIndex = getIndexByLocchrgcon(row.location+"/"+row.charger+"/"+row.connector, tmpBar);
					if (locchrgconIndex != null){
						var tIndex = getIndexByTimestamp(row.timestamp, tmpBar.entries);
						if (tIndex != null){
							tmpBar[locchrgconIndex].entries[tIndex].power += row.power;
						}
						else {
							tmpBar[locchrgconIndex].entries.push({power: row.power,timestamp:row.timestamp});
						}
					}
					else {
						tmpBar.push({locchrgcon: row.location+"/"+row.charger+"/"+row.connector, entries: [{power: row.power, timestamp: row.timestamp}]})
					}
				}
				
				tmpLabels.sort(function(a,b) {return (a > b) ? 1 : ((b > a) ? -1 : 0);} );
				
				for(var m = 0; m < tmpLabels.length; m++) {
					var tmpLabel = tmpLabels[m];
					vm.chartX.labels.push(moment(tmpLabel).format("HH:mm"));
					for(var i = 0; i < tmpBar.length; i++) {
						var tmpRow = tmpBar[i];
						var tidx = getIndexByTimestamp(tmpLabel, tmpRow.entries);
						if (tidx === null){
							tmpRow.entries.push({power: null, timestamp: tmpLabel});
						}
						tmpRow.entries.sort(function(a,b) {return (a.timestamp > b.timestamp) ? 1 : ((b.timestamp > a.timestamp) ? -1 : 0);} );
					}
				}
				
				for(var i = 0; i < tmpBar.length; i++) {
					var tmpRow = tmpBar[i];
					for(var j = 0; j < tmpRow.entries.length; j++) {
						var entry = tmpRow.entries[j];
						var seriesIndex = getIndexByValue(tmpRow.locchrgcon, vm.chartX.series)
						vm.chartX.data[seriesIndex].push(entry.power);
					}
				}
				
				vm.allowCalculate = true;
            });
		}
		
		vm.goBack = goBack;
		
		function goBack() {
			$state.go('app.requests')
		}
		
	}
})();

(function () {
    'use strict';

    angular
        .module('app.platform-users')
        .controller('PlatformUsersController', PlatformUsersController);

    /** @ngInject */
    function PlatformUsersController($scope, $rootScope, $state, $filter, $mdDialog, $document, session, meisterapi, MEISTER){
        var vm = this;
		vm.user = session.getUser();
		vm.tmpResults = [];
		vm.platformUsersTable = {};
		
		vm.allRoles = [
			{title: 'ALL', value: 'ALL'},
			{title: 'CPO', value: 'ROLE_CPO'},
			{title: 'DSO', value: 'ROLE_DSO'},
			{title: 'EV Fleet Manager', value: 'ROLE_EV_FLEET_MANAGER'},
			{title: 'Administrator', value: 'ROLE_ADMIN'}
		];
		
		vm.selectedRole = 'ALL';
		
		$scope.$watch(function() {
            return vm.selectedRole;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue){
                vm.selectedRole = newValue;
                init();
            }
        });
		
		init();
		
		function init() {
			vm.tmpResults = [];
			
			vm.platformUsersTable.limitOptions = [5, 10, 15, {
				label: 'All',
				value: function () {
					return vm.tmpResults.length ? vm.tmpResults.length : 0;
				}
			}];
			
			vm.platformUsersTable.options = {
				rowSelection: false,
				multiSelect: false,
				autoSelect: false,
				decapitate: false,
				largeEditDialog: false,
				boundaryLinks: false,
				limitSelect: true,
				pageSelect: true
			};
			vm.platformUsersTable.query = {
				order: '-creationDate',
				limit: 10,
				page: 1
			};
			vm.platformUsersTable.filter = {
				search: ''
			};
			
			getAllPlatformUsersByRole();
		}
		
		function getAllPlatformUsersByRole() {
			meisterapi.getAllPlatformUsersByRole(vm.selectedRole).then(function (results) {
				vm.tmpResults = results;
			});
		}
		
		vm.controlPlatformUser = controlPlatformUser
		function controlPlatformUser(ev, user, action) {
			
			var action = action;
			var tmpPlatformUser = {};
			
			if (action === 'ADD' && user === null) {
				tmpPlatformUser = {
					firstName: "",
					lastName: "",
					username: "",
					password: "",
					email: "",
					country_code: "",
					party_id: "",
					roles: "",
					active: false
				}
			}
			else if (action === 'EDIT') {
				tmpPlatformUser = {
					id: user.id,
					firstName: user.firstName,
					lastName: user.lastName,
					username: user.username,
					password: user.password,
					email: user.email,
					country_code: user.country_code,
					party_id: user.party_id,
					roles: user.roles,
					active: user.active,
					creationDate: user.creationDate
				}
			}
			else {
				tmpPlatformUser = user;
			}
			
			$mdDialog.show({
				controller         : 'ControlPlatformUserController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/platform-users/dialogs/controlPlatformUser/controlPlatformUser.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				resolve: {
					CountriesDataISO2: function (msApi) {
						return msApi.resolve('countriesiso2@get');
					}
				},
				locals             : {
					event: ev,
					user: tmpPlatformUser,
					action: action
				}
			}).then(function(answer) {
				if (answer.action === 'ADD'){
					vm.tmpResults = [];
					getAllPlatformUsersByRole();
				}
				else if (answer.action === 'EDIT'){
					vm.tmpResults = [];
					getAllPlatformUsersByRole();
				}
				else if (answer.action === 'DELETE'){
					vm.tmpResults = [];
					getAllPlatformUsersByRole();
				}
				
			});
			
		}
		
    }
})();

(function (){
    'use strict';

    angular
        .module('app.parking', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider){
        // State
        $stateProvider
            .state('app.parking', {
                url    : '/monitoring/parking/:parkingid',
                params: {
                    parkingid: null
                },
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/parking/parking.html',
                        controller : 'ParkingController as vm'
                    }
					
					/*

                    'main@'                       : {
                        templateUrl: 'app/core/layouts/content-with-toolbar.html',
                        controller : 'MainController as vm'
                    },
                    'toolbar@app.parking'                       : {
                        templateUrl: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                        controller : 'ToolbarController as vm'
                    },
                    'content@app.parking': {
                        templateUrl: 'app/main/parking/parking.html',
                        controller : 'ParkingController as vm'
                        
                    }
					*/


                },
                resolve: {
                    CarsData: function (msApi){
                        return msApi.resolve('cars@get');
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/parking');

        // Api
        msApiProvider.register('car', ['app/data/cars/data.json']);

        // Navigation
        //msNavigationServiceProvider.saveItem('fuse', {
        //    title : 'SAMPLE',
        //    group : true,
        //    weight: 1
        //});

        // msNavigationServiceProvider.saveItem('cars', {
        //     title    : 'Cars',
        //     icon     : 'icon-car',
        //     state    : 'app.cars',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     translate: 'CARS.CARS_NAV',
        //     weight   : 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.parking')
        .controller('ParkingController', ParkingController);

    /** @ngInject */
    function ParkingController($scope, $state, $stateParams, $mdDialog, $document, meisterapi, MEISTER) {
        var vm = this;
		
		vm.parking = [];
		vm.chargersTable = {};
		vm.chargersNo = 0;
		vm.itemsPerPage = 8;
		
		vm.capabilities = {
			"CHARGING_PROFILE_CAPABLE": {
				"value": "CHARGING_PROFILE_CAPABLE",
				"name": "CHARGING PROFILE",
				"icon": "icon-battery-charging-100"
			},
			"CHARGING_PREFERENCES_CAPABLE": {
				"value": "CHARGING_PREFERENCES_CAPABLE",
				"name": "CHARGING PREFERENCES",
				"icon": "icon-battery"
			},
			"CHIP_CARD_SUPPORT": {
				"value": "CHIP_CARD_SUPPORT",
				"name": "CHIP CARD SUPPORT",
				"icon": "icon-credit-card"
			},
			"CONTACTLESS_CARD_SUPPORT": {
				"value": "CONTACTLESS_CARD_SUPPORT",
				"name": "CONTACTLESS CARD SUPPORT",
				"icon": "icon-credit-card"
			},
			"CREDIT_CARD_PAYABLE": {
				"value": "CREDIT_CARD_PAYABLE",
				"name": "CREDIT CARD PAYABLE",
				"icon": "icon-credit-card"
			},
			"DEBIT_CARD_PAYABLE": {
				"value": "DEBIT_CARD_PAYABLE",
				"name": "DEBIT CARD PAYABLE",
				"icon": "icon-credit-card"
			},
			"PED_TERMINAL": {
				"value": "PED_TERMINAL",
				"name": "PED TERMINAL",
				"icon": "icon-credit-card"
			},
			"REMOTE_START_STOP_CAPABLE": {
				"value": "REMOTE_START_STOP_CAPABLE",
				"name": "REMOTE START STOP",
				"icon": "icon-remote"
			},
			"RESERVABLE": {
				"value": "RESERVABLE",
				"name": "RESERVABLE",
				"icon": "meister-icon-service-time"
			},
			"RFID_READER": {
				"value": "RFID_READER",
				"name": "RFID READER",
				"icon": "meister-icon-online"
			},
			"TOKEN_GROUP_CAPABLE": {
				"value": "TOKEN_GROUP_CAPABLE",
				"name": "TOKEN GROUP",
				"icon": "icon-key"
			},
			"UNLOCK_CAPABLE": {
				"value": "UNLOCK_CAPABLE",
				"name": "UNLOCK",
				"icon": "icon-lock-unlocked"
			}
		};
		
		vm.locationTypes = {
			'ON_STREET': {
				"value": "ON_STREET",
				"name": "ON STREET",
				"icon": ""
			},
			'PARKING_GARAGE': {
				"value": "PARKING_GARAGE",
				"name": "PARKING GARAGE",
				"icon": ""
			},
			'UNDERGROUND_GARAGE': {
				"value": "UNDERGROUND_GARAGE",
				"name": "UNDERGROUND GARAGE",
				"icon": ""
			},
			'PARKING_LOT': {
				"value": "PARKING_LOT",
				"name": "PARKING LOT",
				"icon": ""
			},
			'OTHER': {
				"value": "OTHER",
				"name": "OTHER",
				"icon": ""
			},
			'UNKNOWN': {
				"value": "UNKNOWN",
				"name": "UNKNOWN",
				"icon": ""
			}
		};
		vm.facilities = {
			'AIRPORT': {
				"value": "AIRPORT",
				"name": "AIRPORT",
				"icon": "icon-"
			},
			'BIKE_SHARING': {
				"value": "BIKE_SHARING",
				"name": "BIKE SHARING",
				"icon": "icon-"
			},
			'BUS_STOP': {
				"value": "BUS_STOP",
				"name": "BUS STOP",
				"icon": "icon-"
			},
			'CAFE': {
				"value": "CAFE",
				"name": "CAFE",
				"icon": "icon-"
			},
			'CARPOOL_PARKING': {
				"value": "CARPOOL_PARKING",
				"name": "CARPOOL PARKING",
				"icon": "icon-"
			},
			'PARKING_LOT': {
				"value": "PARKING_LOT",
				"name": "PARKING LOT",
				"icon": "icon-"
			},
			'FUEL_STATION': {
				"value": "FUEL_STATION",
				"name": "FUEL STATION",
				"icon": "icon-"
			},
			'HOTEL': {
				"value": "HOTEL",
				"name": "HOTEL",
				"icon": "icon-"
			},
			'METRO_STATION': {
				"value": "METRO_STATION",
				"name": "METRO STATION",
				"icon": "icon-"
			},
			'MALL': {
				"value": "MALL",
				"name": "MALL",
				"icon": "icon-"
			},
			'MUSEUM': {
				"value": "MUSEUM",
				"name": "MUSEUM",
				"icon": "icon-"
			},
			'NATURE': {
				"value": "NATURE",
				"name": "NATURE",
				"icon": "icon-"
			},
			'RECREATION_AREA': {
				"value": "RECREATION_AREA",
				"name": "RECREATION AREA",
				"icon": "icon-"
			},
			'RESTAURANT': {
				"value": "RESTAURANT",
				"name": "RESTAURANT",
				"icon": "icon-"
			},
			'SUPERMARKET': {
				"value": "SUPERMARKET",
				"name": "SUPERMARKET",
				"icon": "icon-"
			},
			'TAXI_STAND': {
				"value": "TAXI_STAND",
				"name": "TAXI STAND",
				"icon": "icon-"
			},
			'TRAIN_STATION': {
				"value": "TRAIN_STATION",
				"name": "TRAIN STATION",
				"icon": "icon-"
			},
			'TRAM_STOP': {
				"value": "TRAM_STOP",
				"name": "TRAM STOP",
				"icon": "icon-"
			},
			'WIFI': {
				"value": "WIFI",
				"name": "WIFI",
				"icon": "icon-"
			}
		};
		
		vm.controlCharger = controlCharger;
        vm.gotomonitoring = gotomonitoring
		vm.goToCharger = goToCharger;
		
		$scope.$on('new.cpo.monitoring.broadcast', function(event, args) {
			if (args.type === 'Update_Parking') {
				if (args.metadata.requestId === $stateParams.parkingid){
					vm.parking.evses[getIndexByUID(args.metadata.value.uid, vm.parking.evses)] = args.metadata.value;
				}
			}
		});
		
		init();
		
		function init() {
			getParking($stateParams.parkingid);
		}
		
        function getParking(parkingid) {
            meisterapi.getParkingByID(parkingid).then(function (result) {
                vm.parking = result;
				
				for (var j=0; j < vm.parking.evses.length; j++) {
					if (vm.parking.evses[j].status != 'REMOVED'){
						vm.chargersNo++;
					}
				}
				
            });
        }
		
		function controlCharger(ev, parkingID, charger, action) {
			var action = action;
			var tmpCharger = {};
			
			if (action === 'ADD' && charger === null) {
				
				tmpCharger = {
					status: "",
					capabilities: [],
					floor_level: "",
					connectors: [
						{
							id: "1",
							locked: "",
							standard: "",
							format: "",
							power_type: "",
							max_voltage: 0,
							voltage: 0,
							max_amperage: 0,
							amperage: 0,
							max_electric_power: 0,
							tarrif_ids: null
						}
					]
				}
			}
			else if (action === 'EDIT') {
				
				tmpCharger = {
					uid: charger.uid,
					evse_id: charger.evse_id,
					status: charger.status,
					capabilities: charger.capabilities,
					floor_level: charger.floor_level,
					physical_reference: charger.physical_reference,
					connectors: charger.connectors,
					statusSchedule: charger.statusSchedule,
					last_updated: charger.last_updated
				}
			}
			else {
				tmpCharger = charger;
			}
			
			$mdDialog.show({
				controller         : 'ControlChargerController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/parking/dialogs/controlCharger/controlCharger.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					parkingID: parkingID,
					charger: tmpCharger,
					action: action
				}
			}).then(function(answer) {	
				if (answer.action === 'ADD'){
					vm.chargersNo = 0;
					vm.parking = [];
					getParking($stateParams.parkingid);
				}
				else if (answer.action === 'EDIT'){
					vm.chargersNo = 0;
					vm.parking = [];
					getParking($stateParams.parkingid);
				}
				else if (answer.action === 'DELETE'){
					vm.chargersNo = 0;
					vm.parking = [];
					getParking($stateParams.parkingid);
				}
				else {
					// Do nothing :P
				}
				
			});
		}
		
		function getIndexByID(id, array){
			for (var i=0; i < array.length; i++) {
				if (array[i].id === id) {
					return i;
				}
			}
		}
		
		function getIndexByUID(uid, array){
			for (var i=0; i < array.length; i++) {
				if (array[i].uid === uid) {
					return i;
				}
			}
		}
		
        function gotomonitoring() {
            $state.go("app.monitoring");
        }
		
		function goToCharger(chargerid) {
			$state.go('app.charger',{
				chargerid: chargerid,
				parkingid: $stateParams.parkingid
			});
		};
		
		
    }
})();

(function (){
    'use strict';

    angular
        .module('app.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider){
        $stateProvider
			.state('app.profile', {
				url      : '/profile',
				views    : {
					'content@app': {
						templateUrl: 'app/main/profile/profile.html',
						controller : 'ProfileController as vm'
					}
				},
				bodyClass: 'profile'
			});
		
		// Translation
        $translatePartialLoaderProvider.addPart('app/main/profile');
    }

})();
(function (){
    'use strict';

    angular
        .module('app.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController($scope, $rootScope, $translate, $window, $cookieStore, session, Notification, meisterapi, MEISTER){
		var vm = this;
		
		vm.user = session.getUser();
		
		vm.selectedIndex = 0;
		$scope.$watch('vm.selectedIndex', function(current, old) {
			vm.selectedIndex = current;
		});
		
		vm.roles = {
			"ROLE_CPO": "CPO",
			"ROLE_EV_FLEET_MANAGER": "Ev Fleet Manager",
			"ROLE_ADMIN": "Administrator"
		};
		
		init();
		
		function init() {
			vm.tempUser = angular.copy(vm.user);
		}
		
		vm.saveUserInfoForm = saveUserInfoForm;
		function saveUserInfoForm(event, tmpUser) {
			
			var payload = {
				id: tmpUser.id,
				active: tmpUser.active,
				creationDate: tmpUser.creationDate,
				email: tmpUser.email,
				firstName: tmpUser.firstname,
				lastName: tmpUser.lastname,
				password: tmpUser.password,
				roles: tmpUser.role,
				username: tmpUser.username
			}
			
			 meisterapi.updateUserProfile(tmpUser.id, payload).then(function (result) {
                if (result.message === 'User updated'){
					$cookieStore.put('usr',tmpUser);
					$window.location.href = MEISTER.url + '/profile';
				}
				else {
					showNotification($translate.instant("PROFILE.USER_SERVICE"), "Opps, something whent wrong! User Profile Not Updated!", "Error");
				}
				
            });
			
		}
		
        function showNotification(title, message, type) {
            if (type === "Error") {
                Notification.error({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Info") {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Warning") {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Success") {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }   
        }
    }

})();

(function (){
	'use strict';
	
	angular
		.module('app.monitoring')
		.controller('MonitoringController', MonitoringController);
	
	/** @ngInject */
	function MonitoringController($scope, $state, $mdDialog, $document, $q, NgMap, session, meisterapi, MEISTER) {
		var vm = this;
		
		vm.user = session.getUser();
		
		vm.itemsPerPage = 5;
		vm.map = null;
		vm.results = [];
		
		vm.goToParking = goToParking;
		vm.controlParking = controlParking;
		
		vm.openMenu = function($mdOpenMenu, ev) {
			$mdOpenMenu(ev);
		};
		
		NgMap.getMap().then(function(map) {
			vm.map = map;
		});
		
		vm.showDetail = function(e, item) {
			vm.item = item;
			vm.map.showInfoWindow('foo-iw', item.id);
		};
		
		vm.hideDetail = function() {
			vm.map.hideInfoWindow('foo-iw');
		};
		
		init();
		
		function init() {	
			vm.chart = {
				labels: ["Occupied", "Reserved", "Available"],
				chartcolors: ["#002b7f","#7193bc","#a9d52f"],
				options: {},
				data: []
			}
			getMeasurements();
		}
		
		function getMeasurements() {
			meisterapi.getAllParkings().then(function (results) {
				vm.results = results;
				getChargerStatuses();
			});
		}
		
		
		function getChargerStatuses() {
			var promises = [];
			
			for (var i=0; i < vm.results.length; i++) {
				promises.push(meisterapi.chargerStatus(vm.results[i].id))
			}
			
			$q.all(promises).then(function (resArray) {
				
				for (var i=0; i < resArray.length; i++) {
					vm.results[i]['chargerStatus'] = resArray[i];
					
					vm.results[i].chart = {
						labels: ["Occupied", "Reserved", "Available", "Out Of Order"],
						colors: ["#002b7f","#7193bc","#a9d52f",'#ff6347'],
						options: {},
						data: [resArray[i]['charging'],resArray[i]['reserved'],resArray[i]['available'],resArray[i]['out_of_order']]
					}
				}
			});
		}
		
		function goToParking(parkingid) {
			$state.go('app.parking',{
				parkingid: parkingid
			});
		};
		
		function controlParking(ev, parking, action) {
			var action = action;
			var tmpParking = {};
			
			if (action === 'ADD' && parking === null) {
				tmpParking = {
					country_code: vm.user.country_code,
					party_id: vm.user.party_id,
					type: "",
					name: "",
					address: "",
					city: "",
					postal_code: "",
					state: "",
					country: "",
					coordinates: {
						latitude: null,
						longitude: null
					},
					evses: [],
					operator: {
						name: vm.user.firstname + ' ' + vm.user.lastname,
						website: null
					},
					suboperator: null,
					owner: null,
					facilities: "",
					time_zone: "",
					opening_times: {
						twentyfourseven: false,
						regular_hours: null,
						exceptional_openings: null,
						exceptional_closings: null
					},
					charging_when_closed: false
				}
			}
			else if (action === 'EDIT') {
				tmpParking = {
					id: parking.id,
					country_code: parking.country_code,
					party_id: parking.party_id,
					type: parking.type,
					name: parking.name,
					address: parking.address,
					city: parking.city,
					postal_code: parking.postal_code,
					state: parking.state,
					country: parking.country,
					coordinates: {
						latitude: parseFloat(parking.coordinates.latitude),
						longitude: parseFloat(parking.coordinates.longitude)
					},
					evses: parking.evses,
					operator: parking.operator,
					suboperator: parking.suboperator,
					owner: parking.owner,
					facilities: parking.facilities,
					time_zone: parking.time_zone,
					opening_times: parking.opening_times,
					charging_when_closed: parking.charging_when_closed
				}
			}
			else {
				tmpParking = parking;
			}
			
			$mdDialog.show({
				controller         : 'ControlParkingController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/monitoring/dialogs/controlParking/controlParking.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				resolve: {
					CountriesDataISO2: function (msApi) {
						return msApi.resolve('countriesiso2@get');
					},
					CountriesDataISO3: function (msApi) {
						return msApi.resolve('countriesiso3@get');
					}
				},
				locals             : {
					event: ev,
					parking: tmpParking,
					action: action
				}
			}).then(function(answer) {	
				
				if (answer.action === 'ADD'){
					vm.results = [];
					getMeasurements();
				}
				else if (answer.action === 'EDIT'){
					vm.results = [];
					getMeasurements();
				}
				else if (answer.action === 'DELETE'){
					vm.results.splice(getIndexByID(answer.parking.id, vm.results), 1);
				}
				else {
					// Do nothing :P
				}
			});
		}
		
		function getIndexByID(id, array){
			for (var i=0; i < array.length; i++) {
				if (array[i].id === id) {
					return i;
				}
			}
		}
		
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.cars', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.cars', {
                url    : '/cars',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cars/cars.html',
                        controller : 'CarsController as vm'
                    }
                },
                resolve: {
                    CarsData: function (msApi)
                    {
                        return msApi.resolve('cars@get');
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/cars');

        // Api
        msApiProvider.register('cars', ['app/data/cars/data.json']);

        // Navigation
        //msNavigationServiceProvider.saveItem('fuse', {
        //    title : 'SAMPLE',
        //    group : true,
        //    weight: 1
        //});

        msNavigationServiceProvider.saveItem('cars', {
            title    : 'Cars',
            icon     : 'icon-car',
            state    : 'app.cars',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'CARS.CARS_NAV',
            weight   : 1
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.cars')
        .controller('CarsController', CarsController);

    /** @ngInject */
    function CarsController($scope, $state, $location, session, meisterapi, MEISTER) {
        var vm = this;
        
		vm.user = session.getUser();
		
		vm.tmpResults = [];
		vm.carsTable = {};
		
		vm.goToCar = goToCar;
		
		init();
		
		function init() {
			vm.tmpResults = [];
			
			vm.carsTable.limitOptions = [5, 10, 15, {
				label: 'All',
				value: function () {
					return vm.tmpResults.length ? vm.tmpResults.length : 0;
				}
			}];
			vm.carsTable.options = {
				rowSelection: false,
				multiSelect: false,
				autoSelect: false,
				decapitate: false,
				largeEditDialog: false,
				boundaryLinks: false,
				limitSelect: true,
				pageSelect: true
			};
			vm.carsTable.query = {
				order: 'soc',
				limit: 10,
				page: 1
			};
			vm.carsTable.filter = {
				search: ''
			};
			
			getMeasurements();
		}
		
		function getMeasurements() {
			
			var authentication = vm.user.username + ":" + vm.user.password;
			
			if(authentication === 'virtual:virtual') {
				meisterapi.getCars().then(function(response){
					vm.tmpResults = response;
				});
			}
			else {
				meisterapi.getMOQOCars().then(function(response){
					vm.tmpResults = response;
				});
			}
			
		}
		
        function goToCar(carID){
			$state.go('app.car', {'carID': carID})
        }
    }
})();

(function (){
    'use strict';

    angular
        .module('app.charger', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider){
        // State
        $stateProvider
            .state('app.charger', {
                url    : '/monitoring/parking/:parkingid/charger/:chargerid',
                params: {
                    chargerid: null,
					parkingid: null
                },
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/charger/charger.html',
                        controller : 'ChargerController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/charger');

        // Api
        //msApiProvider.register('car', ['app/data/cars/data.json']);

        // Navigation
        //msNavigationServiceProvider.saveItem('fuse', {
        //    title : 'SAMPLE',
        //    group : true,
        //    weight: 1
        //});

        // msNavigationServiceProvider.saveItem('cars', {
        //     title    : 'Cars',
        //     icon     : 'icon-car',
        //     state    : 'app.cars',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     translate: 'CARS.CARS_NAV',
        //     weight   : 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.charger')
        .controller('ChargerController', ChargerController);

    /** @ngInject */
    function ChargerController($scope, $state, $stateParams, $mdDialog, $document, meisterapi, MEISTER) {
        var vm = this;
		
		vm.charger = {};
		vm.chargerId = $stateParams.chargerid;
		vm.parkingId = $stateParams.parkingid;
		vm.parkingName = 'Location';
		vm.itemsPerPage = 8;
		
		vm.capabilities = {
			"CHARGING_PROFILE_CAPABLE": {
				"value": "CHARGING_PROFILE_CAPABLE",
				"name": "CHARGING PROFILE",
				"icon": "icon-battery-charging-100"
			},
			"CHARGING_PREFERENCES_CAPABLE": {
				"value": "CHARGING_PREFERENCES_CAPABLE",
				"name": "CHARGING PREFERENCES",
				"icon": "icon-battery"
			},
			"CHIP_CARD_SUPPORT": {
				"value": "CHIP_CARD_SUPPORT",
				"name": "CHIP CARD SUPPORT",
				"icon": "icon-credit-card"
			},
			"CONTACTLESS_CARD_SUPPORT": {
				"value": "CONTACTLESS_CARD_SUPPORT",
				"name": "CONTACTLESS CARD SUPPORT",
				"icon": "icon-credit-card"
			},
			"CREDIT_CARD_PAYABLE": {
				"value": "CREDIT_CARD_PAYABLE",
				"name": "CREDIT CARD PAYABLE",
				"icon": "icon-credit-card"
			},
			"DEBIT_CARD_PAYABLE": {
				"value": "DEBIT_CARD_PAYABLE",
				"name": "DEBIT CARD PAYABLE",
				"icon": "icon-credit-card"
			},
			"PED_TERMINAL": {
				"value": "PED_TERMINAL",
				"name": "PED TERMINAL",
				"icon": "icon-credit-card"
			},
			"REMOTE_START_STOP_CAPABLE": {
				"value": "REMOTE_START_STOP_CAPABLE",
				"name": "REMOTE START STOP",
				"icon": "icon-remote"
			},
			"RESERVABLE": {
				"value": "RESERVABLE",
				"name": "RESERVABLE",
				"icon": "meister-icon-service-time"
			},
			"RFID_READER": {
				"value": "RFID_READER",
				"name": "RFID READER",
				"icon": "meister-icon-online"
			},
			"TOKEN_GROUP_CAPABLE": {
				"value": "TOKEN_GROUP_CAPABLE",
				"name": "TOKEN GROUP",
				"icon": "icon-key"
			},
			"UNLOCK_CAPABLE": {
				"value": "UNLOCK_CAPABLE",
				"name": "UNLOCK",
				"icon": "icon-lock-unlocked"
			}
		};
		
        vm.gotomonitoring = gotomonitoring;
		vm.gotoparking = gotoparking;
		
		init();
		
		function init() {
			getCharger(vm.parkingId, vm.chargerId);
			getParkingName($stateParams.parkingid);
		}
		
        function getParkingName(parkingid) {
            meisterapi.getParkingByID(parkingid).then(function (result) {
                vm.parkingName = result.name;
            });
        }
		
        function getCharger(parkingId, chargerId) {
            meisterapi.getChargerById(parkingId, chargerId).then(function (result) {
                vm.charger = result;
            });
        }
		
		function getIndexByID(id, array){
			for (var i=0; i < array.length; i++) {
				if (array[i].id === id) {
					return i;
				}
			}
		}
		
		function getIndexByUID(uid, array){
			for (var i=0; i < array.length; i++) {
				if (array[i].uid === uid) {
					return i;
				}
			}
		}
		
        function gotomonitoring() {
            $state.go("app.monitoring");
        }
		
		function gotoparking() {
            $state.go("app.parking", { parkingid: $stateParams.parkingid });
        }
		
    }
})();

(function () {
    'use strict';

    angular
        .module('app.car')
        .controller('CarController', CarController);

    /** @ngInject */
    function CarController(MEISTER, meisterapi, session, $scope, $timeout, $http, $q, $stateParams, $filter, $mdDialog, $mdToast, $state, $document, NgMap) {
        var vm = this;
		
		
		vm.map = null;
		vm.user = session.getUser();
		vm.virtualUser = true;
		
		vm.carID = $stateParams.carID;
		vm.car = [];
		
		vm.bookings = [];
		vm.chargers = [];
		vm.bookingsTable = {};
		vm.chargersTable = {};
		
		vm.dates = {startDate: undefined, endDate: undefined};
		
        vm.checkChargerAvailability = checkChargerAvailability;
		vm.controlPlan = controlPlan;
		vm.goToCars = goToCars;
		
		NgMap.getMap().then(function(map) {
			vm.map = map;
		});
		
		init();
		
		function init() {
			vm.car = [];
			
			vm.bookings = [];
			vm.chargers = [];
			vm.bookingsTable = {};
			vm.chargersTable = {};
			
			vm.dates = {startDate: undefined, endDate: undefined};
			
			vm.bookingsTable.limitOptions = [5, 10, 15, {
				label: 'All',
				value: function () {
					return vm.bookings.length ? vm.bookings.length : 0;
				}
			}];
			
			vm.bookingsTable.options = {
				rowSelection: false,
				multiSelect: false,
				autoSelect: false,
				decapitate: false,
				largeEditDialog: false,
				boundaryLinks: false,
				limitSelect: true,
				pageSelect: true
			};
			
			vm.bookingsTable.query = {
				order: '-start_date',
				limit: 10,
				page: 1
			};
			
			vm.bookingsTable.filter = {
				search: ''
			};
			
			var authentication = vm.user.username + ":" + vm.user.password;
			
			if(authentication === 'moqo:moqo') {
				
				vm.virtualUser = false;
				
				meisterapi.getMOQOCarByID($stateParams.carID).then(function (result) {
					vm.car = result;
					vm.bookings = result.booking;
				});
			}
			else {
				meisterapi.getCarByID($stateParams.carID).then(function (result) {
					vm.car = result;
					vm.bookings = result.booking;
				});
			}
			
		}
		
		function checkChargerAvailability() {
			vm.chargers = [];
			
			vm.chargersTable.limitOptions = [5, 10, 15, {
				label: 'All',
				value: function () {
					return vm.chargers.length ? vm.chargers.length : 0;
				}
			}];
			
			vm.chargersTable.options = {
				rowSelection: false,
				multiSelect: false,
				autoSelect: false,
				decapitate: false,
				largeEditDialog: false,
				boundaryLinks: false,
				limitSelect: true,
				pageSelect: true
			};
			
			vm.chargersTable.query = {
				order: '-id',
				limit: 10,
				page: 1
			};
			
			vm.chargersTable.filter = {
				search: ''
			};
			
			meisterapi.getAvailableChargers(moment(vm.dates.startDate).utc().format('YYYY-MM-DDTHH:mm:00.000[Z]'), moment(vm.dates.endDate).utc().format('YYYY-MM-DDTHH:mm:00.000[Z]')).then(function (result) {
				for (var charger in result) {
					for (var connector in result[charger].connectors) {
						var tmpCharger = {
							id: result[charger].uid,
							location: result[charger].floor_level,
							connectorid: result[charger].connectors[connector].id,
							format: result[charger].connectors[connector].format,
							powertype: result[charger].connectors[connector].power_type,
							maxpower: result[charger].connectors[connector].max_electric_power
						};
						vm.chargers.push(tmpCharger);
					}
				}
			});
		}
		
		function controlPlan(ev, carID, car, charger, action) {
			var action = action;
			var tmpCharger = charger;
			
			$mdDialog.show({
				controller         : 'ControlPlanController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/car/dialogs/controlPlan/controlPlan.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					carID: carID,
					car: car,
					charger: tmpCharger,
					dates: {
						startDate: moment(vm.dates.startDate).utc().format('YYYY-MM-DDTHH:mm:00.000[Z]'),
						endDate: moment(vm.dates.endDate).utc().format('YYYY-MM-DDTHH:mm:00.000[Z]')
					},
					action: action
				}
			}).then(function(answer) {
				init();
			});
		}

        function goToCars(){
            $state.go("app.cars");
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-green',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('session', sessionService);

    /** @ngInject */
    function sessionService($log, $cookieStore)
    {

        var service = {
            start: start,
            getUser: getUser,
            setUser: setUser,
            destroy: destroy
        };
		
        return service;
        //////////
		
        function start() {
            this._user = $cookieStore.get('usr');
        }

        function getUser() {
            return this._user;
        };

        function setUser(user) {
            this._user = user;
            $cookieStore.put('usr', user);
            return this;
        };

        /**
         * Destroy session
         */
        function destroy() {
            this.setUser(null);
            $cookieStore.remove("usr");
        };
      }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('meisterapi', meisterApiService);

    /** @ngInject */
    function meisterApiService($q, $http, $base64, session, MEISTER) {
		
		var service = {
			getAllDSORequests: getAllDSORequests,
			getAllDSORequestsByDateByStatus: getAllDSORequestsByDateByStatus,
			getDSORequestById: getDSORequestById,
			
			getAllParkings: getAllParkings,
			getParkingByID: getParkingByID,
			newParking: newParking,
			updateParking: updateParking,
			deleteParking: deleteParking,
			
			chargerStatus: chargerStatus,
			getChargerById: getChargerById,
			newCharger: newCharger,
			editCharger: editCharger,
			deleteCharger: deleteCharger,
			
			getNotificationsByDate: getNotificationsByDate,
			changeNotificationStatus: changeNotificationStatus,
			sendCPOResponse: sendCPOResponse,
			
			getAllSessions: getAllSessions,
			getAllSessionsByDateByStatus: getAllSessionsByDateByStatus,
			getSessionByID: getSessionByID,
			getChargingProfileBySession: getChargingProfileBySession,
			
			getCars: getCars,
			getCarByID: getCarByID,
			
			getMOQOCars: getMOQOCars,
			getMOQOCarByID: getMOQOCarByID,
			
			getAvailableChargers: getAvailableChargers,
            addChargePlan: addChargePlan,
			deleteChargePlan: deleteChargePlan,
            
			getAllUsers: getAllUsers,
			getAllInternalUsersByParams: getAllInternalUsersByParams,
			getAllExternalUsersByParams: getAllExternalUsersByParams,
			
			getCredentials: getCredentials,
			getCredentialsByParams: getCredentialsByParams,
			
			createOwnToken: createOwnToken,
			addForeignToken: addForeignToken,
			registerToken: registerToken,
			
			deleteCredentials: deleteCredentials,
			
			calculate: calculate,
			
			updateUserProfile: updateUserProfile,
			
			getHistoricalResult: getHistoricalResult,
			
			getAllPlatformUsersByRole: getAllPlatformUsersByRole,
			
			addPlatformUser: addPlatformUser,
			editPlatformUser: editPlatformUser,
			deletePlatformUser: deletePlatformUser,
			
			callRestService: callRestService
        };
        return service;
		
		
		function getChargingProfileBySession (id) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                callRestService(MEISTER.api, "/sessions/" + id + "/charging_profile", "", true, authentication, "GET", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function getAllPlatformUsersByRole(role) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                callRestService(MEISTER.api, "/users", "", true, authentication, "GET", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function addPlatformUser(platformUser) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                callRestService(MEISTER.api, "/users/registration", platformUser, true, authentication, "POST", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function editPlatformUser(platformUserID, platformUser) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			return $q(function (resolve, reject) {
                callRestService(MEISTER.api, "/users/" + platformUserID, platformUser, true, authentication, "PUT", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function deletePlatformUser(platformUserID) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                callRestService(MEISTER.api, "/users/" + platformUserID, "", true, authentication, "DELETE", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function updateUserProfile(userID, payload) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                callRestService(MEISTER.api, "/users/update/" + userID, payload, true, authentication, "PUT", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function getHistoricalResult(requestId) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/requests/" + requestId + "/historical_result", "", true, authentication, "GET", true, false).then(function (res) {
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function registerToken(receiverID) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                callRestService(MEISTER.api, "/ocpi/cpo/credentials?receiverID=" + receiverID, "", true, authentication, "POST", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
			
		}
		
		
		function createOwnToken(token) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                callRestService(MEISTER.api, "/ocpi/cpo/credentials/generateCredentialsToken?tokenType=A&clientId=" + token.clientId + "&setResponseObjectData=true", "", true, authentication, "POST", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function addForeignToken(token) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                callRestService(MEISTER.api, "/ocpi/cpo/credentials/saveForeignCredentialsTokenA", token, true, authentication, "POST", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
			
		}
		
		function deleteCredentials(token) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/credentials/" + token, "", true, authentication, "DELETE", true, false).then(function (res) {
					if (res.data != undefined) {
						resolve(res.data);
					}
					else {
						resolve({});
					}
				});
			});
		}
		
		function getCredentialsByParams (credentials_token_owner_type,credentials_token_type,credentials_token_owner_ID,credentials_token_client_ID) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			var params = '';
			var tmpParams = '';
			
			if (credentials_token_owner_type != -1) {
				tmpParams +=  '&credentials_token_owner_type=' + credentials_token_owner_type;
			}
			if (credentials_token_type != -1) {
				tmpParams +=  '&credentials_token_type=' + credentials_token_type;
			}
			if (credentials_token_owner_ID != '') {
				tmpParams +=  '&credentials_token_owner_ID=' + credentials_token_owner_ID;
			}
			if (credentials_token_client_ID != '') {
				tmpParams +=  '&credentials_token_client_ID=' + credentials_token_client_ID;
			}
			if (tmpParams != ''){
				params = '?' + tmpParams.substring(1);
			}
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/credentials" + "/" + user.country_code + "/" + user.party_id + params, "", true, authentication, "GET", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function getCredentials() {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/credentials", "", true, authentication, "GET", true, false).then(function (res) {
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function getAllInternalUsersByParams (date_from, date_to) { //, country_code, party_id) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			var params = '';
			var tmpParams = '';
			
			if (date_from != '') {
				tmpParams +=  '&date_from=' + date_from;
			}
			if (date_to != '') {
				tmpParams +=  '&date_to=' + date_to;
			}
			if (tmpParams != ''){
				params = '?' + tmpParams.substring(1);
			}
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/tokens/" + user.country_code + "/" + user.party_id + params, "", true, authentication, "GET", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function getAllExternalUsersByParams (date_from, date_to) { //, country_code, party_id) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			var params = '';
			var tmpParams = '';
			
			if (date_from != '') {
				tmpParams +=  '&date_from=' + date_from;
			}
			if (date_to != '') {
				tmpParams +=  '&date_to=' + date_to;
			}
			if (tmpParams != ''){
				params = '?' + tmpParams.substring(1);
			}
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/tokens/" + user.country_code + "/" + user.party_id + "/external" + params, "", true, authentication, "GET", true, false).then(function (res) {
                    
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function getAllUsers() {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/tokens", "", true, authentication, "GET", true, false).then(function (res) {
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
        }
		
		function calculate (requestID) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/requests/" + requestID + "/optimization", "", true, authentication, "GET", true, false).then(function (res) {
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function chargerStatus(parkingID) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/locations/" + parkingID + "/evses_status", "", true, authentication, "GET", true, false).then(function (res) {
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
        }
		
		function getChargerById(parkingID, chargerID) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                callRestService(MEISTER.api, "/locations/" + parkingID + "/evse/" + chargerID, "", true, authentication, "GET", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function newCharger(parkingID, charger) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                callRestService(MEISTER.api, "/locations/" + parkingID, charger, true, authentication, "POST", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function editCharger(parkingID, charger) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                callRestService(MEISTER.api, "/locations/" + parkingID + "/evse/" + charger.uid, charger, true, authentication, "PUT", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function deleteCharger(parkingID, chargerID) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                callRestService(MEISTER.api, "/locations/" + parkingID + "/evse/" + chargerID, "", true, authentication, "DELETE", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function getAllSessions() {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/sessions" + "/" + user.country_code + "/" + user.party_id, "", true, authentication, "GET", true, false).then(function (res) {
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
        }
		
		function getAllSessionsByDateByStatus(status, date_from, date_to) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			var parameters = "";
			
			if (status == 'ALL') {
				parameters = "?date_from=" + date_from + "&date_to=" + date_to;
			}
			else {
				parameters = "?status=" + status + "&date_from=" + date_from + "&date_to=" + date_to;
			}
			
			return $q(function (resolve, reject) {
				
				callRestService(MEISTER.api, "/sessions" + "/" + user.country_code + "/" + user.party_id + parameters, "", true, authentication, "GET", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function getSessionByID(sessionID) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/sessions/" + sessionID, "", true, authentication, "GET", true, false).then(function (res) {
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function getAllParkings() {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/locations" + "/" + user.country_code + "/" + user.party_id, "", true, authentication, "GET", true, false).then(function (res) {
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
        }
		
		function getParkingByID(parkingID) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/locations/" + parkingID, "", true, authentication, "GET", true, false).then(function (res) {
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		
		function newParking(parking) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                callRestService(MEISTER.api, "/locations", parking, true, authentication, "POST", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function updateParking(parking) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/locations/" + parking.id, parking, true, authentication, "PUT", true, false).then(function (res) {
					if (res.data != undefined) {
						resolve(res.data);
					}
					else {
						resolve({});
					}
				});
			});
		}
		
		function deleteParking(parking) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/locations/" + parking.id, "", true, authentication, "DELETE", true, false).then(function (res) {
					if (res.data != undefined) {
						resolve(res.data);
					}
					else {
						resolve({});
					}
				});
			});
		}
		
		function getNotificationsByDate(startDate, endDate) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password;
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/notifications/" + user.country_code + "/" + user.party_id + "?startDate=" + startDate + "&endDate=" + endDate, "", true, authentication, "GET", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function changeNotificationStatus(notificationId) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                callRestService(MEISTER.api, "/notifications/" + notificationId + "?status=read", "", true, authentication, "PUT", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function getMOQOCarByID(carID) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/moqo/evs/" + carID, "", true, authentication, "GET", true, false).then(function (res) {
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
        }
        
        function getMOQOCars() {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/moqo/evs", "", true, authentication, "GET", true, false).then(function (res) {
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
        }
		
		function getCarByID(carID) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/evs/" + carID, "", true, authentication, "GET", true, false).then(function (res) {
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
        }
        
        function getCars() {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/evs", "", true, authentication, "GET", true, false).then(function (res) {
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
        }
        
        function getAvailableChargers(startDate, endDate){
            var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/locations/evses/available?startDate=" + startDate + "&endDate=" + endDate, "", true, authentication, "GET", true, false).then(function (res) {
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
        }

        function addChargePlan(params, carID) {
            var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/evs/" + carID + "/add_charge_plan", params, true, authentication, "POST", true, false).then(function (res) {
                    if (res != undefined) {
                        resolve(res);
                    }
                    else {
                        resolve({});
                    }
                });
            });
        }
		
		function deleteChargePlan(carID) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/evs/" + carID + "/charge_plan", "", true, authentication, "DELETE", true, false).then(function (res) {
					if (res.data != undefined) {
						resolve(res.data);
					}
					else {
						resolve({});
					}
				});
			});
		}
		
		function getAllDSORequests() {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                
				callRestService(MEISTER.api, "/requests", "", true, authentication, "GET", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function sendCPOResponse(response, requestId) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			var tmpResponse = {
				"response": response,
				"requestId": requestId
			};
			
			return $q(function (resolve, reject) {
				callRestService(MEISTER.api, "/requests/cpo_response", tmpResponse, true, authentication, "POST", true, false).then(function (res) {
					if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function getAllNotifications() {
			
		}
		
		function getAllDSORequestsByDateByStatus(status, date_from, date_to) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			var parameters = "";
			
			if (status == 'ALL') {
				parameters = "?date_from=" + date_from + "&date_to=" + date_to;
			}
			else {
				parameters = "?status=" + status + "&date_from=" + date_from + "&date_to=" + date_to;
			}
			
			return $q(function (resolve, reject) {
				
				callRestService(MEISTER.api, "/requests" + "/" + user.country_code + "/" + user.party_id + parameters, "", true, authentication, "GET", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		function getDSORequestById(requestId) {
			var user = session.getUser();
			var authentication = user.username + ':' + user.password; 
			
			return $q(function (resolve, reject) {
                
				callRestService(MEISTER.api, "/requests/" + requestId, "", true, authentication, "GET", true, false).then(function (res) {
                    if (res.data != undefined) {
                        resolve(res.data);
                    }
                    else {
                        resolve({});
                    }
                });
            });
		}
		
		
		/**
		 * -------------------
		 * Call Rest Service
		 * -------------------
		 * @param url_in string
		 * @param service string
		 * @param params json/string
		 * @param useCredentials (true/false)
		 * @param auth string
		 * @param method (GET/POST)
		 * @param access_control (true/false)
		 * @param cookies (true/false)
		 * 
		 * @return json
		 * 
		 * @description
		 * 
		**/
        function callRestService(url_in, service, params, useCredentials, auth, method, access_control, cookies) {
			var this_url;
            var this_headers = {};
            var this_data = {};
            var this_withCredentials = false;

            if (method === "POST" || method === "PUT" || method === "DELETE") {
                this_url = url_in + service;
                this_data = params;
                if (access_control) {
                    this_headers['Access-Control-Allow-Origin'] = "*";
                    this_headers['Content-Type'] = "application/json";
                    this_headers['Access-Control-Allow-Methods'] = "GET, POST, PATCH, PUT, DELETE";
                }
                else {
                    this_headers['Content-Type'] = "application/x-www-form-urlencoded";
                }
            }
            else {
                this_url = url_in + service + params;
            }

            if (useCredentials) {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization'] = "Basic " + this_auth;
            }

            if (cookies) {
                this_withCredentials = true;
            }
			
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                withCredentials: this_withCredentials,
                data: this_data
            });
        }
		
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('auth', authService);

    /** @ngInject */
    function authService($http, $window, $location, $state, session)
    {
        var service = {
            isLoggedIn: isLoggedIn,
			logIn: logIn,
			logOut: logOut
        };

        return service;
        //////////
		
        /**
         * Check whether the user is logged in
         * @returns boolean
         */
		function isLoggedIn()
		{
			return session.getUser() !== null && session.getUser() !== undefined;
		};

        /**
         * Log in
         * @param credentials
		 * @returns {*|Promise}
         */
		function logIn(credentials)
		{
		  session.destroy();
		  return $http
			.post(
				'https://hydra.iti.gr:8101/oauth2/token',
				{'code': credentials, 'grant_type': 'authorization_code', 'redirect_uri' : 'https://hydra.iti.gr/PRAGMA'},
				{'headers': {'Authorization': 'Basic RUVwb3J0YWw6MzNwb3J0QGw='}}
			)
			.then(function(response) {
				var data = response.data;
				if (data.access_token != undefined) {
					session.setUser(data.access_token);
					$window.location.reload();
				}
				else {
					$location.path('/auth/login?failed=true').replace();
				}
			});
		};

        /**
         * Log out
 		 * @returns {*|Promise}
         */
		function logOut ()
		{
		  return $http
			.get('https://hydra.iti.gr:8101/logout')
			.then(function(response){
			  // Destroy session in the browser
			  session.destroy();
			  $location.path('/auth/login').replace();
			});
		};
	}

})();
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,e.mqtt=t()}}(function(){var t;return function e(t,r,n){function i(s,a){if(!r[s]){if(!t[s]){var u="function"==typeof require&&require;if(!a&&u)return u(s,!0);if(o)return o(s,!0);var c=new Error("Cannot find module '"+s+"'");throw c.code="MODULE_NOT_FOUND",c}var h=r[s]={exports:{}};t[s][0].call(h.exports,function(e){var r=t[s][1][e];return i(r?r:e)},h,h.exports,e,t,r,n)}return r[s].exports}for(var o="function"==typeof require&&require,s=0;s<n.length;s++)i(n[s]);return i}({1:[function(t,e,r){"use strict";function n(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");return"="===t[e-2]?2:"="===t[e-1]?1:0}function i(t){return 3*t.length/4-n(t)}function o(t){var e,r,i,o,s,a=t.length;o=n(t),s=new f(3*a/4-o),r=o>0?a-4:a;var u=0;for(e=0;r>e;e+=4)i=h[t.charCodeAt(e)]<<18|h[t.charCodeAt(e+1)]<<12|h[t.charCodeAt(e+2)]<<6|h[t.charCodeAt(e+3)],s[u++]=i>>16&255,s[u++]=i>>8&255,s[u++]=255&i;return 2===o?(i=h[t.charCodeAt(e)]<<2|h[t.charCodeAt(e+1)]>>4,s[u++]=255&i):1===o&&(i=h[t.charCodeAt(e)]<<10|h[t.charCodeAt(e+1)]<<4|h[t.charCodeAt(e+2)]>>2,s[u++]=i>>8&255,s[u++]=255&i),s}function s(t){return c[t>>18&63]+c[t>>12&63]+c[t>>6&63]+c[63&t]}function a(t,e,r){for(var n,i=[],o=e;r>o;o+=3)n=(t[o]<<16)+(t[o+1]<<8)+t[o+2],i.push(s(n));return i.join("")}function u(t){for(var e,r=t.length,n=r%3,i="",o=[],s=16383,u=0,h=r-n;h>u;u+=s)o.push(a(t,u,u+s>h?h:u+s));return 1===n?(e=t[r-1],i+=c[e>>2],i+=c[e<<4&63],i+="=="):2===n&&(e=(t[r-2]<<8)+t[r-1],i+=c[e>>10],i+=c[e>>4&63],i+=c[e<<2&63],i+="="),o.push(i),o.join("")}r.byteLength=i,r.toByteArray=o,r.fromByteArray=u;for(var c=[],h=[],f="undefined"!=typeof Uint8Array?Uint8Array:Array,l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",p=0,d=l.length;d>p;++p)c[p]=l[p],h[l.charCodeAt(p)]=p;h["-".charCodeAt(0)]=62,h["_".charCodeAt(0)]=63},{}],2:[function(t,e,r){},{}],3:[function(t,e,r){"use strict";function n(){try{var t=new Uint8Array(1);return t.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===t.foo()}catch(e){return!1}}function i(t){if(t>Y)throw new RangeError("Invalid typed array length");var e=new Uint8Array(t);return e.__proto__=o.prototype,e}function o(t,e,r){if("number"==typeof t){if("string"==typeof e)throw new Error("If encoding is specified then the first argument must be a string");return c(t)}return s(t,e,r)}function s(t,e,r){if("number"==typeof t)throw new TypeError('"value" argument must not be a number');return Q(t)?l(t,e,r):"string"==typeof t?h(t,e):p(t)}function a(t){if("number"!=typeof t)throw new TypeError('"size" argument must be a number');if(0>t)throw new RangeError('"size" argument must not be negative')}function u(t,e,r){return a(t),0>=t?i(t):void 0!==e?"string"==typeof r?i(t).fill(e,r):i(t).fill(e):i(t)}function c(t){return a(t),i(0>t?0:0|d(t))}function h(t,e){if(("string"!=typeof e||""===e)&&(e="utf8"),!o.isEncoding(e))throw new TypeError('"encoding" must be a valid string encoding');var r=0|b(t,e),n=i(r),s=n.write(t,e);return s!==r&&(n=n.slice(0,s)),n}function f(t){for(var e=t.length<0?0:0|d(t.length),r=i(e),n=0;e>n;n+=1)r[n]=255&t[n];return r}function l(t,e,r){if(0>e||t.byteLength<e)throw new RangeError("'offset' is out of bounds");if(t.byteLength<e+(r||0))throw new RangeError("'length' is out of bounds");var n;return n=void 0===e&&void 0===r?new Uint8Array(t):void 0===r?new Uint8Array(t,e):new Uint8Array(t,e,r),n.__proto__=o.prototype,n}function p(t){if(o.isBuffer(t)){var e=0|d(t.length),r=i(e);return 0===r.length?r:(t.copy(r,0,0,e),r)}if(t){if(V(t)||"length"in t)return"number"!=typeof t.length||G(t.length)?i(0):f(t);if("Buffer"===t.type&&Array.isArray(t.data))return f(t.data)}throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}function d(t){if(t>=Y)throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+Y.toString(16)+" bytes");return 0|t}function g(t){return+t!=t&&(t=0),o.alloc(+t)}function b(t,e){if(o.isBuffer(t))return t.length;if(V(t)||Q(t))return t.byteLength;"string"!=typeof t&&(t=""+t);var r=t.length;if(0===r)return 0;for(var n=!1;;)switch(e){case"ascii":case"latin1":case"binary":return r;case"utf8":case"utf-8":case void 0:return W(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*r;case"hex":return r>>>1;case"base64":return z(t).length;default:if(n)return W(t).length;e=(""+e).toLowerCase(),n=!0}}function m(t,e,r){var n=!1;if((void 0===e||0>e)&&(e=0),e>this.length)return"";if((void 0===r||r>this.length)&&(r=this.length),0>=r)return"";if(r>>>=0,e>>>=0,e>=r)return"";for(t||(t="utf8");;)switch(t){case"hex":return L(this,e,r);case"utf8":case"utf-8":return T(this,e,r);case"ascii":return C(this,e,r);case"latin1":case"binary":return j(this,e,r);case"base64":return A(this,e,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return O(this,e,r);default:if(n)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),n=!0}}function y(t,e,r){var n=t[e];t[e]=t[r],t[r]=n}function v(t,e,r,n,i){if(0===t.length)return-1;if("string"==typeof r?(n=r,r=0):r>2147483647?r=2147483647:-2147483648>r&&(r=-2147483648),r=+r,G(r)&&(r=i?0:t.length-1),0>r&&(r=t.length+r),r>=t.length){if(i)return-1;r=t.length-1}else if(0>r){if(!i)return-1;r=0}if("string"==typeof e&&(e=o.from(e,n)),o.isBuffer(e))return 0===e.length?-1:_(t,e,r,n,i);if("number"==typeof e)return e=255&e,"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(t,e,r):Uint8Array.prototype.lastIndexOf.call(t,e,r):_(t,[e],r,n,i);throw new TypeError("val must be string, number or Buffer")}function _(t,e,r,n,i){function o(t,e){return 1===s?t[e]:t.readUInt16BE(e*s)}var s=1,a=t.length,u=e.length;if(void 0!==n&&(n=String(n).toLowerCase(),"ucs2"===n||"ucs-2"===n||"utf16le"===n||"utf-16le"===n)){if(t.length<2||e.length<2)return-1;s=2,a/=2,u/=2,r/=2}var c;if(i){var h=-1;for(c=r;a>c;c++)if(o(t,c)===o(e,-1===h?0:c-h)){if(-1===h&&(h=c),c-h+1===u)return h*s}else-1!==h&&(c-=c-h),h=-1}else for(r+u>a&&(r=a-u),c=r;c>=0;c--){for(var f=!0,l=0;u>l;l++)if(o(t,c+l)!==o(e,l)){f=!1;break}if(f)return c}return-1}function w(t,e,r,n){r=Number(r)||0;var i=t.length-r;n?(n=Number(n),n>i&&(n=i)):n=i;var o=e.length;if(o%2!==0)throw new TypeError("Invalid hex string");n>o/2&&(n=o/2);for(var s=0;n>s;++s){var a=parseInt(e.substr(2*s,2),16);if(G(a))return s;t[r+s]=a}return s}function S(t,e,r,n){return K(W(e,t.length-r),t,r,n)}function E(t,e,r,n){return K(F(e),t,r,n)}function k(t,e,r,n){return E(t,e,r,n)}function I(t,e,r,n){return K(z(e),t,r,n)}function x(t,e,r,n){return K(H(e,t.length-r),t,r,n)}function A(t,e,r){return 0===e&&r===t.length?$.fromByteArray(t):$.fromByteArray(t.slice(e,r))}function T(t,e,r){r=Math.min(t.length,r);for(var n=[],i=e;r>i;){var o=t[i],s=null,a=o>239?4:o>223?3:o>191?2:1;if(r>=i+a){var u,c,h,f;switch(a){case 1:128>o&&(s=o);break;case 2:u=t[i+1],128===(192&u)&&(f=(31&o)<<6|63&u,f>127&&(s=f));break;case 3:u=t[i+1],c=t[i+2],128===(192&u)&&128===(192&c)&&(f=(15&o)<<12|(63&u)<<6|63&c,f>2047&&(55296>f||f>57343)&&(s=f));break;case 4:u=t[i+1],c=t[i+2],h=t[i+3],128===(192&u)&&128===(192&c)&&128===(192&h)&&(f=(15&o)<<18|(63&u)<<12|(63&c)<<6|63&h,f>65535&&1114112>f&&(s=f))}}null===s?(s=65533,a=1):s>65535&&(s-=65536,n.push(s>>>10&1023|55296),s=56320|1023&s),n.push(s),i+=a}return M(n)}function M(t){var e=t.length;if(J>=e)return String.fromCharCode.apply(String,t);for(var r="",n=0;e>n;)r+=String.fromCharCode.apply(String,t.slice(n,n+=J));return r}function C(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;r>i;++i)n+=String.fromCharCode(127&t[i]);return n}function j(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;r>i;++i)n+=String.fromCharCode(t[i]);return n}function L(t,e,r){var n=t.length;(!e||0>e)&&(e=0),(!r||0>r||r>n)&&(r=n);for(var i="",o=e;r>o;++o)i+=D(t[o]);return i}function O(t,e,r){for(var n=t.slice(e,r),i="",o=0;o<n.length;o+=2)i+=String.fromCharCode(n[o]+256*n[o+1]);return i}function R(t,e,r){if(t%1!==0||0>t)throw new RangeError("offset is not uint");if(t+e>r)throw new RangeError("Trying to access beyond buffer length")}function U(t,e,r,n,i,s){if(!o.isBuffer(t))throw new TypeError('"buffer" argument must be a Buffer instance');if(e>i||s>e)throw new RangeError('"value" argument is out of bounds');if(r+n>t.length)throw new RangeError("Index out of range")}function B(t,e,r,n,i,o){if(r+n>t.length)throw new RangeError("Index out of range");if(0>r)throw new RangeError("Index out of range")}function N(t,e,r,n,i){return e=+e,r>>>=0,i||B(t,e,r,4,3.4028234663852886e38,-3.4028234663852886e38),Z.write(t,e,r,n,23,4),r+4}function q(t,e,r,n,i){return e=+e,r>>>=0,i||B(t,e,r,8,1.7976931348623157e308,-1.7976931348623157e308),Z.write(t,e,r,n,52,8),r+8}function P(t){if(t=t.trim().replace(X,""),t.length<2)return"";for(;t.length%4!==0;)t+="=";return t}function D(t){return 16>t?"0"+t.toString(16):t.toString(16)}function W(t,e){e=e||1/0;for(var r,n=t.length,i=null,o=[],s=0;n>s;++s){if(r=t.charCodeAt(s),r>55295&&57344>r){if(!i){if(r>56319){(e-=3)>-1&&o.push(239,191,189);continue}if(s+1===n){(e-=3)>-1&&o.push(239,191,189);continue}i=r;continue}if(56320>r){(e-=3)>-1&&o.push(239,191,189),i=r;continue}r=(i-55296<<10|r-56320)+65536}else i&&(e-=3)>-1&&o.push(239,191,189);if(i=null,128>r){if((e-=1)<0)break;o.push(r)}else if(2048>r){if((e-=2)<0)break;o.push(r>>6|192,63&r|128)}else if(65536>r){if((e-=3)<0)break;o.push(r>>12|224,r>>6&63|128,63&r|128)}else{if(!(1114112>r))throw new Error("Invalid code point");if((e-=4)<0)break;o.push(r>>18|240,r>>12&63|128,r>>6&63|128,63&r|128)}}return o}function F(t){for(var e=[],r=0;r<t.length;++r)e.push(255&t.charCodeAt(r));return e}function H(t,e){for(var r,n,i,o=[],s=0;s<t.length&&!((e-=2)<0);++s)r=t.charCodeAt(s),n=r>>8,i=r%256,o.push(i),o.push(n);return o}function z(t){return $.toByteArray(P(t))}function K(t,e,r,n){for(var i=0;n>i&&!(i+r>=e.length||i>=t.length);++i)e[i+r]=t[i];return i}function Q(t){return t instanceof ArrayBuffer||null!=t&&null!=t.constructor&&"ArrayBuffer"===t.constructor.name&&"number"==typeof t.byteLength}function V(t){return"function"==typeof ArrayBuffer.isView&&ArrayBuffer.isView(t)}function G(t){return t!==t}var $=t("base64-js"),Z=t("ieee754");r.Buffer=o,r.SlowBuffer=g,r.INSPECT_MAX_BYTES=50;var Y=2147483647;r.kMaxLength=Y,o.TYPED_ARRAY_SUPPORT=n(),o.TYPED_ARRAY_SUPPORT||"undefined"==typeof console||"function"!=typeof console.error||console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."),"undefined"!=typeof Symbol&&Symbol.species&&o[Symbol.species]===o&&Object.defineProperty(o,Symbol.species,{value:null,configurable:!0,enumerable:!1,writable:!1}),o.poolSize=8192,o.from=function(t,e,r){return s(t,e,r)},o.prototype.__proto__=Uint8Array.prototype,o.__proto__=Uint8Array,o.alloc=function(t,e,r){return u(t,e,r)},o.allocUnsafe=function(t){return c(t)},o.allocUnsafeSlow=function(t){return c(t)},o.isBuffer=function(t){return null!=t&&t._isBuffer===!0},o.compare=function(t,e){if(!o.isBuffer(t)||!o.isBuffer(e))throw new TypeError("Arguments must be Buffers");if(t===e)return 0;for(var r=t.length,n=e.length,i=0,s=Math.min(r,n);s>i;++i)if(t[i]!==e[i]){r=t[i],n=e[i];break}return n>r?-1:r>n?1:0},o.isEncoding=function(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},o.concat=function(t,e){if(!Array.isArray(t))throw new TypeError('"list" argument must be an Array of Buffers');if(0===t.length)return o.alloc(0);var r;if(void 0===e)for(e=0,r=0;r<t.length;++r)e+=t[r].length;var n=o.allocUnsafe(e),i=0;for(r=0;r<t.length;++r){var s=t[r];if(!o.isBuffer(s))throw new TypeError('"list" argument must be an Array of Buffers');s.copy(n,i),i+=s.length}return n},o.byteLength=b,o.prototype._isBuffer=!0,o.prototype.swap16=function(){var t=this.length;if(t%2!==0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var e=0;t>e;e+=2)y(this,e,e+1);return this},o.prototype.swap32=function(){var t=this.length;if(t%4!==0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var e=0;t>e;e+=4)y(this,e,e+3),y(this,e+1,e+2);return this},o.prototype.swap64=function(){var t=this.length;if(t%8!==0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var e=0;t>e;e+=8)y(this,e,e+7),y(this,e+1,e+6),y(this,e+2,e+5),y(this,e+3,e+4);return this},o.prototype.toString=function(){var t=this.length;return 0===t?"":0===arguments.length?T(this,0,t):m.apply(this,arguments)},o.prototype.equals=function(t){if(!o.isBuffer(t))throw new TypeError("Argument must be a Buffer");return this===t?!0:0===o.compare(this,t)},o.prototype.inspect=function(){var t="",e=r.INSPECT_MAX_BYTES;return this.length>0&&(t=this.toString("hex",0,e).match(/.{2}/g).join(" "),this.length>e&&(t+=" ... ")),"<Buffer "+t+">"},o.prototype.compare=function(t,e,r,n,i){if(!o.isBuffer(t))throw new TypeError("Argument must be a Buffer");if(void 0===e&&(e=0),void 0===r&&(r=t?t.length:0),void 0===n&&(n=0),void 0===i&&(i=this.length),0>e||r>t.length||0>n||i>this.length)throw new RangeError("out of range index");if(n>=i&&e>=r)return 0;if(n>=i)return-1;if(e>=r)return 1;if(e>>>=0,r>>>=0,n>>>=0,i>>>=0,this===t)return 0;for(var s=i-n,a=r-e,u=Math.min(s,a),c=this.slice(n,i),h=t.slice(e,r),f=0;u>f;++f)if(c[f]!==h[f]){s=c[f],a=h[f];break}return a>s?-1:s>a?1:0},o.prototype.includes=function(t,e,r){return-1!==this.indexOf(t,e,r)},o.prototype.indexOf=function(t,e,r){return v(this,t,e,r,!0)},o.prototype.lastIndexOf=function(t,e,r){return v(this,t,e,r,!1)},o.prototype.write=function(t,e,r,n){if(void 0===e)n="utf8",r=this.length,e=0;else if(void 0===r&&"string"==typeof e)n=e,r=this.length,e=0;else{if(!isFinite(e))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");e>>>=0,isFinite(r)?(r>>>=0,void 0===n&&(n="utf8")):(n=r,r=void 0)}var i=this.length-e;if((void 0===r||r>i)&&(r=i),t.length>0&&(0>r||0>e)||e>this.length)throw new RangeError("Attempt to write outside buffer bounds");n||(n="utf8");for(var o=!1;;)switch(n){case"hex":return w(this,t,e,r);case"utf8":case"utf-8":return S(this,t,e,r);case"ascii":return E(this,t,e,r);case"latin1":case"binary":return k(this,t,e,r);case"base64":return I(this,t,e,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return x(this,t,e,r);default:if(o)throw new TypeError("Unknown encoding: "+n);n=(""+n).toLowerCase(),o=!0}},o.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var J=4096;o.prototype.slice=function(t,e){var r=this.length;t=~~t,e=void 0===e?r:~~e,0>t?(t+=r,0>t&&(t=0)):t>r&&(t=r),0>e?(e+=r,0>e&&(e=0)):e>r&&(e=r),t>e&&(e=t);var n=this.subarray(t,e);return n.__proto__=o.prototype,n},o.prototype.readUIntLE=function(t,e,r){t>>>=0,e>>>=0,r||R(t,e,this.length);for(var n=this[t],i=1,o=0;++o<e&&(i*=256);)n+=this[t+o]*i;return n},o.prototype.readUIntBE=function(t,e,r){t>>>=0,e>>>=0,r||R(t,e,this.length);for(var n=this[t+--e],i=1;e>0&&(i*=256);)n+=this[t+--e]*i;return n},o.prototype.readUInt8=function(t,e){return t>>>=0,e||R(t,1,this.length),this[t]},o.prototype.readUInt16LE=function(t,e){return t>>>=0,e||R(t,2,this.length),this[t]|this[t+1]<<8},o.prototype.readUInt16BE=function(t,e){return t>>>=0,e||R(t,2,this.length),this[t]<<8|this[t+1]},o.prototype.readUInt32LE=function(t,e){return t>>>=0,e||R(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},o.prototype.readUInt32BE=function(t,e){return t>>>=0,e||R(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},o.prototype.readIntLE=function(t,e,r){t>>>=0,e>>>=0,r||R(t,e,this.length);for(var n=this[t],i=1,o=0;++o<e&&(i*=256);)n+=this[t+o]*i;return i*=128,n>=i&&(n-=Math.pow(2,8*e)),n},o.prototype.readIntBE=function(t,e,r){t>>>=0,e>>>=0,r||R(t,e,this.length);for(var n=e,i=1,o=this[t+--n];n>0&&(i*=256);)o+=this[t+--n]*i;return i*=128,o>=i&&(o-=Math.pow(2,8*e)),o},o.prototype.readInt8=function(t,e){return t>>>=0,e||R(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},o.prototype.readInt16LE=function(t,e){t>>>=0,e||R(t,2,this.length);var r=this[t]|this[t+1]<<8;return 32768&r?4294901760|r:r},o.prototype.readInt16BE=function(t,e){t>>>=0,e||R(t,2,this.length);var r=this[t+1]|this[t]<<8;return 32768&r?4294901760|r:r},o.prototype.readInt32LE=function(t,e){return t>>>=0,e||R(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},o.prototype.readInt32BE=function(t,e){return t>>>=0,e||R(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},o.prototype.readFloatLE=function(t,e){return t>>>=0,e||R(t,4,this.length),Z.read(this,t,!0,23,4)},o.prototype.readFloatBE=function(t,e){return t>>>=0,e||R(t,4,this.length),Z.read(this,t,!1,23,4)},o.prototype.readDoubleLE=function(t,e){return t>>>=0,e||R(t,8,this.length),Z.read(this,t,!0,52,8)},o.prototype.readDoubleBE=function(t,e){return t>>>=0,e||R(t,8,this.length),Z.read(this,t,!1,52,8)},o.prototype.writeUIntLE=function(t,e,r,n){if(t=+t,e>>>=0,r>>>=0,!n){var i=Math.pow(2,8*r)-1;U(this,t,e,r,i,0)}var o=1,s=0;for(this[e]=255&t;++s<r&&(o*=256);)this[e+s]=t/o&255;return e+r},o.prototype.writeUIntBE=function(t,e,r,n){if(t=+t,e>>>=0,r>>>=0,!n){var i=Math.pow(2,8*r)-1;U(this,t,e,r,i,0)}var o=r-1,s=1;for(this[e+o]=255&t;--o>=0&&(s*=256);)this[e+o]=t/s&255;return e+r},o.prototype.writeUInt8=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,1,255,0),this[e]=255&t,e+1},o.prototype.writeUInt16LE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,2,65535,0),this[e]=255&t,this[e+1]=t>>>8,e+2},o.prototype.writeUInt16BE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,2,65535,0),this[e]=t>>>8,this[e+1]=255&t,e+2},o.prototype.writeUInt32LE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,4,4294967295,0),this[e+3]=t>>>24,this[e+2]=t>>>16,this[e+1]=t>>>8,this[e]=255&t,e+4},o.prototype.writeUInt32BE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,4,4294967295,0),this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t,e+4},o.prototype.writeIntLE=function(t,e,r,n){if(t=+t,e>>>=0,!n){var i=Math.pow(2,8*r-1);U(this,t,e,r,i-1,-i)}var o=0,s=1,a=0;for(this[e]=255&t;++o<r&&(s*=256);)0>t&&0===a&&0!==this[e+o-1]&&(a=1),this[e+o]=(t/s>>0)-a&255;return e+r},o.prototype.writeIntBE=function(t,e,r,n){if(t=+t,e>>>=0,!n){var i=Math.pow(2,8*r-1);U(this,t,e,r,i-1,-i)}var o=r-1,s=1,a=0;for(this[e+o]=255&t;--o>=0&&(s*=256);)0>t&&0===a&&0!==this[e+o+1]&&(a=1),this[e+o]=(t/s>>0)-a&255;return e+r},o.prototype.writeInt8=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,1,127,-128),0>t&&(t=255+t+1),this[e]=255&t,e+1},o.prototype.writeInt16LE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,2,32767,-32768),this[e]=255&t,this[e+1]=t>>>8,e+2},o.prototype.writeInt16BE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,2,32767,-32768),this[e]=t>>>8,this[e+1]=255&t,e+2},o.prototype.writeInt32LE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,4,2147483647,-2147483648),this[e]=255&t,this[e+1]=t>>>8,this[e+2]=t>>>16,this[e+3]=t>>>24,e+4},o.prototype.writeInt32BE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,4,2147483647,-2147483648),0>t&&(t=4294967295+t+1),this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t,e+4},o.prototype.writeFloatLE=function(t,e,r){return N(this,t,e,!0,r)},o.prototype.writeFloatBE=function(t,e,r){return N(this,t,e,!1,r)},o.prototype.writeDoubleLE=function(t,e,r){return q(this,t,e,!0,r)},o.prototype.writeDoubleBE=function(t,e,r){return q(this,t,e,!1,r)},o.prototype.copy=function(t,e,r,n){if(r||(r=0),n||0===n||(n=this.length),e>=t.length&&(e=t.length),e||(e=0),n>0&&r>n&&(n=r),n===r)return 0;if(0===t.length||0===this.length)return 0;if(0>e)throw new RangeError("targetStart out of bounds");if(0>r||r>=this.length)throw new RangeError("sourceStart out of bounds");if(0>n)throw new RangeError("sourceEnd out of bounds");n>this.length&&(n=this.length),t.length-e<n-r&&(n=t.length-e+r);var i,o=n-r;if(this===t&&e>r&&n>e)for(i=o-1;i>=0;--i)t[i+e]=this[i+r];else if(1e3>o)for(i=0;o>i;++i)t[i+e]=this[i+r];else Uint8Array.prototype.set.call(t,this.subarray(r,r+o),e);return o},o.prototype.fill=function(t,e,r,n){if("string"==typeof t){if("string"==typeof e?(n=e,e=0,r=this.length):"string"==typeof r&&(n=r,r=this.length),1===t.length){var i=t.charCodeAt(0);256>i&&(t=i)}if(void 0!==n&&"string"!=typeof n)throw new TypeError("encoding must be a string");if("string"==typeof n&&!o.isEncoding(n))throw new TypeError("Unknown encoding: "+n)}else"number"==typeof t&&(t=255&t);if(0>e||this.length<e||this.length<r)throw new RangeError("Out of range index");if(e>=r)return this;e>>>=0,r=void 0===r?this.length:r>>>0,t||(t=0);var s;if("number"==typeof t)for(s=e;r>s;++s)this[s]=t;else{var a=o.isBuffer(t)?t:new o(t,n),u=a.length;for(s=0;r-e>s;++s)this[s+e]=a[s%u]}return this};var X=/[^+\/0-9A-Za-z-_]/g},{"base64-js":1,ieee754:5}],4:[function(t,e,r){function n(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function i(t){return"function"==typeof t}function o(t){return"number"==typeof t}function s(t){return"object"==typeof t&&null!==t}function a(t){return void 0===t}e.exports=n,n.EventEmitter=n,n.prototype._events=void 0,n.prototype._maxListeners=void 0,n.defaultMaxListeners=10,n.prototype.setMaxListeners=function(t){if(!o(t)||0>t||isNaN(t))throw TypeError("n must be a positive number");return this._maxListeners=t,this},n.prototype.emit=function(t){var e,r,n,o,u,c;if(this._events||(this._events={}),"error"===t&&(!this._events.error||s(this._events.error)&&!this._events.error.length)){if(e=arguments[1],e instanceof Error)throw e;var h=new Error('Uncaught, unspecified "error" event. ('+e+")");throw h.context=e,h}if(r=this._events[t],a(r))return!1;if(i(r))switch(arguments.length){case 1:r.call(this);break;case 2:r.call(this,arguments[1]);break;case 3:r.call(this,arguments[1],arguments[2]);break;default:o=Array.prototype.slice.call(arguments,1),r.apply(this,o)}else if(s(r))for(o=Array.prototype.slice.call(arguments,1),c=r.slice(),n=c.length,u=0;n>u;u++)c[u].apply(this,o);return!0},n.prototype.addListener=function(t,e){var r;if(!i(e))throw TypeError("listener must be a function");return this._events||(this._events={}),this._events.newListener&&this.emit("newListener",t,i(e.listener)?e.listener:e),this._events[t]?s(this._events[t])?this._events[t].push(e):this._events[t]=[this._events[t],e]:this._events[t]=e,s(this._events[t])&&!this._events[t].warned&&(r=a(this._maxListeners)?n.defaultMaxListeners:this._maxListeners,r&&r>0&&this._events[t].length>r&&(this._events[t].warned=!0,console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",this._events[t].length),"function"==typeof console.trace&&console.trace())),this},n.prototype.on=n.prototype.addListener,n.prototype.once=function(t,e){function r(){this.removeListener(t,r),n||(n=!0,e.apply(this,arguments))}if(!i(e))throw TypeError("listener must be a function");var n=!1;return r.listener=e,this.on(t,r),this},n.prototype.removeListener=function(t,e){var r,n,o,a;if(!i(e))throw TypeError("listener must be a function");if(!this._events||!this._events[t])return this;if(r=this._events[t],o=r.length,n=-1,r===e||i(r.listener)&&r.listener===e)delete this._events[t],this._events.removeListener&&this.emit("removeListener",t,e);else if(s(r)){for(a=o;a-->0;)if(r[a]===e||r[a].listener&&r[a].listener===e){n=a;break}if(0>n)return this;1===r.length?(r.length=0,delete this._events[t]):r.splice(n,1),this._events.removeListener&&this.emit("removeListener",t,e)}return this},n.prototype.removeAllListeners=function(t){var e,r;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[t]&&delete this._events[t],this;if(0===arguments.length){for(e in this._events)"removeListener"!==e&&this.removeAllListeners(e);return this.removeAllListeners("removeListener"),this._events={},this}if(r=this._events[t],i(r))this.removeListener(t,r);else if(r)for(;r.length;)this.removeListener(t,r[r.length-1]);return delete this._events[t],this},n.prototype.listeners=function(t){var e;return e=this._events&&this._events[t]?i(this._events[t])?[this._events[t]]:this._events[t].slice():[]},n.prototype.listenerCount=function(t){if(this._events){var e=this._events[t];if(i(e))return 1;if(e)return e.length}return 0},n.listenerCount=function(t,e){return t.listenerCount(e)}},{}],5:[function(t,e,r){r.read=function(t,e,r,n,i){var o,s,a=8*i-n-1,u=(1<<a)-1,c=u>>1,h=-7,f=r?i-1:0,l=r?-1:1,p=t[e+f];for(f+=l,o=p&(1<<-h)-1,p>>=-h,h+=a;h>0;o=256*o+t[e+f],f+=l,h-=8);for(s=o&(1<<-h)-1,o>>=-h,h+=n;h>0;s=256*s+t[e+f],f+=l,h-=8);if(0===o)o=1-c;else{if(o===u)return s?NaN:(p?-1:1)*(1/0);s+=Math.pow(2,n),o-=c}return(p?-1:1)*s*Math.pow(2,o-n)},r.write=function(t,e,r,n,i,o){var s,a,u,c=8*o-i-1,h=(1<<c)-1,f=h>>1,l=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,p=n?0:o-1,d=n?1:-1,g=0>e||0===e&&0>1/e?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(a=isNaN(e)?1:0,s=h):(s=Math.floor(Math.log(e)/Math.LN2),e*(u=Math.pow(2,-s))<1&&(s--,u*=2),e+=s+f>=1?l/u:l*Math.pow(2,1-f),e*u>=2&&(s++,u/=2),s+f>=h?(a=0,s=h):s+f>=1?(a=(e*u-1)*Math.pow(2,i),s+=f):(a=e*Math.pow(2,f-1)*Math.pow(2,i),s=0));i>=8;t[r+p]=255&a,p+=d,a/=256,i-=8);for(s=s<<i|a,c+=i;c>0;t[r+p]=255&s,p+=d,s/=256,c-=8);t[r+p-d]|=128*g}},{}],6:[function(t,e,r){function n(t){return!!t.constructor&&"function"==typeof t.constructor.isBuffer&&t.constructor.isBuffer(t)}function i(t){return"function"==typeof t.readFloatLE&&"function"==typeof t.slice&&n(t.slice(0,0))}e.exports=function(t){return null!=t&&(n(t)||i(t)||!!t._isBuffer)}},{}],7:[function(t,e,r){function n(){throw new Error("setTimeout has not been defined")}function i(){throw new Error("clearTimeout has not been defined")}function o(t){if(f===setTimeout)return setTimeout(t,0);if((f===n||!f)&&setTimeout)return f=setTimeout,setTimeout(t,0);try{return f(t,0)}catch(e){try{return f.call(null,t,0)}catch(e){return f.call(this,t,0)}}}function s(t){if(l===clearTimeout)return clearTimeout(t);if((l===i||!l)&&clearTimeout)return l=clearTimeout,clearTimeout(t);try{return l(t)}catch(e){try{return l.call(null,t)}catch(e){return l.call(this,t)}}}function a(){b&&d&&(b=!1,d.length?g=d.concat(g):m=-1,g.length&&u())}function u(){if(!b){var t=o(a);b=!0;for(var e=g.length;e;){for(d=g,g=[];++m<e;)d&&d[m].run();m=-1,e=g.length}d=null,b=!1,s(t)}}function c(t,e){this.fun=t,this.array=e}function h(){}var f,l,p=e.exports={};!function(){try{f="function"==typeof setTimeout?setTimeout:n}catch(t){f=n}try{l="function"==typeof clearTimeout?clearTimeout:i}catch(t){l=i}}();var d,g=[],b=!1,m=-1;p.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var r=1;r<arguments.length;r++)e[r-1]=arguments[r];g.push(new c(t,e)),1!==g.length||b||o(u)},c.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=h,p.addListener=h,p.once=h,p.off=h,p.removeListener=h,p.removeAllListeners=h,p.emit=h,p.prependListener=h,p.prependOnceListener=h,p.listeners=function(t){return[]},p.binding=function(t){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(t){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},{}],8:[function(e,r,n){(function(e){!function(i){function o(t){throw new RangeError(R[t])}function s(t,e){for(var r=t.length,n=[];r--;)n[r]=e(t[r]);return n}function a(t,e){var r=t.split("@"),n="";r.length>1&&(n=r[0]+"@",t=r[1]),t=t.replace(O,".");var i=t.split("."),o=s(i,e).join(".");return n+o}function u(t){for(var e,r,n=[],i=0,o=t.length;o>i;)e=t.charCodeAt(i++),e>=55296&&56319>=e&&o>i?(r=t.charCodeAt(i++),56320==(64512&r)?n.push(((1023&e)<<10)+(1023&r)+65536):(n.push(e),i--)):n.push(e);return n}function c(t){return s(t,function(t){var e="";return t>65535&&(t-=65536,e+=N(t>>>10&1023|55296),t=56320|1023&t),e+=N(t)}).join("")}function h(t){return 10>t-48?t-22:26>t-65?t-65:26>t-97?t-97:E}function f(t,e){return t+22+75*(26>t)-((0!=e)<<5)}function l(t,e,r){var n=0;for(t=r?B(t/A):t>>1,t+=B(t/e);t>U*I>>1;n+=E)t=B(t/U);return B(n+(U+1)*t/(t+x))}function p(t){var e,r,n,i,s,a,u,f,p,d,g=[],b=t.length,m=0,y=M,v=T;for(r=t.lastIndexOf(C),0>r&&(r=0),n=0;r>n;++n)t.charCodeAt(n)>=128&&o("not-basic"),g.push(t.charCodeAt(n));for(i=r>0?r+1:0;b>i;){for(s=m,a=1,u=E;i>=b&&o("invalid-input"),f=h(t.charCodeAt(i++)),(f>=E||f>B((S-m)/a))&&o("overflow"),m+=f*a,p=v>=u?k:u>=v+I?I:u-v,!(p>f);u+=E)d=E-p,a>B(S/d)&&o("overflow"),a*=d;e=g.length+1,v=l(m-s,e,0==s),B(m/e)>S-y&&o("overflow"),y+=B(m/e),m%=e,g.splice(m++,0,y)}return c(g)}function d(t){var e,r,n,i,s,a,c,h,p,d,g,b,m,y,v,_=[];for(t=u(t),b=t.length,e=M,r=0,s=T,a=0;b>a;++a)g=t[a],128>g&&_.push(N(g));for(n=i=_.length,i&&_.push(C);b>n;){for(c=S,a=0;b>a;++a)g=t[a],g>=e&&c>g&&(c=g);for(m=n+1,c-e>B((S-r)/m)&&o("overflow"),r+=(c-e)*m,e=c,a=0;b>a;++a)if(g=t[a],e>g&&++r>S&&o("overflow"),g==e){for(h=r,p=E;d=s>=p?k:p>=s+I?I:p-s,!(d>h);p+=E)v=h-d,y=E-d,_.push(N(f(d+v%y,0))),h=B(v/y);_.push(N(f(h,0))),s=l(r,m,n==i),r=0,++n}++r,++e}return _.join("")}function g(t){return a(t,function(t){return j.test(t)?p(t.slice(4).toLowerCase()):t})}function b(t){return a(t,function(t){return L.test(t)?"xn--"+d(t):t})}var m="object"==typeof n&&n&&!n.nodeType&&n,y="object"==typeof r&&r&&!r.nodeType&&r,v="object"==typeof e&&e;(v.global===v||v.window===v||v.self===v)&&(i=v);var _,w,S=2147483647,E=36,k=1,I=26,x=38,A=700,T=72,M=128,C="-",j=/^xn--/,L=/[^\x20-\x7E]/,O=/[\x2E\u3002\uFF0E\uFF61]/g,R={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},U=E-k,B=Math.floor,N=String.fromCharCode;if(_={version:"1.4.1",ucs2:{decode:u,encode:c},decode:p,encode:d,toASCII:b,toUnicode:g},"function"==typeof t&&"object"==typeof t.amd&&t.amd)t("punycode",function(){return _});else if(m&&y)if(r.exports==m)y.exports=_;else for(w in _)_.hasOwnProperty(w)&&(m[w]=_[w]);else i.punycode=_}(this)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],9:[function(t,e,r){"use strict";function n(t,e){return Object.prototype.hasOwnProperty.call(t,e)}e.exports=function(t,e,r,o){e=e||"&",r=r||"=";var s={};if("string"!=typeof t||0===t.length)return s;var a=/\+/g;t=t.split(e);var u=1e3;o&&"number"==typeof o.maxKeys&&(u=o.maxKeys);var c=t.length;u>0&&c>u&&(c=u);for(var h=0;c>h;++h){var f,l,p,d,g=t[h].replace(a,"%20"),b=g.indexOf(r);b>=0?(f=g.substr(0,b),l=g.substr(b+1)):(f=g,l=""),p=decodeURIComponent(f),d=decodeURIComponent(l),n(s,p)?i(s[p])?s[p].push(d):s[p]=[s[p],d]:s[p]=d}return s};var i=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)}},{}],10:[function(t,e,r){"use strict";function n(t,e){if(t.map)return t.map(e);for(var r=[],n=0;n<t.length;n++)r.push(e(t[n],n));return r}var i=function(t){switch(typeof t){case"string":return t;case"boolean":return t?"true":"false";case"number":return isFinite(t)?t:"";default:return""}};e.exports=function(t,e,r,a){return e=e||"&",r=r||"=",null===t&&(t=void 0),"object"==typeof t?n(s(t),function(s){var a=encodeURIComponent(i(s))+r;return o(t[s])?n(t[s],function(t){return a+encodeURIComponent(i(t))}).join(e):a+encodeURIComponent(i(t[s]))}).join(e):a?encodeURIComponent(i(a))+r+encodeURIComponent(i(t)):""};var o=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)},s=Object.keys||function(t){var e=[];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&e.push(r);return e}},{}],11:[function(t,e,r){"use strict";r.decode=r.parse=t("./decode"),r.encode=r.stringify=t("./encode")},{"./decode":9,"./encode":10}],12:[function(t,e,r){"use strict";function n(){
this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}function i(t,e,r){if(t&&c.isObject(t)&&t instanceof n)return t;var i=new n;return i.parse(t,e,r),i}function o(t){return c.isString(t)&&(t=i(t)),t instanceof n?t.format():n.prototype.format.call(t)}function s(t,e){return i(t,!1,!0).resolve(e)}function a(t,e){return t?i(t,!1,!0).resolveObject(e):e}var u=t("punycode"),c=t("./util");r.parse=i,r.resolve=s,r.resolveObject=a,r.format=o,r.Url=n;var h=/^([a-z0-9.+-]+:)/i,f=/:[0-9]*$/,l=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,p=["<",">",'"',"`"," ","\r","\n","	"],d=["{","}","|","\\","^","`"].concat(p),g=["'"].concat(d),b=["%","/","?",";","#"].concat(g),m=["/","?","#"],y=255,v=/^[+a-z0-9A-Z_-]{0,63}$/,_=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,w={javascript:!0,"javascript:":!0},S={javascript:!0,"javascript:":!0},E={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},k=t("querystring");n.prototype.parse=function(t,e,r){if(!c.isString(t))throw new TypeError("Parameter 'url' must be a string, not "+typeof t);var n=t.indexOf("?"),i=-1!==n&&n<t.indexOf("#")?"?":"#",o=t.split(i),s=/\\/g;o[0]=o[0].replace(s,"/"),t=o.join(i);var a=t;if(a=a.trim(),!r&&1===t.split("#").length){var f=l.exec(a);if(f)return this.path=a,this.href=a,this.pathname=f[1],f[2]?(this.search=f[2],e?this.query=k.parse(this.search.substr(1)):this.query=this.search.substr(1)):e&&(this.search="",this.query={}),this}var p=h.exec(a);if(p){p=p[0];var d=p.toLowerCase();this.protocol=d,a=a.substr(p.length)}if(r||p||a.match(/^\/\/[^@\/]+@[^@\/]+/)){var I="//"===a.substr(0,2);!I||p&&S[p]||(a=a.substr(2),this.slashes=!0)}if(!S[p]&&(I||p&&!E[p])){for(var x=-1,A=0;A<m.length;A++){var T=a.indexOf(m[A]);-1!==T&&(-1===x||x>T)&&(x=T)}var M,C;C=-1===x?a.lastIndexOf("@"):a.lastIndexOf("@",x),-1!==C&&(M=a.slice(0,C),a=a.slice(C+1),this.auth=decodeURIComponent(M)),x=-1;for(var A=0;A<b.length;A++){var T=a.indexOf(b[A]);-1!==T&&(-1===x||x>T)&&(x=T)}-1===x&&(x=a.length),this.host=a.slice(0,x),a=a.slice(x),this.parseHost(),this.hostname=this.hostname||"";var j="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!j)for(var L=this.hostname.split(/\./),A=0,O=L.length;O>A;A++){var R=L[A];if(R&&!R.match(v)){for(var U="",B=0,N=R.length;N>B;B++)U+=R.charCodeAt(B)>127?"x":R[B];if(!U.match(v)){var q=L.slice(0,A),P=L.slice(A+1),D=R.match(_);D&&(q.push(D[1]),P.unshift(D[2])),P.length&&(a="/"+P.join(".")+a),this.hostname=q.join(".");break}}}this.hostname.length>y?this.hostname="":this.hostname=this.hostname.toLowerCase(),j||(this.hostname=u.toASCII(this.hostname));var W=this.port?":"+this.port:"",F=this.hostname||"";this.host=F+W,this.href+=this.host,j&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==a[0]&&(a="/"+a))}if(!w[d])for(var A=0,O=g.length;O>A;A++){var H=g[A];if(-1!==a.indexOf(H)){var z=encodeURIComponent(H);z===H&&(z=escape(H)),a=a.split(H).join(z)}}var K=a.indexOf("#");-1!==K&&(this.hash=a.substr(K),a=a.slice(0,K));var Q=a.indexOf("?");if(-1!==Q?(this.search=a.substr(Q),this.query=a.substr(Q+1),e&&(this.query=k.parse(this.query)),a=a.slice(0,Q)):e&&(this.search="",this.query={}),a&&(this.pathname=a),E[d]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){var W=this.pathname||"",V=this.search||"";this.path=W+V}return this.href=this.format(),this},n.prototype.format=function(){var t=this.auth||"";t&&(t=encodeURIComponent(t),t=t.replace(/%3A/i,":"),t+="@");var e=this.protocol||"",r=this.pathname||"",n=this.hash||"",i=!1,o="";this.host?i=t+this.host:this.hostname&&(i=t+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(i+=":"+this.port)),this.query&&c.isObject(this.query)&&Object.keys(this.query).length&&(o=k.stringify(this.query));var s=this.search||o&&"?"+o||"";return e&&":"!==e.substr(-1)&&(e+=":"),this.slashes||(!e||E[e])&&i!==!1?(i="//"+(i||""),r&&"/"!==r.charAt(0)&&(r="/"+r)):i||(i=""),n&&"#"!==n.charAt(0)&&(n="#"+n),s&&"?"!==s.charAt(0)&&(s="?"+s),r=r.replace(/[?#]/g,function(t){return encodeURIComponent(t)}),s=s.replace("#","%23"),e+i+r+s+n},n.prototype.resolve=function(t){return this.resolveObject(i(t,!1,!0)).format()},n.prototype.resolveObject=function(t){if(c.isString(t)){var e=new n;e.parse(t,!1,!0),t=e}for(var r=new n,i=Object.keys(this),o=0;o<i.length;o++){var s=i[o];r[s]=this[s]}if(r.hash=t.hash,""===t.href)return r.href=r.format(),r;if(t.slashes&&!t.protocol){for(var a=Object.keys(t),u=0;u<a.length;u++){var h=a[u];"protocol"!==h&&(r[h]=t[h])}return E[r.protocol]&&r.hostname&&!r.pathname&&(r.path=r.pathname="/"),r.href=r.format(),r}if(t.protocol&&t.protocol!==r.protocol){if(!E[t.protocol]){for(var f=Object.keys(t),l=0;l<f.length;l++){var p=f[l];r[p]=t[p]}return r.href=r.format(),r}if(r.protocol=t.protocol,t.host||S[t.protocol])r.pathname=t.pathname;else{for(var d=(t.pathname||"").split("/");d.length&&!(t.host=d.shift()););t.host||(t.host=""),t.hostname||(t.hostname=""),""!==d[0]&&d.unshift(""),d.length<2&&d.unshift(""),r.pathname=d.join("/")}if(r.search=t.search,r.query=t.query,r.host=t.host||"",r.auth=t.auth,r.hostname=t.hostname||t.host,r.port=t.port,r.pathname||r.search){var g=r.pathname||"",b=r.search||"";r.path=g+b}return r.slashes=r.slashes||t.slashes,r.href=r.format(),r}var m=r.pathname&&"/"===r.pathname.charAt(0),y=t.host||t.pathname&&"/"===t.pathname.charAt(0),v=y||m||r.host&&t.pathname,_=v,w=r.pathname&&r.pathname.split("/")||[],d=t.pathname&&t.pathname.split("/")||[],k=r.protocol&&!E[r.protocol];if(k&&(r.hostname="",r.port=null,r.host&&(""===w[0]?w[0]=r.host:w.unshift(r.host)),r.host="",t.protocol&&(t.hostname=null,t.port=null,t.host&&(""===d[0]?d[0]=t.host:d.unshift(t.host)),t.host=null),v=v&&(""===d[0]||""===w[0])),y)r.host=t.host||""===t.host?t.host:r.host,r.hostname=t.hostname||""===t.hostname?t.hostname:r.hostname,r.search=t.search,r.query=t.query,w=d;else if(d.length)w||(w=[]),w.pop(),w=w.concat(d),r.search=t.search,r.query=t.query;else if(!c.isNullOrUndefined(t.search)){if(k){r.hostname=r.host=w.shift();var I=r.host&&r.host.indexOf("@")>0?r.host.split("@"):!1;I&&(r.auth=I.shift(),r.host=r.hostname=I.shift())}return r.search=t.search,r.query=t.query,c.isNull(r.pathname)&&c.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.href=r.format(),r}if(!w.length)return r.pathname=null,r.search?r.path="/"+r.search:r.path=null,r.href=r.format(),r;for(var x=w.slice(-1)[0],A=(r.host||t.host||w.length>1)&&("."===x||".."===x)||""===x,T=0,M=w.length;M>=0;M--)x=w[M],"."===x?w.splice(M,1):".."===x?(w.splice(M,1),T++):T&&(w.splice(M,1),T--);if(!v&&!_)for(;T--;T)w.unshift("..");!v||""===w[0]||w[0]&&"/"===w[0].charAt(0)||w.unshift(""),A&&"/"!==w.join("/").substr(-1)&&w.push("");var C=""===w[0]||w[0]&&"/"===w[0].charAt(0);if(k){r.hostname=r.host=C?"":w.length?w.shift():"";var I=r.host&&r.host.indexOf("@")>0?r.host.split("@"):!1;I&&(r.auth=I.shift(),r.host=r.hostname=I.shift())}return v=v||r.host&&w.length,v&&!C&&w.unshift(""),w.length?r.pathname=w.join("/"):(r.pathname=null,r.path=null),c.isNull(r.pathname)&&c.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.auth=t.auth||r.auth,r.slashes=r.slashes||t.slashes,r.href=r.format(),r},n.prototype.parseHost=function(){var t=this.host,e=f.exec(t);e&&(e=e[0],":"!==e&&(this.port=e.substr(1)),t=t.substr(0,t.length-e.length)),t&&(this.hostname=t)}},{"./util":13,punycode:8,querystring:11}],13:[function(t,e,r){"use strict";e.exports={isString:function(t){return"string"==typeof t},isObject:function(t){return"object"==typeof t&&null!==t},isNull:function(t){return null===t},isNullOrUndefined:function(t){return null==t}}},{}],14:[function(t,e,r){"function"==typeof Object.create?e.exports=function(t,e){t.super_=e,t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}})}:e.exports=function(t,e){t.super_=e;var r=function(){};r.prototype=e.prototype,t.prototype=new r,t.prototype.constructor=t}},{}],15:[function(t,e,r){e.exports=function(t){return t&&"object"==typeof t&&"function"==typeof t.copy&&"function"==typeof t.fill&&"function"==typeof t.readUInt8}},{}],16:[function(t,e,r){(function(e,n){function i(t,e){var n={seen:[],stylize:s};return arguments.length>=3&&(n.depth=arguments[2]),arguments.length>=4&&(n.colors=arguments[3]),g(e)?n.showHidden=e:e&&r._extend(n,e),w(n.showHidden)&&(n.showHidden=!1),w(n.depth)&&(n.depth=2),w(n.colors)&&(n.colors=!1),w(n.customInspect)&&(n.customInspect=!0),n.colors&&(n.stylize=o),u(n,t,n.depth)}function o(t,e){var r=i.styles[e];return r?"["+i.colors[r][0]+"m"+t+"["+i.colors[r][1]+"m":t}function s(t,e){return t}function a(t){var e={};return t.forEach(function(t,r){e[t]=!0}),e}function u(t,e,n){if(t.customInspect&&e&&x(e.inspect)&&e.inspect!==r.inspect&&(!e.constructor||e.constructor.prototype!==e)){var i=e.inspect(n,t);return v(i)||(i=u(t,i,n)),i}var o=c(t,e);if(o)return o;var s=Object.keys(e),g=a(s);if(t.showHidden&&(s=Object.getOwnPropertyNames(e)),I(e)&&(s.indexOf("message")>=0||s.indexOf("description")>=0))return h(e);if(0===s.length){if(x(e)){var b=e.name?": "+e.name:"";return t.stylize("[Function"+b+"]","special")}if(S(e))return t.stylize(RegExp.prototype.toString.call(e),"regexp");if(k(e))return t.stylize(Date.prototype.toString.call(e),"date");if(I(e))return h(e)}var m="",y=!1,_=["{","}"];if(d(e)&&(y=!0,_=["[","]"]),x(e)){var w=e.name?": "+e.name:"";m=" [Function"+w+"]"}if(S(e)&&(m=" "+RegExp.prototype.toString.call(e)),k(e)&&(m=" "+Date.prototype.toUTCString.call(e)),I(e)&&(m=" "+h(e)),0===s.length&&(!y||0==e.length))return _[0]+m+_[1];if(0>n)return S(e)?t.stylize(RegExp.prototype.toString.call(e),"regexp"):t.stylize("[Object]","special");t.seen.push(e);var E;return E=y?f(t,e,n,g,s):s.map(function(r){return l(t,e,n,g,r,y)}),t.seen.pop(),p(E,m,_)}function c(t,e){if(w(e))return t.stylize("undefined","undefined");if(v(e)){var r="'"+JSON.stringify(e).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return t.stylize(r,"string")}return y(e)?t.stylize(""+e,"number"):g(e)?t.stylize(""+e,"boolean"):b(e)?t.stylize("null","null"):void 0}function h(t){return"["+Error.prototype.toString.call(t)+"]"}function f(t,e,r,n,i){for(var o=[],s=0,a=e.length;a>s;++s)j(e,String(s))?o.push(l(t,e,r,n,String(s),!0)):o.push("");return i.forEach(function(i){i.match(/^\d+$/)||o.push(l(t,e,r,n,i,!0))}),o}function l(t,e,r,n,i,o){var s,a,c;if(c=Object.getOwnPropertyDescriptor(e,i)||{value:e[i]},c.get?a=c.set?t.stylize("[Getter/Setter]","special"):t.stylize("[Getter]","special"):c.set&&(a=t.stylize("[Setter]","special")),j(n,i)||(s="["+i+"]"),a||(t.seen.indexOf(c.value)<0?(a=b(r)?u(t,c.value,null):u(t,c.value,r-1),a.indexOf("\n")>-1&&(a=o?a.split("\n").map(function(t){return"  "+t}).join("\n").substr(2):"\n"+a.split("\n").map(function(t){return"   "+t}).join("\n"))):a=t.stylize("[Circular]","special")),w(s)){if(o&&i.match(/^\d+$/))return a;s=JSON.stringify(""+i),s.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)?(s=s.substr(1,s.length-2),s=t.stylize(s,"name")):(s=s.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'"),s=t.stylize(s,"string"))}return s+": "+a}function p(t,e,r){var n=0,i=t.reduce(function(t,e){return n++,e.indexOf("\n")>=0&&n++,t+e.replace(/\u001b\[\d\d?m/g,"").length+1},0);return i>60?r[0]+(""===e?"":e+"\n ")+" "+t.join(",\n  ")+" "+r[1]:r[0]+e+" "+t.join(", ")+" "+r[1]}function d(t){return Array.isArray(t)}function g(t){return"boolean"==typeof t}function b(t){return null===t}function m(t){return null==t}function y(t){return"number"==typeof t}function v(t){return"string"==typeof t}function _(t){return"symbol"==typeof t}function w(t){return void 0===t}function S(t){return E(t)&&"[object RegExp]"===T(t)}function E(t){return"object"==typeof t&&null!==t}function k(t){return E(t)&&"[object Date]"===T(t)}function I(t){return E(t)&&("[object Error]"===T(t)||t instanceof Error)}function x(t){return"function"==typeof t}function A(t){return null===t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||"symbol"==typeof t||"undefined"==typeof t}function T(t){return Object.prototype.toString.call(t)}function M(t){return 10>t?"0"+t.toString(10):t.toString(10)}function C(){var t=new Date,e=[M(t.getHours()),M(t.getMinutes()),M(t.getSeconds())].join(":");return[t.getDate(),U[t.getMonth()],e].join(" ")}function j(t,e){return Object.prototype.hasOwnProperty.call(t,e)}var L=/%[sdj%]/g;r.format=function(t){if(!v(t)){for(var e=[],r=0;r<arguments.length;r++)e.push(i(arguments[r]));return e.join(" ")}for(var r=1,n=arguments,o=n.length,s=String(t).replace(L,function(t){if("%%"===t)return"%";if(r>=o)return t;switch(t){case"%s":return String(n[r++]);case"%d":return Number(n[r++]);case"%j":try{return JSON.stringify(n[r++])}catch(e){return"[Circular]"}default:return t}}),a=n[r];o>r;a=n[++r])s+=b(a)||!E(a)?" "+a:" "+i(a);return s},r.deprecate=function(t,i){function o(){if(!s){if(e.throwDeprecation)throw new Error(i);e.traceDeprecation?console.trace(i):console.error(i),s=!0}return t.apply(this,arguments)}if(w(n.process))return function(){return r.deprecate(t,i).apply(this,arguments)};if(e.noDeprecation===!0)return t;var s=!1;return o};var O,R={};r.debuglog=function(t){if(w(O)&&(O=e.env.NODE_DEBUG||""),t=t.toUpperCase(),!R[t])if(new RegExp("\\b"+t+"\\b","i").test(O)){var n=e.pid;R[t]=function(){var e=r.format.apply(r,arguments);console.error("%s %d: %s",t,n,e)}}else R[t]=function(){};return R[t]},r.inspect=i,i.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},i.styles={special:"cyan",number:"yellow","boolean":"yellow",undefined:"grey","null":"bold",string:"green",date:"magenta",regexp:"red"},r.isArray=d,r.isBoolean=g,r.isNull=b,r.isNullOrUndefined=m,r.isNumber=y,r.isString=v,r.isSymbol=_,r.isUndefined=w,r.isRegExp=S,r.isObject=E,r.isDate=k,r.isError=I,r.isFunction=x,r.isPrimitive=A,r.isBuffer=t("./support/isBuffer");var U=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];r.log=function(){console.log("%s - %s",C(),r.format.apply(r,arguments))},r.inherits=t("inherits"),r._extend=function(t,e){if(!e||!E(e))return t;for(var r=Object.keys(e),n=r.length;n--;)t[r[n]]=e[r[n]];return t}}).call(this,t("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./support/isBuffer":15,_process:7,inherits:14}],17:[function(t,e,r){(function(r,n){"use strict";function i(){return"mqttjs_"+Math.random().toString(16).substr(2,8)}function o(t,e,r){t.emit("packetsend",e);var n=l.writeToStream(e,t.stream);!n&&r?t.stream.once("drain",r):r&&r()}function s(t,e,r){t.outgoingStore.put(e,function(n){return n?r&&r(n):void o(t,e,r)})}function a(){}function u(t,e){var r,n=this;if(!(this instanceof u))return new u(t,e);this.options=e||{};for(r in v)"undefined"==typeof this.options[r]?this.options[r]=v[r]:this.options[r]=e[r];this.options.clientId=this.options.clientId||i(),this.streamBuilder=t,this.outgoingStore=this.options.outgoingStore||new h,this.incomingStore=this.options.incomingStore||new h,this.queueQoSZero=void 0===this.options.queueQoSZero?!0:this.options.queueQoSZero,this._resubscribeTopics={},this.messageIdToTopic={},this.pingTimer=null,this.connected=!1,this.disconnecting=!1,this.queue=[],this.connackTimer=null,this.reconnectTimer=null,this.nextId=Math.floor(65535*Math.random()),this.outgoing={},this.on("connect",function(){if(!this.disconnected){this.connected=!0;var t=null;t=this.outgoingStore.createStream(),t.once("readable",function(){function e(){var r,i=t.read(1);i&&(!n.disconnecting&&!n.reconnectTimer&&n.options.reconnectPeriod>0?(t.read(0),r=n.outgoing[i.messageId],n.outgoing[i.messageId]=function(t,n){r&&r(t,n),e()},n._sendPacket(i)):t.destroy&&t.destroy())}e()}).on("error",this.emit.bind(this,"error"))}}),this.on("close",function(){this.connected=!1,clearTimeout(this.connackTimer)}),this.on("connect",this._setupPingTimer),this.on("connect",function(){function t(){var r=e.shift(),i=null;r&&(i=r.packet,n._sendPacket(i,function(e){r.cb&&r.cb(e),t()}))}var e=this.queue;t()});var o=!0;this.on("connect",function(){!o&&this.options.clean&&Object.keys(this._resubscribeTopics).length>0&&(this.options.resubscribe?(this._resubscribeTopics.resubscribe=!0,this.subscribe(this._resubscribeTopics)):this._resubscribeTopics={}),o=!1}),this.on("close",function(){null!==n.pingTimer&&(n.pingTimer.clear(),n.pingTimer=null)}),this.on("close",this._setupReconnect),c.EventEmitter.call(this),this._setupStream()}var c=t("events"),h=t("./store"),f=t("end-of-stream"),l=t("mqtt-packet"),p=t("readable-stream").Writable,d=t("inherits"),g=t("reinterval"),b=t("./validations"),m=t("xtend"),y=n.setImmediate||function(t){r.nextTick(t)},v={keepalive:60,reschedulePings:!0,protocolId:"MQTT",protocolVersion:4,reconnectPeriod:1e3,connectTimeout:3e4,clean:!0,resubscribe:!0};d(u,c.EventEmitter),u.prototype._setupStream=function(){function t(){var e=u.shift(),n=s;e?r._handlePacket(e,t):(s=null,n())}var e,r=this,n=new p,i=l.parser(this.options),s=null,u=[];this._clearReconnect(),this.stream=this.streamBuilder(this),i.on("packet",function(t){u.push(t)}),n._write=function(e,r,n){s=n,i.parse(e),t()},this.stream.pipe(n),this.stream.on("error",a),f(this.stream,this.emit.bind(this,"close")),e=Object.create(this.options),e.cmd="connect",o(this,e),i.on("error",this.emit.bind(this,"error")),this.stream.setMaxListeners(1e3),clearTimeout(this.connackTimer),this.connackTimer=setTimeout(function(){r._cleanUp(!0)},this.options.connectTimeout)},u.prototype._handlePacket=function(t,e){switch(this.emit("packetreceive",t),t.cmd){case"publish":this._handlePublish(t,e);break;case"puback":case"pubrec":case"pubcomp":case"suback":case"unsuback":this._handleAck(t),e();break;case"pubrel":this._handlePubrel(t,e);break;case"connack":this._handleConnack(t),e();break;case"pingresp":this._handlePingresp(t),e()}},u.prototype._checkDisconnecting=function(t){return this.disconnecting&&(t?t(new Error("client disconnecting")):this.emit("error",new Error("client disconnecting"))),this.disconnecting},u.prototype.publish=function(t,e,r,n){var i;"function"==typeof r&&(n=r,r=null);var o={qos:0,retain:!1,dup:!1};if(r=m(o,r),this._checkDisconnecting(n))return this;switch(i={cmd:"publish",topic:t,payload:e,qos:r.qos,retain:r.retain,messageId:this._nextId(),dup:r.dup},r.qos){case 1:case 2:this.outgoing[i.messageId]=n||a,this._sendPacket(i);break;default:this._sendPacket(i,n)}return this},u.prototype.subscribe=function(){var t,e,r=Array.prototype.slice.call(arguments),n=[],i=r.shift(),o=i.resubscribe,s=r.pop()||a,u=r.pop(),c=this;if(delete i.resubscribe,"string"==typeof i&&(i=[i]),"function"!=typeof s&&(u=s,s=a),e=b.validateTopics(i),null!==e)return y(s,new Error("Invalid topic "+e)),this;if(this._checkDisconnecting(s))return this;var h={qos:0};if(u=m(h,u),Array.isArray(i)?i.forEach(function(t){(c._resubscribeTopics[t]<u.qos||!c._resubscribeTopics.hasOwnProperty(t)||o)&&n.push({topic:t,qos:u.qos})}):Object.keys(i).forEach(function(t){(c._resubscribeTopics[t]<i[t]||!c._resubscribeTopics.hasOwnProperty(t)||o)&&n.push({topic:t,qos:i[t]})}),t={cmd:"subscribe",subscriptions:n,qos:1,retain:!1,dup:!1,messageId:this._nextId()},!n.length)return void s(null,[]);if(this.options.resubscribe){var f=[];n.forEach(function(t){c.options.reconnectPeriod>0&&(c._resubscribeTopics[t.topic]=t.qos,f.push(t.topic))}),c.messageIdToTopic[t.messageId]=f}return this.outgoing[t.messageId]=function(t,e){if(!t)for(var r=e.granted,i=0;i<r.length;i+=1)n[i].qos=r[i];s(t,n)},this._sendPacket(t),this},u.prototype.unsubscribe=function(t,e){var r={cmd:"unsubscribe",qos:1,messageId:this._nextId()},n=this;return e=e||a,this._checkDisconnecting(e)?this:("string"==typeof t?r.unsubscriptions=[t]:"object"==typeof t&&t.length&&(r.unsubscriptions=t),this.options.resubscribe&&r.unsubscriptions.forEach(function(t){delete n._resubscribeTopics[t]}),this.outgoing[r.messageId]=e,this._sendPacket(r),this)},u.prototype.end=function(t,e){function r(){i.disconnected=!0,i.incomingStore.close(function(){i.outgoingStore.close(e)})}function n(){i._cleanUp(t,y.bind(null,r))}var i=this;return"function"==typeof t&&(e=t,t=!1),this.disconnecting?this:(this._clearReconnect(),this.disconnecting=!0,!t&&Object.keys(this.outgoing).length>0?this.once("outgoingEmpty",setTimeout.bind(null,n,10)):n(),this)},u.prototype.removeOutgoingMessage=function(t){var e=this.outgoing[t];return delete this.outgoing[t],this.outgoingStore.del({messageId:t},function(){e(new Error("Message removed"))}),this},u.prototype.reconnect=function(){return this.disconnecting=!1,this.disconnected=!1,this._reconnect(),this},u.prototype._reconnect=function(){this.emit("reconnect"),this._setupStream()},u.prototype._setupReconnect=function(){var t=this;!t.disconnecting&&!t.reconnectTimer&&t.options.reconnectPeriod>0&&(this.reconnecting||(this.emit("offline"),this.reconnecting=!0),t.reconnectTimer=setInterval(function(){t._reconnect()},t.options.reconnectPeriod))},u.prototype._clearReconnect=function(){this.reconnectTimer&&(clearInterval(this.reconnectTimer),this.reconnectTimer=null)},u.prototype._cleanUp=function(t,e){e&&this.stream.on("close",e),t?this.stream.destroy():this._sendPacket({cmd:"disconnect"},y.bind(null,this.stream.end.bind(this.stream))),this.disconnecting||(this._clearReconnect(),this._setupReconnect()),null!==this.pingTimer&&(this.pingTimer.clear(),this.pingTimer=null)},u.prototype._sendPacket=function(t,e){if(!this.connected)return void(0===(t.qos||0)&&this.queueQoSZero||"publish"!==t.cmd?this.queue.push({packet:t,cb:e}):t.qos>0?this.outgoingStore.put(t,function(t){return t?e&&e(t):void 0}):e&&e(new Error("No connection to broker")));if(this._shiftPingInterval(),"publish"!==t.cmd)return void o(this,t,e);switch(t.qos){case 2:case 1:s(this,t,e);break;case 0:default:o(this,t,e)}},u.prototype._setupPingTimer=function(){var t=this;!this.pingTimer&&this.options.keepalive&&(this.pingResp=!0,this.pingTimer=g(function(){t._checkPing()},1e3*this.options.keepalive))},u.prototype._shiftPingInterval=function(){this.pingTimer&&this.options.keepalive&&this.options.reschedulePings&&this.pingTimer.reschedule(1e3*this.options.keepalive)},u.prototype._checkPing=function(){this.pingResp?(this.pingResp=!1,this._sendPacket({cmd:"pingreq"})):this._cleanUp(!0)},u.prototype._handlePingresp=function(){this.pingResp=!0},u.prototype._handleConnack=function(t){var e=t.returnCode,r=["","Unacceptable protocol version","Identifier rejected","Server unavailable","Bad username or password","Not authorized"];if(clearTimeout(this.connackTimer),0===e)this.reconnecting=!1,this.emit("connect",t);else if(e>0){var n=new Error("Connection refused: "+r[e]);n.code=e,this.emit("error",n)}},u.prototype._handlePublish=function(t,e){var r=t.topic.toString(),n=t.payload,i=t.qos,o=t.messageId,s=this;switch(i){case 2:this.incomingStore.put(t,function(){s._sendPacket({cmd:"pubrec",messageId:o},e)});break;case 1:this.emit("message",r,n,t),this.handleMessage(t,function(t){return t?void e(t):void s._sendPacket({cmd:"puback",messageId:o},e)});break;case 0:this.emit("message",r,n,t),this.handleMessage(t,e)}},u.prototype.handleMessage=function(t,e){e()},u.prototype._handleAck=function(t){var e=t.messageId,r=t.cmd,n=null,i=this.outgoing[e],o=this;if(i){switch(r){case"pubcomp":case"puback":delete this.outgoing[e],this.outgoingStore.del(t,i);break;case"pubrec":n={cmd:"pubrel",qos:2,messageId:e},this._sendPacket(n);break;case"suback":if(delete this.outgoing[e],1===t.granted.length&&0!==(128&t.granted[0])){var s=this.messageIdToTopic[e];s&&s.forEach(function(t){delete o._resubscribeTopics[t]})}i(null,t);break;case"unsuback":delete this.outgoing[e],i(null);break;default:o.emit("error",new Error("unrecognized packet type"))}this.disconnecting&&0===Object.keys(this.outgoing).length&&this.emit("outgoingEmpty")}},u.prototype._handlePubrel=function(t,e){var r=t.messageId,n=this,i={cmd:"pubcomp",messageId:r};n.incomingStore.get(t,function(r,o){r||"pubrel"===o.cmd?n._sendPacket(i,e):(n.emit("message",o.topic,o.payload,o),n.incomingStore.put(t),n.handleMessage(o,function(t){return t?void e(t):void n._sendPacket(i,e)}))})},u.prototype._nextId=function(){var t=this.nextId++;return 65535===t&&(this.nextId=1),t},u.prototype.getLastMessageId=function(){return 1===this.nextId?65535:this.nextId-1},e.exports=u}).call(this,t("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./store":22,"./validations":23,_process:7,"end-of-stream":28,events:4,inherits:29,"mqtt-packet":33,"readable-stream":49,reinterval:50,xtend:58}],18:[function(t,e,r){"use strict";function n(t,e){var r,n;return e.port=e.port||1883,e.hostname=e.hostname||e.host||"localhost",r=e.port,n=e.hostname,i.createConnection(r,n)}var i=t("net");e.exports=n},{net:2}],19:[function(t,e,r){"use strict";function n(t,e){function r(r){e.rejectUnauthorized&&t.emit("error",r),n.end()}var n;return e.port=e.port||8883,e.host=e.hostname||e.host||"localhost",e.rejectUnauthorized=e.rejectUnauthorized!==!1,delete e.path,n=i.connect(e),n.on("secureConnect",function(){e.rejectUnauthorized&&!n.authorized?n.emit("error",new Error("TLS not authorized")):n.removeListener("error",r)}),n.on("error",r),n}var i=t("tls");e.exports=n},{tls:2}],20:[function(t,e,r){(function(r){"use strict";function n(t,e){var r=t.protocol+"://"+t.hostname+":"+t.port+t.path;return"function"==typeof t.transformWsUrl&&(r=t.transformWsUrl(r,t,e)),r}function i(t){t.hostname||(t.hostname="localhost"),t.port||("wss"===t.protocol?t.port=443:t.port=80),t.path||(t.path="/"),t.wsOptions||(t.wsOptions={}),f||"wss"!==t.protocol||h.forEach(function(e){t.hasOwnProperty(e)&&!t.wsOptions.hasOwnProperty(e)&&(t.wsOptions[e]=t[e])})}function o(t,e){var r="MQIsdp"===e.protocolId&&3===e.protocolVersion?"mqttv3.1":"mqtt";i(e);var o=n(e,t);return u(o,[r],e.wsOptions)}function s(t,e){return o(t,e)}function a(t,e){if(e.hostname||(e.hostname=e.host),!e.hostname){if("undefined"==typeof document)throw new Error("Could not determine host. Specify host manually.");var r=c.parse(document.URL);e.hostname=r.hostname,e.port||(e.port=r.port)}return o(t,e)}var u=t("websocket-stream"),c=t("url"),h=["rejectUnauthorized","ca","cert","key","pfx","passphrase"],f="browser"===r.title;f?e.exports=a:e.exports=s}).call(this,t("_process"))},{_process:7,url:12,"websocket-stream":55}],21:[function(t,e,r){"use strict";function n(t){c?wx.sendSocketMessage({data:t}):h.push(t)}function i(t,e){console.log("creating WebSocket...",arguments);var r={OPEN:1,CLOSING:2,CLOSED:3,readyState:c?1:0,send:n,close:wx.closeSocket,onopen:null,onmessage:null,onclose:null,onerror:null};return wx.connectSocket({url:t,protocols:e}),wx.onSocketOpen(function(t){r.readyState=r.OPEN,c=!0;for(var e=0;e<h.length;e++)n(h[e]);h=[],r.onopen&&r.onopen.apply(r,arguments)}),wx.onSocketMessage(function(t){r.onmessage&&r.onmessage.apply(r,arguments)}),wx.onSocketClose(function(){r.readyState=r.CLOSED,r.onclose&&r.onclose.apply(r,arguments)}),wx.onSocketError(function(){r.onerror&&r.onerror.apply(r,arguments)}),r}function o(t,e){var r="wxs"===t.protocol?"wss":"ws",n=r+"://"+t.hostname+":"+t.port+t.path;return"function"==typeof t.transformWsUrl&&(n=t.transformWsUrl(n,t,e)),n}function s(t){t.hostname||(t.hostname="localhost"),t.port||("wss"===t.protocol?t.port=443:t.port=80),t.path||(t.path="/"),t.wsOptions||(t.wsOptions={})}function a(t,e){var r="MQIsdp"===e.protocolId&&3===e.protocolVersion?"mqttv3.1":"mqtt";s(e);var n=o(e,t);return f(i(n,[r]))}function u(t,e){if(e.hostname||(e.hostname=e.host),!e.hostname){if("undefined"==typeof document)throw new Error("Could not determine host. Specify host manually.");var r=l.parse(document.URL);e.hostname=r.hostname,e.port||(e.port=r.port)}return a(t,e)}var c=!1,h=[],f=t("websocket-stream"),l=t("url");e.exports=u},{url:12,"websocket-stream":55}],22:[function(t,e,r){(function(r){"use strict";function n(t){return this instanceof n?(this.options=t||{},this.options=i(a,t),void(this._inflights={})):new n(t)}var i=t("xtend"),o=t("readable-stream").Readable,s={objectMode:!0},a={clean:!0};n.prototype.put=function(t,e){return this._inflights[t.messageId]=t,e&&e(),this},n.prototype.createStream=function(){var t=new o(s),e=this._inflights,n=Object.keys(this._inflights),i=!1,a=0;return t._read=function(){!i&&a<n.length?this.push(e[n[a++]]):this.push(null)},t.destroy=function(){if(!i){var t=this;i=!0,r.nextTick(function(){t.emit("close")})}},t},n.prototype.del=function(t,e){return t=this._inflights[t.messageId],t?(delete this._inflights[t.messageId],e(null,t)):e&&e(new Error("missing packet")),this},n.prototype.get=function(t,e){return t=this._inflights[t.messageId],t?e(null,t):e&&e(new Error("missing packet")),this},n.prototype.close=function(t){this.options.clean&&(this._inflights=null),t&&t()},e.exports=n}).call(this,t("_process"))},{_process:7,"readable-stream":49,xtend:58}],23:[function(t,e,r){"use strict";function n(t){for(var e=t.split("/"),r=0;r<e.length;r++)if("+"!==e[r]){if("#"===e[r])return r===e.length-1;if(-1!==e[r].indexOf("+")||-1!==e[r].indexOf("#"))return!1}return!0}function i(t){if(0===t.length)return"empty_topic_list";for(var e=0;e<t.length;e++)if(!n(t[e]))return t[e];return null}e.exports={validateTopics:i}},{}],24:[function(t,e,r){(function(r){"use strict";function n(t){var e;t.auth&&(e=t.auth.match(/^(.+):(.+)$/),e?(t.username=e[1],t.password=e[2]):t.username=t.auth)}function i(t,e){function r(t){return e.servers&&(t._reconnectCount&&t._reconnectCount!==e.servers.length||(t._reconnectCount=0),e.host=e.servers[t._reconnectCount].host,e.port=e.servers[t._reconnectCount].port,e.hostname=e.host,t._reconnectCount++),u[e.protocol](t,e)}if("object"!=typeof t||e||(e=t,t=null),e=e||{},t){var i=s.parse(t,!0);if(null!=i.port&&(i.port=Number(i.port)),e=a(i,e),null===e.protocol)throw new Error("Missing protocol");e.protocol=e.protocol.replace(/:$/,"")}if(n(e),e.query&&"string"==typeof e.query.clientId&&(e.clientId=e.query.clientId),e.cert&&e.key){if(!e.protocol)throw new Error("Missing secure protocol key");if(-1===["mqtts","wss","wxs"].indexOf(e.protocol))switch(e.protocol){case"mqtt":e.protocol="mqtts";break;case"ws":e.protocol="wss";break;case"wx":e.protocol="wxs";break;default:throw new Error('Unknown protocol for secure connection: "'+e.protocol+'"!')}}if(!u[e.protocol]){var c=-1!==["mqtts","wss"].indexOf(e.protocol);e.protocol=["mqtt","mqtts","ws","wss","wx","wxs"].filter(function(t,e){return c&&e%2===0?!1:"function"==typeof u[t]})[0]}if(e.clean===!1&&!e.clientId)throw new Error("Missing clientId for unclean clients");return new o(r,e)}var o=t("../client"),s=t("url"),a=t("xtend"),u={};"browser"!==r.title?(u.mqtt=t("./tcp"),u.tcp=t("./tcp"),u.ssl=t("./tls"),u.tls=t("./tls"),u.mqtts=t("./tls")):(u.wx=t("./wx"),u.wxs=t("./wx")),u.ws=t("./ws"),u.wss=t("./ws"),e.exports=i,e.exports.connect=i,e.exports.MqttClient=o}).call(this,t("_process"))},{"../client":17,"./tcp":18,"./tls":19,"./ws":20,"./wx":21,_process:7,url:12,xtend:58}],25:[function(t,e,r){(function(r){function n(t){if(!(this instanceof n))return new n(t);if(this._bufs=[],this.length=0,"function"==typeof t){this._callback=t;var e=function(t){this._callback&&(this._callback(t),this._callback=null)}.bind(this);this.on("pipe",function(t){t.on("error",e)}),this.on("unpipe",function(t){t.removeListener("error",e)})}else this.append(t);i.call(this)}var i=t("readable-stream/duplex"),o=t("util");o.inherits(n,i),n.prototype._offset=function(t){var e,r=0,n=0;if(0===t)return[0,0];for(;n<this._bufs.length;n++){if(e=r+this._bufs[n].length,e>t||n==this._bufs.length-1)return[n,t-r];r=e}},n.prototype.append=function(t){var e=0;if(r.isBuffer(t))this._appendBuffer(t);else if(Array.isArray(t))for(;e<t.length;e++)this.append(t[e]);else if(t instanceof n)for(;e<t._bufs.length;e++)this.append(t._bufs[e]);else null!=t&&("number"==typeof t&&(t=t.toString()),
this._appendBuffer(new r(t)));return this},n.prototype._appendBuffer=function(t){this._bufs.push(t),this.length+=t.length},n.prototype._write=function(t,e,r){this._appendBuffer(t),"function"==typeof r&&r()},n.prototype._read=function(t){return this.length?(t=Math.min(t,this.length),this.push(this.slice(0,t)),void this.consume(t)):this.push(null)},n.prototype.end=function(t){i.prototype.end.call(this,t),this._callback&&(this._callback(null,this.slice()),this._callback=null)},n.prototype.get=function(t){return this.slice(t,t+1)[0]},n.prototype.slice=function(t,e){return"number"==typeof t&&0>t&&(t+=this.length),"number"==typeof e&&0>e&&(e+=this.length),this.copy(null,0,t,e)},n.prototype.copy=function s(t,e,n,i){if(("number"!=typeof n||0>n)&&(n=0),("number"!=typeof i||i>this.length)&&(i=this.length),n>=this.length)return t||new r(0);if(0>=i)return t||new r(0);var o,a,s=!!t,u=this._offset(n),c=i-n,h=c,f=s&&e||0,l=u[1];if(0===n&&i==this.length){if(!s)return 1===this._bufs.length?this._bufs[0]:r.concat(this._bufs,this.length);for(a=0;a<this._bufs.length;a++)this._bufs[a].copy(t,f),f+=this._bufs[a].length;return t}if(h<=this._bufs[u[0]].length-l)return s?this._bufs[u[0]].copy(t,e,l,l+h):this._bufs[u[0]].slice(l,l+h);for(s||(t=new r(c)),a=u[0];a<this._bufs.length;a++){if(o=this._bufs[a].length-l,!(h>o)){this._bufs[a].copy(t,f,l,l+h);break}this._bufs[a].copy(t,f,l),f+=o,h-=o,l&&(l=0)}return t},n.prototype.shallowSlice=function(t,e){t=t||0,e=e||this.length,0>t&&(t+=this.length),0>e&&(e+=this.length);var r=this._offset(t),i=this._offset(e),o=this._bufs.slice(r[0],i[0]+1);return 0==i[1]?o.pop():o[o.length-1]=o[o.length-1].slice(0,i[1]),0!=r[1]&&(o[0]=o[0].slice(r[1])),new n(o)},n.prototype.toString=function(t,e,r){return this.slice(e,r).toString(t)},n.prototype.consume=function(t){for(;this._bufs.length;){if(!(t>=this._bufs[0].length)){this._bufs[0]=this._bufs[0].slice(t),this.length-=t;break}t-=this._bufs[0].length,this.length-=this._bufs[0].length,this._bufs.shift()}return this},n.prototype.duplicate=function(){for(var t=0,e=new n;t<this._bufs.length;t++)e.append(this._bufs[t]);return e},n.prototype.destroy=function(){this._bufs.length=0,this.length=0,this.push(null)},function(){var t={readDoubleBE:8,readDoubleLE:8,readFloatBE:4,readFloatLE:4,readInt32BE:4,readInt32LE:4,readUInt32BE:4,readUInt32LE:4,readInt16BE:2,readInt16LE:2,readUInt16BE:2,readUInt16LE:2,readInt8:1,readUInt8:1};for(var e in t)!function(e){n.prototype[e]=function(r){return this.slice(r,r+t[e])[e](0)}}(e)}(),e.exports=n}).call(this,t("buffer").Buffer)},{buffer:3,"readable-stream/duplex":40,util:16}],26:[function(t,e,r){(function(t){function e(t){return Array.isArray?Array.isArray(t):"[object Array]"===b(t)}function n(t){return"boolean"==typeof t}function i(t){return null===t}function o(t){return null==t}function s(t){return"number"==typeof t}function a(t){return"string"==typeof t}function u(t){return"symbol"==typeof t}function c(t){return void 0===t}function h(t){return"[object RegExp]"===b(t)}function f(t){return"object"==typeof t&&null!==t}function l(t){return"[object Date]"===b(t)}function p(t){return"[object Error]"===b(t)||t instanceof Error}function d(t){return"function"==typeof t}function g(t){return null===t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||"symbol"==typeof t||"undefined"==typeof t}function b(t){return Object.prototype.toString.call(t)}r.isArray=e,r.isBoolean=n,r.isNull=i,r.isNullOrUndefined=o,r.isNumber=s,r.isString=a,r.isSymbol=u,r.isUndefined=c,r.isRegExp=h,r.isObject=f,r.isDate=l,r.isError=p,r.isFunction=d,r.isPrimitive=g,r.isBuffer=t.isBuffer}).call(this,{isBuffer:t("C:/Users/lmak/AppData/Roaming/npm/node_modules/browserify/node_modules/is-buffer/index.js")})},{"C:/Users/lmak/AppData/Roaming/npm/node_modules/browserify/node_modules/is-buffer/index.js":6}],27:[function(t,e,r){(function(r,n){var i=t("readable-stream"),o=t("end-of-stream"),s=t("inherits"),a=t("stream-shift"),u=new n([0]),c=function(t,e){t._corked?t.once("uncork",e):e()},h=function(t,e){return function(r){r?t.destroy("premature close"===r.message?null:r):e&&!t._ended&&t.end()}},f=function(t,e){return t?t._writableState&&t._writableState.finished?e():t._writableState?t.end(e):(t.end(),void e()):e()},l=function(t){return new i.Readable({objectMode:!0,highWaterMark:16}).wrap(t)},p=function(t,e,r){return this instanceof p?(i.Duplex.call(this,r),this._writable=null,this._readable=null,this._readable2=null,this._forwardDestroy=!r||r.destroy!==!1,this._forwardEnd=!r||r.end!==!1,this._corked=1,this._ondrain=null,this._drained=!1,this._forwarding=!1,this._unwrite=null,this._unread=null,this._ended=!1,this.destroyed=!1,t&&this.setWritable(t),void(e&&this.setReadable(e))):new p(t,e,r)};s(p,i.Duplex),p.obj=function(t,e,r){return r||(r={}),r.objectMode=!0,r.highWaterMark=16,new p(t,e,r)},p.prototype.cork=function(){1===++this._corked&&this.emit("cork")},p.prototype.uncork=function(){this._corked&&0===--this._corked&&this.emit("uncork")},p.prototype.setWritable=function(t){if(this._unwrite&&this._unwrite(),this.destroyed)return void(t&&t.destroy&&t.destroy());if(null===t||t===!1)return void this.end();var e=this,n=o(t,{writable:!0,readable:!1},h(this,this._forwardEnd)),i=function(){var t=e._ondrain;e._ondrain=null,t&&t()},s=function(){e._writable.removeListener("drain",i),n()};this._unwrite&&r.nextTick(i),this._writable=t,this._writable.on("drain",i),this._unwrite=s,this.uncork()},p.prototype.setReadable=function(t){if(this._unread&&this._unread(),this.destroyed)return void(t&&t.destroy&&t.destroy());if(null===t||t===!1)return this.push(null),void this.resume();var e=this,r=o(t,{writable:!1,readable:!0},h(this)),n=function(){e._forward()},i=function(){e.push(null)},s=function(){e._readable2.removeListener("readable",n),e._readable2.removeListener("end",i),r()};this._drained=!0,this._readable=t,this._readable2=t._readableState?t:l(t),this._readable2.on("readable",n),this._readable2.on("end",i),this._unread=s,this._forward()},p.prototype._read=function(){this._drained=!0,this._forward()},p.prototype._forward=function(){if(!this._forwarding&&this._readable2&&this._drained){this._forwarding=!0;for(var t;this._drained&&null!==(t=a(this._readable2));)this.destroyed||(this._drained=this.push(t));this._forwarding=!1}},p.prototype.destroy=function(t){if(!this.destroyed){this.destroyed=!0;var e=this;r.nextTick(function(){e._destroy(t)})}},p.prototype._destroy=function(t){if(t){var e=this._ondrain;this._ondrain=null,e?e(t):this.emit("error",t)}this._forwardDestroy&&(this._readable&&this._readable.destroy&&this._readable.destroy(),this._writable&&this._writable.destroy&&this._writable.destroy()),this.emit("close")},p.prototype._write=function(t,e,r){return this.destroyed?r():this._corked?c(this,this._write.bind(this,t,e,r)):t===u?this._finish(r):this._writable?void(this._writable.write(t)===!1?this._ondrain=r:r()):r()},p.prototype._finish=function(t){var e=this;this.emit("preend"),c(this,function(){f(e._forwardEnd&&e._writable,function(){e._writableState.prefinished===!1&&(e._writableState.prefinished=!0),e.emit("prefinish"),c(e,t)})})},p.prototype.end=function(t,e,r){return"function"==typeof t?this.end(null,null,t):"function"==typeof e?this.end(t,null,e):(this._ended=!0,t&&this.write(t),this._writableState.ending||this.write(u),i.Writable.prototype.end.call(this,r))},e.exports=p}).call(this,t("_process"),t("buffer").Buffer)},{_process:7,buffer:3,"end-of-stream":28,inherits:29,"readable-stream":49,"stream-shift":52}],28:[function(t,e,r){var n=t("once"),i=function(){},o=function(t){return t.setHeader&&"function"==typeof t.abort},s=function(t){return t.stdio&&Array.isArray(t.stdio)&&3===t.stdio.length},a=function(t,e,r){if("function"==typeof e)return a(t,null,e);e||(e={}),r=n(r||i);var u=t._writableState,c=t._readableState,h=e.readable||e.readable!==!1&&t.readable,f=e.writable||e.writable!==!1&&t.writable,l=function(){t.writable||p()},p=function(){f=!1,h||r.call(t)},d=function(){h=!1,f||r.call(t)},g=function(e){r.call(t,e?new Error("exited with error code: "+e):null)},b=function(){return(!h||c&&c.ended)&&(!f||u&&u.ended)?void 0:r.call(t,new Error("premature close"))},m=function(){t.req.on("finish",p)};return o(t)?(t.on("complete",p),t.on("abort",b),t.req?m():t.on("request",m)):f&&!u&&(t.on("end",l),t.on("close",l)),s(t)&&t.on("exit",g),t.on("end",d),t.on("finish",p),e.error!==!1&&t.on("error",r),t.on("close",b),function(){t.removeListener("complete",p),t.removeListener("abort",b),t.removeListener("request",m),t.req&&t.req.removeListener("finish",p),t.removeListener("end",l),t.removeListener("close",l),t.removeListener("finish",p),t.removeListener("exit",g),t.removeListener("end",d),t.removeListener("error",r),t.removeListener("close",b)}};e.exports=a},{once:38}],29:[function(t,e,r){arguments[4][14][0].apply(r,arguments)},{dup:14}],30:[function(t,e,r){var n={}.toString;e.exports=Array.isArray||function(t){return"[object Array]"==n.call(t)}},{}],31:[function(t,e,r){"use strict";function n(t){return[0,1,2].map(function(e){return[0,1].map(function(r){return[0,1].map(function(n){var s=new i(1);return s.writeUInt8(o.codes[t]<<o.CMD_SHIFT|(r?o.DUP_MASK:0)|e<<o.QOS_SHIFT|n,0,!0),s})})})}var i=t("safe-buffer").Buffer,o=e.exports;o.types={0:"reserved",1:"connect",2:"connack",3:"publish",4:"puback",5:"pubrec",6:"pubrel",7:"pubcomp",8:"subscribe",9:"suback",10:"unsubscribe",11:"unsuback",12:"pingreq",13:"pingresp",14:"disconnect",15:"reserved"},o.codes={};for(var s in o.types){var a=o.types[s];o.codes[a]=s}o.CMD_SHIFT=4,o.CMD_MASK=240,o.DUP_MASK=8,o.QOS_MASK=3,o.QOS_SHIFT=1,o.RETAIN_MASK=1,o.LENGTH_MASK=127,o.LENGTH_FIN_MASK=128,o.SESSIONPRESENT_MASK=1,o.SESSIONPRESENT_HEADER=i.from([o.SESSIONPRESENT_MASK]),o.CONNACK_HEADER=i.from([o.codes.connack<<o.CMD_SHIFT]),o.USERNAME_MASK=128,o.PASSWORD_MASK=64,o.WILL_RETAIN_MASK=32,o.WILL_QOS_MASK=24,o.WILL_QOS_SHIFT=3,o.WILL_FLAG_MASK=4,o.CLEAN_SESSION_MASK=2,o.CONNECT_HEADER=i.from([o.codes.connect<<o.CMD_SHIFT]),o.PUBLISH_HEADER=n("publish"),o.SUBSCRIBE_HEADER=n("subscribe"),o.UNSUBSCRIBE_HEADER=n("unsubscribe"),o.ACKS={unsuback:n("unsuback"),puback:n("puback"),pubcomp:n("pubcomp"),pubrel:n("pubrel"),pubrec:n("pubrec")},o.SUBACK_HEADER=i.from([o.codes.suback<<o.CMD_SHIFT]),o.VERSION3=i.from([3]),o.VERSION4=i.from([4]),o.QOS=[0,1,2].map(function(t){return i.from([t])}),o.EMPTY={pingreq:i.from([o.codes.pingreq<<4,0]),pingresp:i.from([o.codes.pingresp<<4,0]),disconnect:i.from([o.codes.disconnect<<4,0])}},{"safe-buffer":51}],32:[function(t,e,r){"use strict";function n(t){var e=new i;return s(t,e),e.concat()}function i(){this._array=new Array(20),this._i=0}var o=t("safe-buffer").Buffer,s=t("./writeToStream"),a=t("events").EventEmitter,u=t("inherits");u(i,a),i.prototype.write=function(t){return this._array[this._i++]=t,!0},i.prototype.concat=function(){var t,e,r=0,n=new Array(this._array.length),i=this._array,s=0;for(t=0;t<i.length&&i[t];t++)"string"!=typeof i[t]?n[t]=i[t].length:n[t]=o.byteLength(i[t]),r+=n[t];for(e=o.allocUnsafe(r),t=0;t<i.length&&i[t];t++)"string"!=typeof i[t]?(i[t].copy(e,s),s+=n[t]):(e.write(i[t],s),s+=n[t]);return e},e.exports=n},{"./writeToStream":37,events:4,inherits:29,"safe-buffer":51}],33:[function(t,e,r){"use strict";r.parser=t("./parser"),r.generate=t("./generate"),r.writeToStream=t("./writeToStream")},{"./generate":32,"./parser":36,"./writeToStream":37}],34:[function(t,e,r){"use strict";function n(t){var e=o.allocUnsafe(2);return e.writeUInt8(t>>8,0,!0),e.writeUInt8(255&t,1,!0),e}function i(){for(var t=0;s>t;t++)a[t]=n(t)}var o=t("safe-buffer").Buffer,s=65536,a={};e.exports={cache:a,generateCache:i,generateNumber:n}},{"safe-buffer":51}],35:[function(t,e,r){function n(){this.cmd=null,this.retain=!1,this.qos=0,this.dup=!1,this.length=-1,this.topic=null,this.payload=null}e.exports=n},{}],36:[function(t,e,r){"use strict";function n(){return this instanceof n?(this._states=["_parseHeader","_parseLength","_parsePayload","_newPacket"],void this._resetState()):new n}var i=t("bl"),o=t("inherits"),s=t("events").EventEmitter,a=t("./packet"),u=t("./constants");o(n,s),n.prototype._resetState=function(){this.packet=new a,this.error=null,this._list=i(),this._stateCounter=0},n.prototype.parse=function(t){for(this.error&&this._resetState(),this._list.append(t);(-1!==this.packet.length||this._list.length>0)&&this[this._states[this._stateCounter]]()&&!this.error;)this._stateCounter++,this._stateCounter>=this._states.length&&(this._stateCounter=0);return this._list.length},n.prototype._parseHeader=function(){var t=this._list.readUInt8(0);return this.packet.cmd=u.types[t>>u.CMD_SHIFT],this.packet.retain=0!==(t&u.RETAIN_MASK),this.packet.qos=t>>u.QOS_SHIFT&u.QOS_MASK,this.packet.dup=0!==(t&u.DUP_MASK),this._list.consume(1),!0},n.prototype._parseLength=function(){for(var t,e=0,r=1,n=0,i=!0;5>e&&(t=this._list.readUInt8(e++),n+=r*(t&u.LENGTH_MASK),r*=128,0!==(t&u.LENGTH_FIN_MASK));)if(this._list.length<=e){i=!1;break}return i&&(this.packet.length=n,this._list.consume(e)),i},n.prototype._parsePayload=function(){var t=!1;if(0===this.packet.length||this._list.length>=this.packet.length){switch(this._pos=0,this.packet.cmd){case"connect":this._parseConnect();break;case"connack":this._parseConnack();break;case"publish":this._parsePublish();break;case"puback":case"pubrec":case"pubrel":case"pubcomp":this._parseMessageId();break;case"subscribe":this._parseSubscribe();break;case"suback":this._parseSuback();break;case"unsubscribe":this._parseUnsubscribe();break;case"unsuback":this._parseUnsuback();break;case"pingreq":case"pingresp":case"disconnect":break;default:this._emitError(new Error("Not supported"))}t=!0}return t},n.prototype._parseConnect=function(){var t,e,r,n,i,o,s={},a=this.packet;if(t=this._parseString(),null===t)return this._emitError(new Error("Cannot parse protocolId"));if("MQTT"!==t&&"MQIsdp"!==t)return this._emitError(new Error("Invalid protocolId"));if(a.protocolId=t,this._pos>=this._list.length)return this._emitError(new Error("Packet too short"));if(a.protocolVersion=this._list.readUInt8(this._pos),3!==a.protocolVersion&&4!==a.protocolVersion)return this._emitError(new Error("Invalid protocol version"));if(this._pos++,this._pos>=this._list.length)return this._emitError(new Error("Packet too short"));if(s.username=this._list.readUInt8(this._pos)&u.USERNAME_MASK,s.password=this._list.readUInt8(this._pos)&u.PASSWORD_MASK,s.will=this._list.readUInt8(this._pos)&u.WILL_FLAG_MASK,s.will&&(a.will={},a.will.retain=0!==(this._list.readUInt8(this._pos)&u.WILL_RETAIN_MASK),a.will.qos=(this._list.readUInt8(this._pos)&u.WILL_QOS_MASK)>>u.WILL_QOS_SHIFT),a.clean=0!==(this._list.readUInt8(this._pos)&u.CLEAN_SESSION_MASK),this._pos++,a.keepalive=this._parseNum(),-1===a.keepalive)return this._emitError(new Error("Packet too short"));if(e=this._parseString(),null===e)return this._emitError(new Error("Packet too short"));if(a.clientId=e,s.will){if(r=this._parseString(),null===r)return this._emitError(new Error("Cannot parse will topic"));if(a.will.topic=r,n=this._parseBuffer(),null===n)return this._emitError(new Error("Cannot parse will payload"));a.will.payload=n}if(s.username){if(o=this._parseString(),null===o)return this._emitError(new Error("Cannot parse username"));a.username=o}if(s.password){if(i=this._parseBuffer(),null===i)return this._emitError(new Error("Cannot parse password"));a.password=i}return a},n.prototype._parseConnack=function(){var t=this.packet;return this._list.length<2?null:(t.sessionPresent=!!(this._list.readUInt8(this._pos++)&u.SESSIONPRESENT_MASK),t.returnCode=this._list.readUInt8(this._pos),-1===t.returnCode?this._emitError(new Error("Cannot parse return code")):void 0)},n.prototype._parsePublish=function(){var t=this.packet;return t.topic=this._parseString(),null===t.topic?this._emitError(new Error("Cannot parse topic")):void(t.qos>0&&!this._parseMessageId()||(t.payload=this._list.slice(this._pos,t.length)))},n.prototype._parseSubscribe=function(){var t,e,r=this.packet;if(1!==r.qos)return this._emitError(new Error("Wrong subscribe header"));if(r.subscriptions=[],this._parseMessageId())for(;this._pos<r.length;){if(t=this._parseString(),null===t)return this._emitError(new Error("Cannot parse topic"));e=this._list.readUInt8(this._pos++),r.subscriptions.push({topic:t,qos:e})}},n.prototype._parseSuback=function(){if(this.packet.granted=[],this._parseMessageId())for(;this._pos<this.packet.length;)this.packet.granted.push(this._list.readUInt8(this._pos++))},n.prototype._parseUnsubscribe=function(){var t=this.packet;if(t.unsubscriptions=[],this._parseMessageId())for(;this._pos<t.length;){var e;if(e=this._parseString(),null===e)return this._emitError(new Error("Cannot parse topic"));t.unsubscriptions.push(e)}},n.prototype._parseUnsuback=function(){return this._parseMessageId()?void 0:this._emitError(new Error("Cannot parse messageId"))},n.prototype._parseMessageId=function(){var t=this.packet;return t.messageId=this._parseNum(),null===t.messageId?(this._emitError(new Error("Cannot parse messageId")),!1):!0},n.prototype._parseString=function(t){var e,r=this._parseNum(),n=r+this._pos;return-1===r||n>this._list.length||n>this.packet.length?null:(e=this._list.toString("utf8",this._pos,n),this._pos+=r,e)},n.prototype._parseBuffer=function(){var t,e=this._parseNum(),r=e+this._pos;return-1===e||r>this._list.length||r>this.packet.length?null:(t=this._list.slice(this._pos,r),this._pos+=e,t)},n.prototype._parseNum=function(){if(this._list.length-this._pos<2)return-1;var t=this._list.readUInt16BE(this._pos);return this._pos+=2,t},n.prototype._newPacket=function(){return this.packet&&(this._list.consume(this.packet.length),this.emit("packet",this.packet)),this.packet=new a,!0},n.prototype._emitError=function(t){this.error=t,this.emit("error",t)},e.exports=n},{"./constants":31,"./packet":35,bl:25,events:4,inherits:29}],37:[function(t,e,r){"use strict";function n(t,e){switch(e.cork&&(e.cork(),x(i,e)),j&&(j=!1,M()),t.cmd){case"connect":return o(t,e);case"connack":return s(t,e);case"publish":return a(t,e);case"puback":case"pubrec":case"pubrel":case"pubcomp":case"unsuback":return u(t,e);case"subscribe":return c(t,e);case"suback":return h(t,e);case"unsubscribe":return f(t,e);case"pingreq":case"pingresp":case"disconnect":return l(t,e);default:return e.emit("error",new Error("Unknown command")),!1}}function i(t){t.uncork()}function o(t,e){var r=t||{},n=r.protocolId||"MQTT",i=r.protocolVersion||4,o=r.will,s=r.clean,a=r.keepalive||0,u=r.clientId||"",c=r.username,h=r.password;void 0===s&&(s=!0);var f=0;if(!n||"string"!=typeof n&&!S.isBuffer(n))return e.emit("error",new Error("Invalid protocolId")),!1;if(f+=n.length+2,3!==i&&4!==i)return e.emit("error",new Error("Invalid protocol version")),!1;if(f+=1,"string"!=typeof u&&!S.isBuffer(u)||!u&&4!==i||!u&&!s){if(4>i)return e.emit("error",new Error("clientId must be supplied before 3.1.1")),!1;if(1*s===0)return e.emit("error",new Error("clientId must be given if cleanSession set to 0")),!1}else f+=u.length+2;if("number"!=typeof a||0>a||a>65535||a%1!==0)return e.emit("error",new Error("Invalid keepalive")),!1;if(f+=2,f+=1,o){if("object"!=typeof o)return e.emit("error",new Error("Invalid will")),!1;if(!o.topic||"string"!=typeof o.topic)return e.emit("error",new Error("Invalid will topic")),!1;if(f+=S.byteLength(o.topic)+2,o.payload&&o.payload){if(!(o.payload.length>=0))return e.emit("error",new Error("Invalid will payload")),!1;f+="string"==typeof o.payload?S.byteLength(o.payload)+2:o.payload.length+2}else f+=2}if(c){if(!c.length)return e.emit("error",new Error("Invalid username")),!1;f+=S.byteLength(c)+2}if(h){if(!h.length)return e.emit("error",new Error("Invalid password")),!1;f+=_(h)+2}e.write(w.CONNECT_HEADER),g(e,f),v(e,n),e.write(4===i?w.VERSION4:w.VERSION3);var l=0;return l|=c?w.USERNAME_MASK:0,l|=h?w.PASSWORD_MASK:0,l|=o&&o.retain?w.WILL_RETAIN_MASK:0,l|=o&&o.qos?o.qos<<w.WILL_QOS_SHIFT:0,l|=o?w.WILL_FLAG_MASK:0,l|=s?w.CLEAN_SESSION_MASK:0,e.write(S.from([l])),C(e,a),v(e,u),o&&(b(e,o.topic),v(e,o.payload)),c&&v(e,c),h&&v(e,h),!0}function s(t,e){var r=t||{},n=r.returnCode;return"number"!=typeof n?(e.emit("error",new Error("Invalid return code")),!1):(e.write(w.CONNACK_HEADER),g(e,2),e.write(t.sessionPresent?w.SESSIONPRESENT_HEADER:k),e.write(S.from([n])))}function a(t,e){var r=t||{},n=r.qos||0,i=r.retain?w.RETAIN_MASK:0,o=r.topic,s=r.payload||E,a=r.messageId,u=0;if("string"==typeof o)u+=S.byteLength(o)+2;else{if(!S.isBuffer(o))return e.emit("error",new Error("Invalid topic")),!1;u+=o.length+2}return u+=S.isBuffer(s)?s.length:S.byteLength(s),n&&"number"!=typeof a?(e.emit("error",new Error("Invalid messageId")),!1):(n&&(u+=2),e.write(w.PUBLISH_HEADER[n][t.dup?1:0][i?1:0]),g(e,u),C(e,_(o)),e.write(o),n>0&&C(e,a),e.write(s))}function u(t,e){var r=t||{},n=r.cmd||"puback",i=r.messageId,o=r.dup&&"pubrel"===n?w.DUP_MASK:0,s=0;return"pubrel"===n&&(s=1),"number"!=typeof i?(e.emit("error",new Error("Invalid messageId")),!1):(e.write(w.ACKS[n][s][o][0]),g(e,2),C(e,i))}function c(t,e){var r=t||{},n=r.dup?w.DUP_MASK:0,i=r.messageId,o=r.subscriptions,s=0;if("number"!=typeof i)return e.emit("error",new Error("Invalid messageId")),!1;if(s+=2,"object"!=typeof o||!o.length)return e.emit("error",new Error("Invalid subscriptions")),!1;for(var a=0;a<o.length;a+=1){var u=o[a].topic,c=o[a].qos;if("string"!=typeof u)return e.emit("error",new Error("Invalid subscriptions - invalid topic")),!1;if("number"!=typeof c)return e.emit("error",new Error("Invalid subscriptions - invalid qos")),!1;s+=S.byteLength(u)+2+1}e.write(w.SUBSCRIBE_HEADER[1][n?1:0][0]),g(e,s),C(e,i);for(var h=!0,f=0;f<o.length;f++){var l=o[f],p=l.topic,d=l.qos;b(e,p),h=e.write(w.QOS[d])}return h}function h(t,e){var r=t||{},n=r.messageId,i=r.granted,o=0;if("number"!=typeof n)return e.emit("error",new Error("Invalid messageId")),!1;if(o+=2,"object"!=typeof i||!i.length)return e.emit("error",new Error("Invalid qos vector")),!1;for(var s=0;s<i.length;s+=1){if("number"!=typeof i[s])return e.emit("error",new Error("Invalid qos vector")),!1;o+=1}return e.write(w.SUBACK_HEADER),g(e,o),C(e,n),e.write(S.from(i))}function f(t,e){var r=t||{},n=r.messageId,i=r.dup?w.DUP_MASK:0,o=r.unsubscriptions,s=0;if("number"!=typeof n)return e.emit("error",new Error("Invalid messageId")),!1;if(s+=2,"object"!=typeof o||!o.length)return e.emit("error",new Error("Invalid unsubscriptions")),!1;for(var a=0;a<o.length;a+=1){if("string"!=typeof o[a])return e.emit("error",new Error("Invalid unsubscriptions")),!1;s+=S.byteLength(o[a])+2}e.write(w.UNSUBSCRIBE_HEADER[1][i?1:0][0]),g(e,s),C(e,n);for(var u=!0,c=0;c<o.length;c++)u=b(e,o[c]);return u}function l(t,e){return e.write(w.EMPTY[t.cmd])}function p(t){return t>=0&&128>t?1:t>=128&&16384>t?2:t>=16384&&2097152>t?3:t>=2097152&&268435456>t?4:0}function d(t){var e=0,r=0,n=S.allocUnsafe(p(t));do e=t%128|0,t=t/128|0,t>0&&(e=128|e),n.writeUInt8(e,r++,!0);while(t>0);return n}function g(t,e){var r=L[e];r||(r=d(e),16384>e&&(L[e]=r)),t.write(r)}function b(t,e){var r=S.byteLength(e);C(t,r),t.write(e,"utf8")}function m(t,e){return t.write(A[e])}function y(t,e){return t.write(T(e))}function v(t,e){e&&"string"==typeof e?b(t,e):e?(C(t,e.length),t.write(e)):C(t,0)}function _(t){return t?S.isBuffer(t)?t.length:S.byteLength(t):0}var w=t("./constants"),S=t("safe-buffer").Buffer,E=S.allocUnsafe(0),k=S.from([0]),I=t("./numbers"),x=t("process-nextick-args"),A=I.cache,T=I.generateNumber,M=I.generateCache,C=m,j=!0;Object.defineProperty(n,"cacheNumbers",{get:function(){return C===m},set:function(t){t?(A&&0!==Object.keys(A).length||(j=!0),C=m):(j=!1,C=y)}});var L={};e.exports=n},{"./constants":31,"./numbers":34,"process-nextick-args":39,"safe-buffer":51}],38:[function(t,e,r){function n(t){var e=function(){return e.called?e.value:(e.called=!0,e.value=t.apply(this,arguments))};return e.called=!1,e}function i(t){var e=function(){if(e.called)throw new Error(e.onceError);return e.called=!0,e.value=t.apply(this,arguments)},r=t.name||"Function wrapped with `once`";return e.onceError=r+" shouldn't be called more than once",e.called=!1,e}var o=t("wrappy");e.exports=o(n),e.exports.strict=o(i),n.proto=n(function(){Object.defineProperty(Function.prototype,"once",{value:function(){return n(this)},configurable:!0}),Object.defineProperty(Function.prototype,"onceStrict",{value:function(){return i(this)},configurable:!0})})},{wrappy:57}],39:[function(t,e,r){(function(t){"use strict";function r(e,r,n,i){if("function"!=typeof e)throw new TypeError('"callback" argument must be a function');var o,s,a=arguments.length;switch(a){case 0:case 1:return t.nextTick(e);case 2:return t.nextTick(function(){e.call(null,r)});case 3:return t.nextTick(function(){e.call(null,r,n)});case 4:return t.nextTick(function(){e.call(null,r,n,i)});default:for(o=new Array(a-1),s=0;s<o.length;)o[s++]=arguments[s];return t.nextTick(function(){e.apply(null,o)})}}!t.version||0===t.version.indexOf("v0.")||0===t.version.indexOf("v1.")&&0!==t.version.indexOf("v1.8.")?e.exports=r:e.exports=t.nextTick}).call(this,t("_process"))},{_process:7}],40:[function(t,e,r){e.exports=t("./lib/_stream_duplex.js")},{"./lib/_stream_duplex.js":41}],41:[function(t,e,r){"use strict";function n(t){return this instanceof n?(c.call(this,t),h.call(this,t),t&&t.readable===!1&&(this.readable=!1),t&&t.writable===!1&&(this.writable=!1),this.allowHalfOpen=!0,t&&t.allowHalfOpen===!1&&(this.allowHalfOpen=!1),void this.once("end",i)):new n(t)}function i(){this.allowHalfOpen||this._writableState.ended||s(o,this)}function o(t){t.end()}var s=t("process-nextick-args"),a=Object.keys||function(t){var e=[];for(var r in t)e.push(r);return e};e.exports=n;var u=t("core-util-is");u.inherits=t("inherits");var c=t("./_stream_readable"),h=t("./_stream_writable");u.inherits(n,c);for(var f=a(h.prototype),l=0;l<f.length;l++){var p=f[l];n.prototype[p]||(n.prototype[p]=h.prototype[p])}Object.defineProperty(n.prototype,"destroyed",{get:function(){return void 0===this._readableState||void 0===this._writableState?!1:this._readableState.destroyed&&this._writableState.destroyed},set:function(t){void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed=t,this._writableState.destroyed=t)}}),n.prototype._destroy=function(t,e){this.push(null),this.end(),s(e,t)}},{"./_stream_readable":43,"./_stream_writable":45,"core-util-is":26,inherits:29,"process-nextick-args":39}],42:[function(t,e,r){"use strict";function n(t){return this instanceof n?void i.call(this,t):new n(t)}e.exports=n;var i=t("./_stream_transform"),o=t("core-util-is");o.inherits=t("inherits"),o.inherits(n,i),n.prototype._transform=function(t,e,r){r(null,t)}},{"./_stream_transform":44,"core-util-is":26,inherits:29}],43:[function(t,e,r){(function(r,n){"use strict";function i(t){return N.from(t)}function o(t){return N.isBuffer(t)||t instanceof q}function s(t,e,r){return"function"==typeof t.prependListener?t.prependListener(e,r):void(t._events&&t._events[e]?R(t._events[e])?t._events[e].unshift(r):t._events[e]=[r,t._events[e]]:t.on(e,r))}function a(e,r){O=O||t("./_stream_duplex"),e=e||{},this.objectMode=!!e.objectMode,r instanceof O&&(this.objectMode=this.objectMode||!!e.readableObjectMode);var n=e.highWaterMark,i=this.objectMode?16:16384;this.highWaterMark=n||0===n?n:i,this.highWaterMark=Math.floor(this.highWaterMark),this.buffer=new H,this.length=0,this.pipes=null,this.pipesCount=0,this.flowing=null,this.ended=!1,this.endEmitted=!1,this.reading=!1,this.sync=!0,this.needReadable=!1,this.emittedReadable=!1,this.readableListening=!1,this.resumeScheduled=!1,this.destroyed=!1,this.defaultEncoding=e.defaultEncoding||"utf8",this.awaitDrain=0,this.readingMore=!1,this.decoder=null,this.encoding=null,e.encoding&&(F||(F=t("string_decoder/").StringDecoder),this.decoder=new F(e.encoding),this.encoding=e.encoding)}function u(e){return O=O||t("./_stream_duplex"),this instanceof u?(this._readableState=new a(e,this),this.readable=!0,e&&("function"==typeof e.read&&(this._read=e.read),"function"==typeof e.destroy&&(this._destroy=e.destroy)),void B.call(this)):new u(e)}function c(t,e,r,n,o){var s=t._readableState;if(null===e)s.reading=!1,g(t,s);else{var a;o||(a=f(s,e)),a?t.emit("error",a):s.objectMode||e&&e.length>0?("string"==typeof e||s.objectMode||Object.getPrototypeOf(e)===N.prototype||(e=i(e)),n?s.endEmitted?t.emit("error",new Error("stream.unshift() after end event")):h(t,s,e,!0):s.ended?t.emit("error",new Error("stream.push() after EOF")):(s.reading=!1,s.decoder&&!r?(e=s.decoder.write(e),s.objectMode||0!==e.length?h(t,s,e,!1):y(t,s)):h(t,s,e,!1))):n||(s.reading=!1)}return l(s)}function h(t,e,r,n){e.flowing&&0===e.length&&!e.sync?(t.emit("data",r),t.read(0)):(e.length+=e.objectMode?1:r.length,n?e.buffer.unshift(r):e.buffer.push(r),e.needReadable&&b(t)),y(t,e)}function f(t,e){var r;return o(e)||"string"==typeof e||void 0===e||t.objectMode||(r=new TypeError("Invalid non-string/buffer chunk")),r}function l(t){return!t.ended&&(t.needReadable||t.length<t.highWaterMark||0===t.length)}function p(t){return t>=Q?t=Q:(t--,t|=t>>>1,t|=t>>>2,t|=t>>>4,t|=t>>>8,t|=t>>>16,t++),t}function d(t,e){return 0>=t||0===e.length&&e.ended?0:e.objectMode?1:t!==t?e.flowing&&e.length?e.buffer.head.data.length:e.length:(t>e.highWaterMark&&(e.highWaterMark=p(t)),t<=e.length?t:e.ended?e.length:(e.needReadable=!0,0))}function g(t,e){if(!e.ended){if(e.decoder){var r=e.decoder.end();r&&r.length&&(e.buffer.push(r),e.length+=e.objectMode?1:r.length)}e.ended=!0,b(t)}}function b(t){var e=t._readableState;e.needReadable=!1,e.emittedReadable||(W("emitReadable",e.flowing),e.emittedReadable=!0,e.sync?L(m,t):m(t))}function m(t){W("emit readable"),t.emit("readable"),k(t)}function y(t,e){e.readingMore||(e.readingMore=!0,L(v,t,e))}function v(t,e){for(var r=e.length;!e.reading&&!e.flowing&&!e.ended&&e.length<e.highWaterMark&&(W("maybeReadMore read 0"),t.read(0),r!==e.length);)r=e.length;e.readingMore=!1}function _(t){return function(){var e=t._readableState;W("pipeOnDrain",e.awaitDrain),e.awaitDrain&&e.awaitDrain--,0===e.awaitDrain&&U(t,"data")&&(e.flowing=!0,k(t))}}function w(t){W("readable nexttick read 0"),t.read(0)}function S(t,e){e.resumeScheduled||(e.resumeScheduled=!0,L(E,t,e))}function E(t,e){e.reading||(W("resume read 0"),t.read(0)),e.resumeScheduled=!1,e.awaitDrain=0,t.emit("resume"),k(t),e.flowing&&!e.reading&&t.read(0)}function k(t){var e=t._readableState;for(W("flow",e.flowing);e.flowing&&null!==t.read(););}function I(t,e){if(0===e.length)return null;var r;return e.objectMode?r=e.buffer.shift():!t||t>=e.length?(r=e.decoder?e.buffer.join(""):1===e.buffer.length?e.buffer.head.data:e.buffer.concat(e.length),e.buffer.clear()):r=x(t,e.buffer,e.decoder),r}function x(t,e,r){var n;return t<e.head.data.length?(n=e.head.data.slice(0,t),e.head.data=e.head.data.slice(t)):n=t===e.head.data.length?e.shift():r?A(t,e):T(t,e),n}function A(t,e){var r=e.head,n=1,i=r.data;for(t-=i.length;r=r.next;){var o=r.data,s=t>o.length?o.length:t;if(i+=s===o.length?o:o.slice(0,t),t-=s,0===t){s===o.length?(++n,r.next?e.head=r.next:e.head=e.tail=null):(e.head=r,r.data=o.slice(s));break}++n}return e.length-=n,i}function T(t,e){var r=N.allocUnsafe(t),n=e.head,i=1;for(n.data.copy(r),t-=n.data.length;n=n.next;){var o=n.data,s=t>o.length?o.length:t;if(o.copy(r,r.length-t,0,s),t-=s,0===t){s===o.length?(++i,n.next?e.head=n.next:e.head=e.tail=null):(e.head=n,n.data=o.slice(s));break}++i}return e.length-=i,r}function M(t){var e=t._readableState;if(e.length>0)throw new Error('"endReadable()" called on non-empty stream');e.endEmitted||(e.ended=!0,L(C,e,t))}function C(t,e){t.endEmitted||0!==t.length||(t.endEmitted=!0,e.readable=!1,e.emit("end"))}function j(t,e){for(var r=0,n=t.length;n>r;r++)if(t[r]===e)return r;return-1}var L=t("process-nextick-args");e.exports=u;var O,R=t("isarray");u.ReadableState=a;var U=(t("events").EventEmitter,function(t,e){return t.listeners(e).length}),B=t("./internal/streams/stream"),N=t("safe-buffer").Buffer,q=n.Uint8Array||function(){},P=t("core-util-is");P.inherits=t("inherits");var D=t("util"),W=void 0;W=D&&D.debuglog?D.debuglog("stream"):function(){};
var F,H=t("./internal/streams/BufferList"),z=t("./internal/streams/destroy");P.inherits(u,B);var K=["error","close","destroy","pause","resume"];Object.defineProperty(u.prototype,"destroyed",{get:function(){return void 0===this._readableState?!1:this._readableState.destroyed},set:function(t){this._readableState&&(this._readableState.destroyed=t)}}),u.prototype.destroy=z.destroy,u.prototype._undestroy=z.undestroy,u.prototype._destroy=function(t,e){this.push(null),e(t)},u.prototype.push=function(t,e){var r,n=this._readableState;return n.objectMode?r=!0:"string"==typeof t&&(e=e||n.defaultEncoding,e!==n.encoding&&(t=N.from(t,e),e=""),r=!0),c(this,t,e,!1,r)},u.prototype.unshift=function(t){return c(this,t,null,!0,!1)},u.prototype.isPaused=function(){return this._readableState.flowing===!1},u.prototype.setEncoding=function(e){return F||(F=t("string_decoder/").StringDecoder),this._readableState.decoder=new F(e),this._readableState.encoding=e,this};var Q=8388608;u.prototype.read=function(t){W("read",t),t=parseInt(t,10);var e=this._readableState,r=t;if(0!==t&&(e.emittedReadable=!1),0===t&&e.needReadable&&(e.length>=e.highWaterMark||e.ended))return W("read: emitReadable",e.length,e.ended),0===e.length&&e.ended?M(this):b(this),null;if(t=d(t,e),0===t&&e.ended)return 0===e.length&&M(this),null;var n=e.needReadable;W("need readable",n),(0===e.length||e.length-t<e.highWaterMark)&&(n=!0,W("length less than watermark",n)),e.ended||e.reading?(n=!1,W("reading or ended",n)):n&&(W("do read"),e.reading=!0,e.sync=!0,0===e.length&&(e.needReadable=!0),this._read(e.highWaterMark),e.sync=!1,e.reading||(t=d(r,e)));var i;return i=t>0?I(t,e):null,null===i?(e.needReadable=!0,t=0):e.length-=t,0===e.length&&(e.ended||(e.needReadable=!0),r!==t&&e.ended&&M(this)),null!==i&&this.emit("data",i),i},u.prototype._read=function(t){this.emit("error",new Error("_read() is not implemented"))},u.prototype.pipe=function(t,e){function n(t,e){W("onunpipe"),t===l&&e&&e.hasUnpiped===!1&&(e.hasUnpiped=!0,o())}function i(){W("onend"),t.end()}function o(){W("cleanup"),t.removeListener("close",c),t.removeListener("finish",h),t.removeListener("drain",b),t.removeListener("error",u),t.removeListener("unpipe",n),l.removeListener("end",i),l.removeListener("end",f),l.removeListener("data",a),m=!0,!p.awaitDrain||t._writableState&&!t._writableState.needDrain||b()}function a(e){W("ondata"),y=!1;var r=t.write(e);!1!==r||y||((1===p.pipesCount&&p.pipes===t||p.pipesCount>1&&-1!==j(p.pipes,t))&&!m&&(W("false write response, pause",l._readableState.awaitDrain),l._readableState.awaitDrain++,y=!0),l.pause())}function u(e){W("onerror",e),f(),t.removeListener("error",u),0===U(t,"error")&&t.emit("error",e)}function c(){t.removeListener("finish",h),f()}function h(){W("onfinish"),t.removeListener("close",c),f()}function f(){W("unpipe"),l.unpipe(t)}var l=this,p=this._readableState;switch(p.pipesCount){case 0:p.pipes=t;break;case 1:p.pipes=[p.pipes,t];break;default:p.pipes.push(t)}p.pipesCount+=1,W("pipe count=%d opts=%j",p.pipesCount,e);var d=(!e||e.end!==!1)&&t!==r.stdout&&t!==r.stderr,g=d?i:f;p.endEmitted?L(g):l.once("end",g),t.on("unpipe",n);var b=_(l);t.on("drain",b);var m=!1,y=!1;return l.on("data",a),s(t,"error",u),t.once("close",c),t.once("finish",h),t.emit("pipe",l),p.flowing||(W("pipe resume"),l.resume()),t},u.prototype.unpipe=function(t){var e=this._readableState,r={hasUnpiped:!1};if(0===e.pipesCount)return this;if(1===e.pipesCount)return t&&t!==e.pipes?this:(t||(t=e.pipes),e.pipes=null,e.pipesCount=0,e.flowing=!1,t&&t.emit("unpipe",this,r),this);if(!t){var n=e.pipes,i=e.pipesCount;e.pipes=null,e.pipesCount=0,e.flowing=!1;for(var o=0;i>o;o++)n[o].emit("unpipe",this,r);return this}var s=j(e.pipes,t);return-1===s?this:(e.pipes.splice(s,1),e.pipesCount-=1,1===e.pipesCount&&(e.pipes=e.pipes[0]),t.emit("unpipe",this,r),this)},u.prototype.on=function(t,e){var r=B.prototype.on.call(this,t,e);if("data"===t)this._readableState.flowing!==!1&&this.resume();else if("readable"===t){var n=this._readableState;n.endEmitted||n.readableListening||(n.readableListening=n.needReadable=!0,n.emittedReadable=!1,n.reading?n.length&&b(this):L(w,this))}return r},u.prototype.addListener=u.prototype.on,u.prototype.resume=function(){var t=this._readableState;return t.flowing||(W("resume"),t.flowing=!0,S(this,t)),this},u.prototype.pause=function(){return W("call pause flowing=%j",this._readableState.flowing),!1!==this._readableState.flowing&&(W("pause"),this._readableState.flowing=!1,this.emit("pause")),this},u.prototype.wrap=function(t){var e=this._readableState,r=!1,n=this;t.on("end",function(){if(W("wrapped end"),e.decoder&&!e.ended){var t=e.decoder.end();t&&t.length&&n.push(t)}n.push(null)}),t.on("data",function(i){if(W("wrapped data"),e.decoder&&(i=e.decoder.write(i)),(!e.objectMode||null!==i&&void 0!==i)&&(e.objectMode||i&&i.length)){var o=n.push(i);o||(r=!0,t.pause())}});for(var i in t)void 0===this[i]&&"function"==typeof t[i]&&(this[i]=function(e){return function(){return t[e].apply(t,arguments)}}(i));for(var o=0;o<K.length;o++)t.on(K[o],n.emit.bind(n,K[o]));return n._read=function(e){W("wrapped _read",e),r&&(r=!1,t.resume())},n},u._fromList=I}).call(this,t("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./_stream_duplex":41,"./internal/streams/BufferList":46,"./internal/streams/destroy":47,"./internal/streams/stream":48,_process:7,"core-util-is":26,events:4,inherits:29,isarray:30,"process-nextick-args":39,"safe-buffer":51,"string_decoder/":53,util:2}],44:[function(t,e,r){"use strict";function n(t){this.afterTransform=function(e,r){return i(t,e,r)},this.needTransform=!1,this.transforming=!1,this.writecb=null,this.writechunk=null,this.writeencoding=null}function i(t,e,r){var n=t._transformState;n.transforming=!1;var i=n.writecb;if(!i)return t.emit("error",new Error("write callback called multiple times"));n.writechunk=null,n.writecb=null,null!==r&&void 0!==r&&t.push(r),i(e);var o=t._readableState;o.reading=!1,(o.needReadable||o.length<o.highWaterMark)&&t._read(o.highWaterMark)}function o(t){if(!(this instanceof o))return new o(t);a.call(this,t),this._transformState=new n(this);var e=this;this._readableState.needReadable=!0,this._readableState.sync=!1,t&&("function"==typeof t.transform&&(this._transform=t.transform),"function"==typeof t.flush&&(this._flush=t.flush)),this.once("prefinish",function(){"function"==typeof this._flush?this._flush(function(t,r){s(e,t,r)}):s(e)})}function s(t,e,r){if(e)return t.emit("error",e);null!==r&&void 0!==r&&t.push(r);var n=t._writableState,i=t._transformState;if(n.length)throw new Error("Calling transform done when ws.length != 0");if(i.transforming)throw new Error("Calling transform done when still transforming");return t.push(null)}e.exports=o;var a=t("./_stream_duplex"),u=t("core-util-is");u.inherits=t("inherits"),u.inherits(o,a),o.prototype.push=function(t,e){return this._transformState.needTransform=!1,a.prototype.push.call(this,t,e)},o.prototype._transform=function(t,e,r){throw new Error("_transform() is not implemented")},o.prototype._write=function(t,e,r){var n=this._transformState;if(n.writecb=r,n.writechunk=t,n.writeencoding=e,!n.transforming){var i=this._readableState;(n.needTransform||i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark)}},o.prototype._read=function(t){var e=this._transformState;null!==e.writechunk&&e.writecb&&!e.transforming?(e.transforming=!0,this._transform(e.writechunk,e.writeencoding,e.afterTransform)):e.needTransform=!0},o.prototype._destroy=function(t,e){var r=this;a.prototype._destroy.call(this,t,function(t){e(t),r.emit("close")})}},{"./_stream_duplex":41,"core-util-is":26,inherits:29}],45:[function(t,e,r){(function(r,n){"use strict";function i(t){var e=this;this.next=null,this.entry=null,this.finish=function(){x(e,t)}}function o(t){return O.from(t)}function s(t){return O.isBuffer(t)||t instanceof R}function a(){}function u(e,r){T=T||t("./_stream_duplex"),e=e||{},this.objectMode=!!e.objectMode,r instanceof T&&(this.objectMode=this.objectMode||!!e.writableObjectMode);var n=e.highWaterMark,o=this.objectMode?16:16384;this.highWaterMark=n||0===n?n:o,this.highWaterMark=Math.floor(this.highWaterMark),this.finalCalled=!1,this.needDrain=!1,this.ending=!1,this.ended=!1,this.finished=!1,this.destroyed=!1;var s=e.decodeStrings===!1;this.decodeStrings=!s,this.defaultEncoding=e.defaultEncoding||"utf8",this.length=0,this.writing=!1,this.corked=0,this.sync=!0,this.bufferProcessing=!1,this.onwrite=function(t){m(r,t)},this.writecb=null,this.writelen=0,this.bufferedRequest=null,this.lastBufferedRequest=null,this.pendingcb=0,this.prefinished=!1,this.errorEmitted=!1,this.bufferedRequestCount=0,this.corkedRequestsFree=new i(this)}function c(e){return T=T||t("./_stream_duplex"),B.call(c,this)||this instanceof T?(this._writableState=new u(e,this),this.writable=!0,e&&("function"==typeof e.write&&(this._write=e.write),"function"==typeof e.writev&&(this._writev=e.writev),"function"==typeof e.destroy&&(this._destroy=e.destroy),"function"==typeof e["final"]&&(this._final=e["final"])),void L.call(this)):new c(e)}function h(t,e){var r=new Error("write after end");t.emit("error",r),A(e,r)}function f(t,e,r,n){var i=!0,o=!1;return null===r?o=new TypeError("May not write null values to stream"):"string"==typeof r||void 0===r||e.objectMode||(o=new TypeError("Invalid non-string/buffer chunk")),o&&(t.emit("error",o),A(n,o),i=!1),i}function l(t,e,r){return t.objectMode||t.decodeStrings===!1||"string"!=typeof e||(e=O.from(e,r)),e}function p(t,e,r,n,i,o){if(!r){var s=l(e,n,i);n!==s&&(r=!0,i="buffer",n=s)}var a=e.objectMode?1:n.length;e.length+=a;var u=e.length<e.highWaterMark;if(u||(e.needDrain=!0),e.writing||e.corked){var c=e.lastBufferedRequest;e.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:o,next:null},c?c.next=e.lastBufferedRequest:e.bufferedRequest=e.lastBufferedRequest,e.bufferedRequestCount+=1}else d(t,e,!1,a,n,i,o);return u}function d(t,e,r,n,i,o,s){e.writelen=n,e.writecb=s,e.writing=!0,e.sync=!0,r?t._writev(i,e.onwrite):t._write(i,o,e.onwrite),e.sync=!1}function g(t,e,r,n,i){--e.pendingcb,r?(A(i,n),A(k,t,e),t._writableState.errorEmitted=!0,t.emit("error",n)):(i(n),t._writableState.errorEmitted=!0,t.emit("error",n),k(t,e))}function b(t){t.writing=!1,t.writecb=null,t.length-=t.writelen,t.writelen=0}function m(t,e){var r=t._writableState,n=r.sync,i=r.writecb;if(b(r),e)g(t,r,n,e,i);else{var o=w(r);o||r.corked||r.bufferProcessing||!r.bufferedRequest||_(t,r),n?M(y,t,r,o,i):y(t,r,o,i)}}function y(t,e,r,n){r||v(t,e),e.pendingcb--,n(),k(t,e)}function v(t,e){0===e.length&&e.needDrain&&(e.needDrain=!1,t.emit("drain"))}function _(t,e){e.bufferProcessing=!0;var r=e.bufferedRequest;if(t._writev&&r&&r.next){var n=e.bufferedRequestCount,o=new Array(n),s=e.corkedRequestsFree;s.entry=r;for(var a=0,u=!0;r;)o[a]=r,r.isBuf||(u=!1),r=r.next,a+=1;o.allBuffers=u,d(t,e,!0,e.length,o,"",s.finish),e.pendingcb++,e.lastBufferedRequest=null,s.next?(e.corkedRequestsFree=s.next,s.next=null):e.corkedRequestsFree=new i(e)}else{for(;r;){var c=r.chunk,h=r.encoding,f=r.callback,l=e.objectMode?1:c.length;if(d(t,e,!1,l,c,h,f),r=r.next,e.writing)break}null===r&&(e.lastBufferedRequest=null)}e.bufferedRequestCount=0,e.bufferedRequest=r,e.bufferProcessing=!1}function w(t){return t.ending&&0===t.length&&null===t.bufferedRequest&&!t.finished&&!t.writing}function S(t,e){t._final(function(r){e.pendingcb--,r&&t.emit("error",r),e.prefinished=!0,t.emit("prefinish"),k(t,e)})}function E(t,e){e.prefinished||e.finalCalled||("function"==typeof t._final?(e.pendingcb++,e.finalCalled=!0,A(S,t,e)):(e.prefinished=!0,t.emit("prefinish")))}function k(t,e){var r=w(e);return r&&(E(t,e),0===e.pendingcb&&(e.finished=!0,t.emit("finish"))),r}function I(t,e,r){e.ending=!0,k(t,e),r&&(e.finished?A(r):t.once("finish",r)),e.ended=!0,t.writable=!1}function x(t,e,r){var n=t.entry;for(t.entry=null;n;){var i=n.callback;e.pendingcb--,i(r),n=n.next}e.corkedRequestsFree?e.corkedRequestsFree.next=t:e.corkedRequestsFree=t}var A=t("process-nextick-args");e.exports=c;var T,M=!r.browser&&["v0.10","v0.9."].indexOf(r.version.slice(0,5))>-1?setImmediate:A;c.WritableState=u;var C=t("core-util-is");C.inherits=t("inherits");var j={deprecate:t("util-deprecate")},L=t("./internal/streams/stream"),O=t("safe-buffer").Buffer,R=n.Uint8Array||function(){},U=t("./internal/streams/destroy");C.inherits(c,L),u.prototype.getBuffer=function(){for(var t=this.bufferedRequest,e=[];t;)e.push(t),t=t.next;return e},function(){try{Object.defineProperty(u.prototype,"buffer",{get:j.deprecate(function(){return this.getBuffer()},"_writableState.buffer is deprecated. Use _writableState.getBuffer instead.","DEP0003")})}catch(t){}}();var B;"function"==typeof Symbol&&Symbol.hasInstance&&"function"==typeof Function.prototype[Symbol.hasInstance]?(B=Function.prototype[Symbol.hasInstance],Object.defineProperty(c,Symbol.hasInstance,{value:function(t){return B.call(this,t)?!0:t&&t._writableState instanceof u}})):B=function(t){return t instanceof this},c.prototype.pipe=function(){this.emit("error",new Error("Cannot pipe, not readable"))},c.prototype.write=function(t,e,r){var n=this._writableState,i=!1,u=s(t)&&!n.objectMode;return u&&!O.isBuffer(t)&&(t=o(t)),"function"==typeof e&&(r=e,e=null),u?e="buffer":e||(e=n.defaultEncoding),"function"!=typeof r&&(r=a),n.ended?h(this,r):(u||f(this,n,t,r))&&(n.pendingcb++,i=p(this,n,u,t,e,r)),i},c.prototype.cork=function(){var t=this._writableState;t.corked++},c.prototype.uncork=function(){var t=this._writableState;t.corked&&(t.corked--,t.writing||t.corked||t.finished||t.bufferProcessing||!t.bufferedRequest||_(this,t))},c.prototype.setDefaultEncoding=function(t){if("string"==typeof t&&(t=t.toLowerCase()),!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((t+"").toLowerCase())>-1))throw new TypeError("Unknown encoding: "+t);return this._writableState.defaultEncoding=t,this},c.prototype._write=function(t,e,r){r(new Error("_write() is not implemented"))},c.prototype._writev=null,c.prototype.end=function(t,e,r){var n=this._writableState;"function"==typeof t?(r=t,t=null,e=null):"function"==typeof e&&(r=e,e=null),null!==t&&void 0!==t&&this.write(t,e),n.corked&&(n.corked=1,this.uncork()),n.ending||n.finished||I(this,n,r)},Object.defineProperty(c.prototype,"destroyed",{get:function(){return void 0===this._writableState?!1:this._writableState.destroyed},set:function(t){this._writableState&&(this._writableState.destroyed=t)}}),c.prototype.destroy=U.destroy,c.prototype._undestroy=U.undestroy,c.prototype._destroy=function(t,e){this.end(),e(t)}}).call(this,t("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./_stream_duplex":41,"./internal/streams/destroy":47,"./internal/streams/stream":48,_process:7,"core-util-is":26,inherits:29,"process-nextick-args":39,"safe-buffer":51,"util-deprecate":54}],46:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e,r){t.copy(e,r)}var o=t("safe-buffer").Buffer;e.exports=function(){function t(){n(this,t),this.head=null,this.tail=null,this.length=0}return t.prototype.push=function(t){var e={data:t,next:null};this.length>0?this.tail.next=e:this.head=e,this.tail=e,++this.length},t.prototype.unshift=function(t){var e={data:t,next:this.head};0===this.length&&(this.tail=e),this.head=e,++this.length},t.prototype.shift=function(){if(0!==this.length){var t=this.head.data;return 1===this.length?this.head=this.tail=null:this.head=this.head.next,--this.length,t}},t.prototype.clear=function(){this.head=this.tail=null,this.length=0},t.prototype.join=function(t){if(0===this.length)return"";for(var e=this.head,r=""+e.data;e=e.next;)r+=t+e.data;return r},t.prototype.concat=function(t){if(0===this.length)return o.alloc(0);if(1===this.length)return this.head.data;for(var e=o.allocUnsafe(t>>>0),r=this.head,n=0;r;)i(r.data,e,n),n+=r.data.length,r=r.next;return e},t}()},{"safe-buffer":51}],47:[function(t,e,r){"use strict";function n(t,e){var r=this,n=this._readableState&&this._readableState.destroyed,i=this._writableState&&this._writableState.destroyed;return n||i?void(e?e(t):!t||this._writableState&&this._writableState.errorEmitted||s(o,this,t)):(this._readableState&&(this._readableState.destroyed=!0),this._writableState&&(this._writableState.destroyed=!0),void this._destroy(t||null,function(t){!e&&t?(s(o,r,t),r._writableState&&(r._writableState.errorEmitted=!0)):e&&e(t)}))}function i(){this._readableState&&(this._readableState.destroyed=!1,this._readableState.reading=!1,this._readableState.ended=!1,this._readableState.endEmitted=!1),this._writableState&&(this._writableState.destroyed=!1,this._writableState.ended=!1,this._writableState.ending=!1,this._writableState.finished=!1,this._writableState.errorEmitted=!1)}function o(t,e){t.emit("error",e)}var s=t("process-nextick-args");e.exports={destroy:n,undestroy:i}},{"process-nextick-args":39}],48:[function(t,e,r){e.exports=t("events").EventEmitter},{events:4}],49:[function(t,e,r){r=e.exports=t("./lib/_stream_readable.js"),r.Stream=r,r.Readable=r,r.Writable=t("./lib/_stream_writable.js"),r.Duplex=t("./lib/_stream_duplex.js"),r.Transform=t("./lib/_stream_transform.js"),r.PassThrough=t("./lib/_stream_passthrough.js")},{"./lib/_stream_duplex.js":41,"./lib/_stream_passthrough.js":42,"./lib/_stream_readable.js":43,"./lib/_stream_transform.js":44,"./lib/_stream_writable.js":45}],50:[function(t,e,r){"use strict";function n(t,e,r){var n=this;this._callback=t,this._args=r,this._interval=setInterval(t,e,this._args),this.reschedule=function(t){t||(t=n._interval),n._interval&&clearInterval(n._interval),n._interval=setInterval(n._callback,t,n._args)},this.clear=function(){n._interval&&(clearInterval(n._interval),n._interval=void 0)},this.destroy=function(){n._interval&&clearInterval(n._interval),n._callback=void 0,n._interval=void 0,n._args=void 0}}function i(){if("function"!=typeof arguments[0])throw new Error("callback needed");if("number"!=typeof arguments[1])throw new Error("interval needed");var t;if(arguments.length>0){t=new Array(arguments.length-2);for(var e=0;e<t.length;e++)t[e]=arguments[e+2]}return new n(arguments[0],arguments[1],t)}e.exports=i},{}],51:[function(t,e,r){function n(t,e){for(var r in t)e[r]=t[r]}function i(t,e,r){return s(t,e,r)}var o=t("buffer"),s=o.Buffer;s.from&&s.alloc&&s.allocUnsafe&&s.allocUnsafeSlow?e.exports=o:(n(o,r),r.Buffer=i),n(s,i),i.from=function(t,e,r){if("number"==typeof t)throw new TypeError("Argument must not be a number");return s(t,e,r)},i.alloc=function(t,e,r){if("number"!=typeof t)throw new TypeError("Argument must be a number");var n=s(t);return void 0!==e?"string"==typeof r?n.fill(e,r):n.fill(e):n.fill(0),n},i.allocUnsafe=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return s(t)},i.allocUnsafeSlow=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return o.SlowBuffer(t)}},{buffer:3}],52:[function(t,e,r){function n(t){var e=t._readableState;return e?e.objectMode?t.read():t.read(i(e)):null}function i(t){return t.buffer.length?t.buffer.head?t.buffer.head.data.length:t.buffer[0].length:t.length}e.exports=n},{}],53:[function(t,e,r){"use strict";function n(t){if(!t)return"utf8";for(var e;;)switch(t){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return t;default:if(e)return;t=(""+t).toLowerCase(),e=!0}}function i(t){var e=n(t);if("string"!=typeof e&&(y.isEncoding===v||!v(t)))throw new Error("Unknown encoding: "+t);return e||t}function o(t){this.encoding=i(t);var e;switch(this.encoding){case"utf16le":this.text=l,this.end=p,e=4;break;case"utf8":this.fillLast=c,e=4;break;case"base64":this.text=d,this.end=g,e=3;break;default:return this.write=b,void(this.end=m)}this.lastNeed=0,this.lastTotal=0,this.lastChar=y.allocUnsafe(e)}function s(t){return 127>=t?0:t>>5===6?2:t>>4===14?3:t>>3===30?4:-1}function a(t,e,r){var n=e.length-1;if(r>n)return 0;var i=s(e[n]);return i>=0?(i>0&&(t.lastNeed=i-1),i):--n<r?0:(i=s(e[n]),i>=0?(i>0&&(t.lastNeed=i-2),i):--n<r?0:(i=s(e[n]),i>=0?(i>0&&(2===i?i=0:t.lastNeed=i-3),i):0))}function u(t,e,r){if(128!==(192&e[0]))return t.lastNeed=0,"�".repeat(r);if(t.lastNeed>1&&e.length>1){if(128!==(192&e[1]))return t.lastNeed=1,"�".repeat(r+1);if(t.lastNeed>2&&e.length>2&&128!==(192&e[2]))return t.lastNeed=2,"�".repeat(r+2)}}function c(t){var e=this.lastTotal-this.lastNeed,r=u(this,t,e);return void 0!==r?r:this.lastNeed<=t.length?(t.copy(this.lastChar,e,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(t.copy(this.lastChar,e,0,t.length),void(this.lastNeed-=t.length))}function h(t,e){var r=a(this,t,e);if(!this.lastNeed)return t.toString("utf8",e);this.lastTotal=r;var n=t.length-(r-this.lastNeed);return t.copy(this.lastChar,0,n),t.toString("utf8",e,n)}function f(t){var e=t&&t.length?this.write(t):"";return this.lastNeed?e+"�".repeat(this.lastTotal-this.lastNeed):e}function l(t,e){if((t.length-e)%2===0){var r=t.toString("utf16le",e);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&56319>=n)return this.lastNeed=2,this.lastTotal=4,this.lastChar[0]=t[t.length-2],this.lastChar[1]=t[t.length-1],r.slice(0,-1)}return r}return this.lastNeed=1,this.lastTotal=2,this.lastChar[0]=t[t.length-1],t.toString("utf16le",e,t.length-1)}function p(t){var e=t&&t.length?this.write(t):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return e+this.lastChar.toString("utf16le",0,r)}return e}function d(t,e){var r=(t.length-e)%3;return 0===r?t.toString("base64",e):(this.lastNeed=3-r,this.lastTotal=3,1===r?this.lastChar[0]=t[t.length-1]:(this.lastChar[0]=t[t.length-2],this.lastChar[1]=t[t.length-1]),t.toString("base64",e,t.length-r))}function g(t){var e=t&&t.length?this.write(t):"";return this.lastNeed?e+this.lastChar.toString("base64",0,3-this.lastNeed):e}function b(t){return t.toString(this.encoding)}function m(t){return t&&t.length?this.write(t):""}var y=t("safe-buffer").Buffer,v=y.isEncoding||function(t){switch(t=""+t,t&&t.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return!0;default:return!1}};r.StringDecoder=o,o.prototype.write=function(t){if(0===t.length)return"";var e,r;if(this.lastNeed){if(e=this.fillLast(t),void 0===e)return"";r=this.lastNeed,this.lastNeed=0}else r=0;return r<t.length?e?e+this.text(t,r):this.text(t,r):e||""},o.prototype.end=f,o.prototype.text=h,o.prototype.fillLast=function(t){return this.lastNeed<=t.length?(t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,t.length),void(this.lastNeed-=t.length))}},{"safe-buffer":51}],54:[function(t,e,r){(function(t){function r(t,e){function r(){if(!i){if(n("throwDeprecation"))throw new Error(e);n("traceDeprecation")?console.trace(e):console.warn(e),i=!0}return t.apply(this,arguments)}if(n("noDeprecation"))return t;var i=!1;return r}function n(e){try{if(!t.localStorage)return!1}catch(r){return!1}var n=t.localStorage[e];return null==n?!1:"true"===String(n).toLowerCase()}e.exports=r}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],55:[function(t,e,r){(function(r,n){"use strict";function i(t,e,n){var i=new s({objectMode:t.objectMode});return i._write=e,i._flush=n,i._destroy=function(t,e){var n=this;this.push(null),this.end(),r.nextTick(function(){e(t),n.emit("close")})},i}function o(t,e,o){function s(t,e,r){return v.readyState!==v.OPEN?void r():(x&&"string"==typeof t&&(t=new c(t,"utf8")),void v.send(t,r))}function h(t,e,r){if(v.bufferedAmount>k)return void setTimeout(h,I,t,e,r);x&&"string"==typeof t&&(t=new c(t,"utf8"));try{v.send(t)}catch(n){return r(n)}r()}function f(t){v.close(),t()}function l(){y.setReadable(E),y.setWritable(E),y.emit("connect")}function p(){y.end(),y.destroy()}function d(t){y.destroy(t)}function g(t){var e=t.data;e=e instanceof ArrayBuffer?c.from(e):c.from(e,"utf8"),E.push(e)}function b(){v.close()}function m(t,e){for(var r=new Array(t.length),n=0;n<t.length;n++)"string"==typeof t[n].chunk?r[n]=c.from(t[n],"utf8"):r[n]=t[n].chunk;this._write(c.concat(r),"binary",e)}var y,v,_="browser"===r.title,w=!!n.WebSocket,S=_?h:s;e&&!Array.isArray(e)&&"object"==typeof e&&(o=e,e=null,("string"==typeof o.protocol||Array.isArray(o.protocol))&&(e=o.protocol)),o||(o={}),void 0===o.objectMode&&(o.objectMode=!(o.binary===!0||void 0===o.binary));var E=i(o,S,f);o.objectMode||(E._writev=m);var k=o.browserBufferSize||524288,I=o.browserBufferTimeout||1e3;"object"==typeof t?v=t:(v=w&&_?new u(t,e):new u(t,e,o),v.binaryType="arraybuffer"),v.readyState===v.OPEN?y=E:(y=a.obj(),v.onopen=l),y.socket=v,v.onclose=p,v.onerror=d,v.onmessage=g,E.on("close",b);var x=!o.objectMode;return y}var s=t("readable-stream").Transform,a=t("duplexify"),u=t("ws"),c=t("safe-buffer").Buffer;e.exports=o}).call(this,t("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{_process:7,duplexify:27,"readable-stream":49,"safe-buffer":51,ws:56}],56:[function(t,e,r){var n=null;"undefined"!=typeof WebSocket?n=WebSocket:"undefined"!=typeof MozWebSocket?n=MozWebSocket:"undefined"!=typeof window&&(n=window.WebSocket||window.MozWebSocket),e.exports=n},{}],57:[function(t,e,r){function n(t,e){function r(){for(var e=new Array(arguments.length),r=0;r<e.length;r++)e[r]=arguments[r];var n=t.apply(this,e),i=e[e.length-1];return"function"==typeof n&&n!==i&&Object.keys(i).forEach(function(t){n[t]=i[t]}),n}if(t&&e)return n(t)(e);if("function"!=typeof t)throw new TypeError("need wrapper function");return Object.keys(t).forEach(function(e){r[e]=t[e]}),r}e.exports=n},{}],58:[function(t,e,r){function n(){for(var t={},e=0;e<arguments.length;e++){var r=arguments[e];for(var n in r)i.call(r,n)&&(t[n]=r[n])}return t}e.exports=n;var i=Object.prototype.hasOwnProperty},{}]},{},[24])(24)});
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($scope, $rootScope, $q, $state, $timeout, $mdSidenav, $window, $translate, $mdToast, msNavigationService, session, meisterapi, MEISTER)
    {
        var vm = this;
		vm.user = session.getUser();
		
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };
		
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

		vm.unseenNotifications = [];
		$scope.$on('new.cpo.request.broadcast', function(event, args) {
			$timeout(function() {
				$scope.$apply(function () {
					vm.unseenNotifications.push(args);
				});
			},1000); 
		});
		
		vm.dates = {startDate: moment().startOf('day'), endDate: moment()};
		
        init();

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
			
			if (vm.user.role === 'ROLE_CPO'){
				meisterapi.getNotificationsByDate(moment(vm.dates.startDate).utc().format('YYYY-MM-DDTHH:mm:ss.000[Z]'), moment(vm.dates.endDate).utc().format('YYYY-MM-DDTHH:mm:ss.000[Z]')).then(function (result) {
					
					for (var j = 0; j < result.length; j++) {
						var notification = result[j];
						if (notification.status == 0){
							vm.unseenNotifications.push(notification)
						}
					}
				});
			}
			
        }
		
		
		vm.goToRequest = goToRequest;
		
		function goToRequest(notificationId, requestID) {
			
			meisterapi.changeNotificationStatus(notificationId).then(function (result) {
				for (var j = 0; j < vm.unseenNotifications.length; j++) {
					var notification = vm.unseenNotifications[j];
					if (notification.notificationId = notificationId){
						vm.unseenNotifications.splice(j,1);
						break;
					}
				}
			});
			
			$state.go('app.request', {'requestID': requestID})
		}
		


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            // Do logout here..
			session.destroy();
			$window.location.href = MEISTER.url + '/' + MEISTER.loginPage;
			
			
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' ) {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ ) {
                if ( flatNavigation[x].uisref ) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query ) {
                navigation = navigation.filter(function (item) {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 ) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if ( item.uisref ) {
                // If there are state params,
                // use them...
                if ( item.stateParams ) {
                    $state.go(item.state, item.stateParams);
                }
                else {
                    $state.go(item.state);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, msNavigationService, session)
    {
        var vm = this;
		vm.user = session.getUser();

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

		init();
		
		function init() {
			removeUnauthorized();
		}
		
		function removeUnauthorized() {
			if (vm.user.role == 'ROLE_EV_FLEET_MANAGER') {
				msNavigationService.deleteItem('monitoring');
				msNavigationService.deleteItem('requests');
				msNavigationService.deleteItem('users');
				msNavigationService.deleteItem('tokens');
				msNavigationService.deleteItem('sessions');
				msNavigationService.deleteItem('platform-users');
			}
			else if (vm.user.role == 'ROLE_CPO'){
				msNavigationService.deleteItem('cars');
				msNavigationService.deleteItem('platform-users');
			}
			else {
				msNavigationService.deleteItem('monitoring');
				msNavigationService.deleteItem('requests');
				msNavigationService.deleteItem('users');
				msNavigationService.deleteItem('tokens');
				msNavigationService.deleteItem('sessions');
				msNavigationService.deleteItem('cars');
			}
		}
		
		
        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',
			
			// Authentication
            'app.auth',
			
			// Monitoring
			'app.monitoring',
			
			// Parking
			'app.parking',
			
			// Charger
			'app.charger',
			
			// Requests
			'app.requests',
			
			// Request
			'app.request',
			
			// Cars
            'app.cars',
              
            // Car
			'app.car',
			
			// Users
			'app.users',
			
			// Tokens
			'app.tokens',
			
			// Settings
			//'app.settings',
			
			// Sessions
			'app.sessions',
			
			// Session
			'app.session',
			
			// Platform Users
			'app.platform-users',
			
			
			
			// Profile
			'app.profile'
			
        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock(session, $rootScope, $timeout, $state, MEISTER) {
        var vm = {};
		
		session.start();
		vm.user = session.getUser();
		
		// Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
            $timeout(function () {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
		
		$rootScope.$on('$stateChangeStart', function(e, toState, toParams, fromState, fromParams) {
			
			if(toState.url.match(/\/auth\//) || toState.url.match(/\/change_pass/)){
				return; // no need to redirect 
			}
			
			if (vm.user != undefined){
				
			}
			else {
				e.preventDefault(); // stop current execution
				$state.go('app.auth_login'); // go to login
			}
			
		});
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/auth/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigationFullwidthToolbar2';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController($rootScope, Notification, session, fuseTheming, MEISTER){
        var vm = this;
		vm.user = session.getUser();
        vm.themes = fuseTheming.themes;
		
		/* IF AUTH CONNECT TO SOCKETS */
		if (vm.user != undefined && vm.user.role == 'ROLE_CPO'){
			connectToSockets();
		}
		
		function connectToSockets() {
			if (MEISTER.wsckUrl) {
                $rootScope.client = mqtt.connect(MEISTER.wsckUrl, {keepalive: 120});
                $rootScope.client.on('connect', function () {
                    console.log('WebSocket Client Connected');
                    
					$rootScope.client.subscribe('meister/cpo/' + vm.user.country_code + '/' + vm.user.party_id + '/notifications');
					$rootScope.client.subscribe('meister/cpo/' + vm.user.country_code + '/' + vm.user.party_id + '/monitoring');
					
					$rootScope.client.on('message', function (topic, message) {
						if(topic==='meister/cpo/' + vm.user.country_code + '/' + vm.user.party_id + '/notifications') {
							var notification = JSON.parse(message);
							$rootScope.$broadcast('new.cpo.request.broadcast', notification);
						}
						
						if(topic==='meister/cpo/' + vm.user.country_code + '/' + vm.user.party_id + '/monitoring') {
							var monitoring = JSON.parse(message);
							
							$rootScope.$broadcast('new.cpo.monitoring.broadcast', monitoring);
						}
						
					});
					
                });
            }
        }
		
		function showNotification(title,message,type) {
            if(type==="Error") {
                Notification.error({
                    title:title,
                    message: message,
                    delay: null,
                    startTop: 20,
                    startRight: 10,
                    verticalSpacing: 20,
                    horizontalSpacing: 20,
                    positionX: 'right',
                    positionY: 'bottom',
                });
            }
            else if(type==="Info") {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: null,
                    startTop: 20,
                    startRight: 10,
                    verticalSpacing: 20,
                    horizontalSpacing: 20,
                    positionX: 'right',
                    positionY: 'bottom',
                });
            }
            else if(type==="Warning") {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: null,
                    startTop: 20,
                    startRight: 10,
                    verticalSpacing: 20,
                    horizontalSpacing: 20,
                    positionX: 'right',
                    positionY: 'bottom',
                });
            }
            else if(type==="Success") {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: null,
                    startTop: 20,
                    startRight: 10,
                    verticalSpacing: 20,
                    horizontalSpacing: 20,
                    positionX: 'right',
                    positionY: 'bottom',
                });
            }
        }
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider, paginationTemplateProvider)
    {
        // Put your common app configurations here
		paginationTemplateProvider.setPath('app/core/pagination/dirPagination.tpl.html');

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
(function () {
	'use strict';
	
	angular
		.module('fuse')
		.constant('MEISTER', getMEISTERConstants());
	
	function getMEISTERConstants() {
		
		var DEV = false;
		
		if (DEV) {
			var url = "http://195.251.117.55:3030";
			//var api = "http://160.40.49.109:8080";
			var api = "https://smart-charging.iti.gr/services";
			var wsckUrl = "wss://smart-charging.iti.gr/wss/";
			//var wsckUrl = "ws://microgrid.iti.gr:9001";
			var loginPage = "auth/login";
		}
		else {
			var url = "https://smart-charging.iti.gr";
			var api = "https://smart-charging.iti.gr/services";
			var wsckUrl = "wss://smart-charging.iti.gr/wss/";
			var loginPage = "auth/login";
		}
		
		var MEISTER = {
			url: url,
			api: api,
			wsckUrl: wsckUrl,
			loginPage: loginPage,
			DEV: DEV
		};
		
		return MEISTER;
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth', [
            'app.auth.login'
        ])
        .config(config);

    /** @ngInject */
    function config()
    {
    }
    
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-background-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-background-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/pagination/dirPagination.tpl.html","<div class=\"pagination\" ng-if=\"1 < pages.length || !autoHide\" layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"range-label\"><span>{{range.lower}} - {{range.upper}} of {{range.total}}</span></div><div class=\"range-controls\">\n<a href=\"\" title=\"Previous\" ng-class=\"{disabled : pagination.current == 1}\" \nng-click=\"setCurrent(pagination.current - 1)\">&lang;</a> <a href=\"\" title=\"Next\" \nng-class=\"{disabled : pagination.current == pagination.last}\" ng-click=\"setCurrent(pagination.current + 1)\">&rang;</a>\n</div></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/car/car.html","<div id=\"car\" class=\"page-layout simple fullwidth\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 icon-car\"></i> <span ng-click=\"vm.goToCars()\">{{ \'CARS.CARS_NAV\' | translate}}</span> <i \nclass=\"icon s16 icon-chevron-right\"></i> <span>{{ \'CAR.CAR_NAV\' | translate}}: {{vm.car.id}}</span></div><div \nclass=\"content\" md-background-bg><div class=\"white-bg m-8\" flex><div class=\"p-16 bb\"><span class=\"h3 m-0\">\nElectric Vehicle</span></div><div layout=\"row\" layout-align=\"start start\" flex><div layout=\"column\" class=\"p-16\" \nflex=\"25\"><div layout=\"row\" layout-align=\"start center\" class=\"mb-16\"><md-icon md-font-icon=\"icon-car\" \nclass=\"icon s70 indigo-fg\"></md-icon><div flex><div class=\"h1 font-weight-500 indigo-fg\">\n{{vm.car.brand}} {{vm.car.model}}</div><div class=\"grey-fg\">ID: {{vm.car.id}}</div></div></div><div layout=\"column\" \nclass=\"mb-16\" flex><span class=\"mb-8 font-size-18 blue-grey-fg\">SoC: {{vm.car.soc}}%</span> <span \nclass=\"mb-8 font-size-18 blue-grey-fg\">Capacity: {{vm.car.batteryCapacity}}kWh</span> <span \nclass=\"mb-8 font-size-18 blue-grey-fg\">Plug Type: {{vm.car.plug_type}}</span> <span ng-if=\"vm.car.charging_plan==null\" \nclass=\"mb-8 font-size-18 red-fg\">No Charging Plan!</span></div></div><div class=\"p-16\" \nmap-lazy-load=\"https://maps.google.com/maps/api/js\" flex><ng-map default-style=\"true\" style=\"min-height:200px\" \ncenter=\"{{vm.car.coordinates.latitude}},{{vm.car.coordinates.longitude}}\" zoom=\"14\"><marker id=\"{{vm.car.id}}\" \nposition=\"{{vm.car.coordinates.latitude}}, {{vm.car.coordinates.longitude}}\"></marker></ng-map></div></div></div><div \nclass=\"white-bg m-8\" flex><div class=\"p-16 bb\"><span class=\"h3 m-0\">User Bookings</span></div><div class=\"p-16\" flex>\n<md-table-container flex><table class=\"hovered\" data-md-table md-progress=\"promise\"><thead \nng-if=\"!vm.bookingsTable.options.decapitate\" md-head data-md-order=\"vm.bookingsTable.query.order\"><tr md-row><th \nmd-column width=\"50px\"></th><th md-column md:order:by=\"user_id\">User</th><th md-column md:order:by=\"start_date\"><span>\nStart Date</span></th><th md-column md:order:by=\"end_date\"><span>End Date</span></th></tr></thead><tbody md-body><tr \nmd-row ng-if=\"!vm.bookings.length\"><td md-cell colspan=\"4\"><div class=\"p-25\"><p>No data available in table...</p></div>\n</td></tr><tr md-row \nng-if=\"vm.bookings.length && vm.bookingsTable.filter.search && !(vm.bookings|filter:vm.bookingsTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"4\"><div class=\"p-25\"><h3>Nothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"booking in vm.bookings | filter: vm.bookingsTable.filter.search | orderBy: vm.bookingsTable.query.order | limitTo: vm.bookingsTable.query.limit : (vm.bookingsTable.query.page - 1) * vm.bookingsTable.query.limit\">\n<td md-cell><md-icon md-font-icon=\"icon-calendar-select\" class=\"icon blue-grey-fg\"></md-icon></td><td md-cell><span>\n{{booking.user_id}}</span></td><td md-cell><span>{{booking.start_date | date:\'dd/MM/yyyy HH:mm\'}}</span></td><td \nmd-cell><span>{{booking.end_date | date:\'dd/MM/yyyy HH:mm\'}}</span></td></tr></tbody></table></md-table-container>\n<data-md-table-pagination ng-if=\"vm.bookings.length\" class=\"noborder\" md-limit=\"vm.bookingsTable.query.limit\" \nmd-limit-options=\"vm.bookingsTable.limitOptions\" md-page=\"vm.bookingsTable.query.page\" \nmd-total=\"{{(vm.bookings|filter:vm.bookingsTable.filter.search).length}}\" \nmd-boundary-links=\"vm.bookingsTable.options.boundaryLinks\"></data-md-table-pagination></div></div><div \nclass=\"white-bg m-8\" flex><div class=\"p-16 bb\" layout=\"row\" layout-align=\"space-between center\" flex><span \nclass=\"h3 m-0\">Charging Plan</span><md-button ng-if=\"vm.car.charging_plan!=null\" \nng-click=\"vm.controlPlan($event, vm.car.id, vm.car, null, \'DELETE\')\" class=\"md-icon-button\" aria-label=\"Delete Plan\">\n<md-tooltip md-direction=\"left\">Delete Plan</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"icon blue-grey-fg\" \naria-hidden=\"true\"></md-icon></md-button></div><div ng-if=\"vm.car.charging_plan!=null\" layout=\"row\" \nlayout-align=\"start center\" class=\"p-16\" flex><div layout=\"column\" layout-align=\"center center\" flex><md-icon \nmd-font-icon=\"meister-icon-connector-closed-h\" class=\"icon s72 blue-grey-fg\"></md-icon><span class=\"h2\">Charger</span> \n<span>{{vm.car.charging_plan.charger_id}} : {{vm.car.charging_plan.connector_id}}</span></div><div layout=\"column\" \nlayout-align=\"center center\" flex><md-icon md-font-icon=\"icon-clock\" class=\"icon s72 blue-grey-fg\"></md-icon><span \nclass=\"h2\">Duration</span> <span>\n{{vm.car.charging_plan.start_date | date:\'dd/MM/yyyy HH:mm\'}} - {{vm.car.charging_plan.end_date | date:\'dd/MM/yyyy HH:mm\'}}\n</span></div><div layout=\"column\" layout-align=\"center center\" flex><md-icon md-font-icon=\"icon-battery\" \nclass=\"icon s72 blue-grey-fg\"></md-icon><span class=\"h2\">SoC</span> <span>\n{{vm.car.charging_plan.soc_initial}}% -> {{vm.car.charging_plan.soc_final}}%</span></div></div><div \nng-if=\"vm.car.charging_plan==null\" layout=\"column\" class=\"p-16\" style=\"min-height:600px\" flex><h3>Check Availability\n</h3><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"m-0\"><label for=\"startDate\">Start Date\n</label><input ng-model=\"vm.dates.startDate\" datetime-picker date-format=\"yyyy-MM-dd HH:mm\"></md-input-container>\n<md-input-container class=\"m-0\"><label for=\"endDate\">End Date</label><input ng-model=\"vm.dates.endDate\" \ndatetime-picker date-format=\"yyyy-MM-dd HH:mm\"></md-input-container><md-button class=\"md-raised md-accent white-fg\" \nng-disabled=\"vm.dates.startDate==undefined || vm.dates.endDate==undefined\" ng-click=\"vm.checkChargerAvailability()\">\nCheck</md-button></div><div ng-if=\"vm.chargers.length > 0\" flex><h3>Available Chargers</h3><md-table-container><table \nclass=\"hovered\" data-md-table md-progress=\"promise\"><thead ng-if=\"!vm.chargersTable.options.decapitate\" md-head \ndata-md-order=\"vm.chargersTable.query.order\"><tr md-row><th md-column width=\"50px\"></th><th md-column md:order:by=\"id\">\n<span>Charger</span></th><th md-column md:order:by=\"location\"><span>Location</span></th><th md-column \nmd:order:by=\"connectorid\"><span>Connector</span></th><th md-column md:order:by=\"format\"><span>Format</span></th><th \nmd-column md:order:by=\"powertype\"><span>Power Type</span></th><th md-column md:order:by=\"maxpower\"><span>Max Power(kW)\n</span></th><th ng-if=\"vm.virtualUser\" md-column><span>Actions</span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"!vm.chargers.length\"><td md-cell colspan=\"8\"><div class=\"p-25\"><p>No data available in table...</p></div></td>\n</tr><tr md-row \nng-if=\"vm.chargers.length && vm.chargersTable.filter.search && !(vm.chargers|filter:vm.chargersTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"8\"><div class=\"p-25\"><h3>Nothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"charger in vm.chargers | filter: vm.chargersTable.filter.search | orderBy: vm.chargersTable.query.order | limitTo: vm.chargersTable.query.limit : (vm.chargersTable.query.page - 1) * vm.chargersTable.query.limit\">\n<td md-cell><md-icon md-font-icon=\"meister-icon-connector-closed-h\" class=\"icon blue-grey-fg\"></md-icon></td><td \nmd-cell><span>{{charger.id}}</span></td><td md-cell><span>{{charger.location}}</span></td><td md-cell><span>\n{{charger.connectorid}}</span></td><td md-cell><span>{{charger.format}}</span></td><td md-cell><span>\n{{charger.powertype}}</span></td><td md-cell><span>{{charger.maxpower}}</span></td><td ng-if=\"vm.virtualUser\" md-cell>\n<md-button ng-click=\"vm.controlPlan($event, vm.car.id, vm.car, charger, \'SELECT\')\" class=\"md-icon-button\" \naria-label=\"SetUp Charger\"><md-tooltip md-direction=\"left\">Setup Charger</md-tooltip><md-icon \nmd-font-icon=\"icon-calendar-plus\" class=\"icon blue-grey-fg\" aria-hidden=\"true\"></md-icon></md-button></td></tr></tbody>\n</table></md-table-container><data-md-table-pagination ng-if=\"vm.chargers.length\" class=\"noborder\" \nmd-limit=\"vm.chargersTable.query.limit\" md-limit-options=\"vm.chargersTable.limitOptions\" \nmd-page=\"vm.chargersTable.query.page\" md-total=\"{{(vm.chargers|filter:vm.chargersTable.filter.search).length}}\" \nmd-boundary-links=\"vm.chargersTable.options.boundaryLinks\"></data-md-table-pagination></div></div></div></div></div>");
$templateCache.put("app/main/cars/cars.html","<div id=\"cars\" class=\"page-layout simple fullwidth\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><i\n class=\"icon s16 icon-car\"></i> <span class=\"item\">{{ \'CARS.CARS_NAV\' | translate}}</span></div><div class=\"content\" \nmd-background-bg><div class=\"white-bg m-8\" flex><div class=\"p-16 bb\"><span class=\"h3 m-0\">Available Electric Vehicles\n</span></div><div class=\"p-16\" flex><md-table-container><table class=\"hovered linked\" data-md-table \nmd-progress=\"promise\"><thead ng-if=\"!vm.carsTable.options.decapitate\" md-head data-md-order=\"vm.carsTable.query.order\">\n<tr md-row><th class=\"indigo-fg\" width=\"50px\" md-column></th><th class=\"indigo-fg\" md-column md:order:by=\"id\">ID</th>\n<th class=\"indigo-fg\" md-column md:order:by=\"brand\">Brand</th><th class=\"indigo-fg\" md-column md:order:by=\"model\">Model\n</th><th class=\"indigo-fg\" md-column md:order:by=\"batteryCapacity\">Battery Capacity (kW)</th><th class=\"indigo-fg\" \nmd-column md:order:by=\"soc\"><span>SoC (%)</span></th><th class=\"indigo-fg\" md-column><span>Charging</span></th></tr>\n</thead><tbody md-body><tr md-row ng-if=\"!vm.tmpResults.length\"><td md-cell colspan=\"8\"><div class=\"p-25\"><p>\nNo data available in table...</p></div></td></tr><tr md-row \nng-if=\"vm.tmpResults.length && vm.carsTable.filter.search && !(vm.tmpResults|filter:vm.carsTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"8\"><div class=\"p-25\"><h3>Nothing found...</h3></div></td></tr><tr md-row \nng-click=\"vm.goToCar(result.id)\" \ndata-ng-repeat=\"result in vm.tmpResults | filter: vm.carsTable.filter.search | orderBy: vm.carsTable.query.order | limitTo: vm.carsTable.query.limit : (vm.carsTable.query.page - 1) * vm.carsTable.query.limit\">\n<td md-cell><md-icon md-font-icon=\"icon-car indigo-fg\" class=\"icon\" aria-hidden=\"true\"></md-icon></td><td md-cell>\n<span>{{result.id}}</span></td><td md-cell><span>{{result.brand}}</span></td><td md-cell><span>{{result.model}}</span>\n</td><td md-cell><span>{{result.batteryCapacity}}kW</span></td><td md-cell><span>{{result.soc}}%</span></td><td \nmd-cell><span ng-if=\"result.charging_plan!=null\">\n{{ result.charging_plan.start_date | date: \'dd/MM/yyyy HH:mm\' }} - {{ result.charging_plan.end_date | date: \'dd/MM/yyyy HH:mm\' }}\n</span> <span ng-if=\"result.charging_plan==null\">No Charging Plan</span></td></tr></tbody></table></md-table-container>\n<data-md-table-pagination ng-if=\"vm.tmpResults.length\" class=\"noborder\" md-limit=\"vm.carsTable.query.limit\" \nmd-limit-options=\"vm.carsTable.limitOptions\" md-page=\"vm.carsTable.query.page\" \nmd-total=\"{{(vm.tmpResults|filter:vm.carsTable.filter.search).length}}\" \nmd-boundary-links=\"vm.carsTable.options.boundaryLinks\"></data-md-table-pagination></div></div></div></div>");
$templateCache.put("app/main/monitoring/monitoring.html","<div id=\"monitoring\" class=\"page-layout simple fullwidth\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 icon-chart-line\"></i> <span class=\"item\">\n{{ \'MONITORING.MONITORING_NAV\' | translate}}</span></div><div class=\"content\" md-background-bg><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><div class=\"white-bg m-8 list b\" flex><div class=\"p-16\" layout=\"row\" \nlayout-align=\"space-between center\"><h2 class=\"font-wight-500 m-0\">{{ \'MONITORING.LOCATIONS\' | translate}}</h2>\n<md-button class=\"md-icon-button\" ng-click=\"vm.controlParking($event, null, \'ADD\')\" aria-label=\"ADD Location\" \naria-label-translate=\"{{ \'MONITORING.ACTIONS.ADD_LOCATION\' | translate}}\"><md-tooltip md-direction=\"left\">\n{{ \'MONITORING.ACTIONS.ADD_LOCATION\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\" class=\"icon\">\n</md-icon></md-button></div><div class=\"separator\"></div><div class=\"search-wrapper mt-8 p-16\" flex><input id=\"search\" \nclass=\"search\" ng-model=\"search\" name=\"search\" type=\"text\" \nplaceholder=\"{{ \'MONITORING.ACTIONS.SEARCH_PLACEHOLDER\' | translate}}\"></div><div class=\"list-item p-16\" layout=\"row\" \nlayout-align=\"start center\" \ndir-paginate=\"item in filtered = (vm.results | filter: search | itemsPerPage: vm.itemsPerPage)\" flex><div \nclass=\"md-menu-demo\" ng-cloak><div class=\"menu-demo-container\" layout-align=\"center center\" layout=\"column\"><md-menu>\n<md-button class=\"small md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\" aria-label=\"Control Location\">\n<md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon blue-fg\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.controlParking($event, item, \'EDIT\')\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"icon\"></md-icon><span>Edit</span></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item>\n<md-button ng-click=\"vm.controlParking($event, item, \'DELETE\')\"><md-icon md-font-icon=\"icon-trash\" class=\"icon\">\n</md-icon><span>Delete</span></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button \nng-click=\"vm.showDetail($event,item)\"><md-icon md-font-icon=\"icon-map\" class=\"icon\"></md-icon><span>Show on map</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div ng-click=\"vm.showDetail($event,item)\"><md-icon \nmd-font-icon=\"icon-parking\" class=\"icon indigo-fg s48\"></md-icon></div><div layout=\"column\" layout-align=\"start start\" \nflex=\"65\"><span style=\"color:#8BC34A;cursor:pointer\" class=\"font-size-14 font-weight-600\" \nng-click=\"vm.goToParking(item.id);\">{{item.name}}</span> <span>\n{{item.address}}, {{item.postal_code}}, {{item.city}} {{item.country}}</span> <span><md-icon \nmd-font-icon=\"icon-gas-station\" class=\"icon blue-grey-fg mr-8\"></md-icon>{{item.evses.length}}</span></div><div \nflex=\"25\"><canvas height=\"60\" width=\"150\" id=\"pie_{{item.id}}\" class=\"chart chart-pie\" chart-data=\"item.chart.data\" \nchart-colors=\"item.chart.colors\" chart-labels=\"item.chart.labels\" chart-options=\"item.chart.options\"></canvas></div>\n</div><div class=\"list-item p-16\" layout=\"row\" ng-if=\"filtered.length === 0\"><span \nclass=\"font-size-14 font-weight-400 p-16\">No available locations</span></div><div class=\"pagination-wrapper\" \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"pages\" layout=\"row\" layout-align=\"start center\">\n<label for=\"search\">Items per page:</label><input type=\"number\" min=\"5\" max=\"20\" step=\"5\" class=\"form-control\" \nng-model=\"vm.itemsPerPage\"></div><dir-pagination-controls auto-hide=\"false\"></dir-pagination-controls></div></div><div \nng-if=\"vm-results.length != 0\" flex><div class=\"white-bg p-16 m-8 b\" \nmap-lazy-load=\"https://maps.google.com/maps/api/js\"><ng-map default-style=\"true\" style=\"min-height:600px\" \nzoom-to-include-markers=\"auto\"><div><marker id=\"{{item.id}}\" ng-repeat=\"item in vm.results | filter:search\" \nicon=\"https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld={{item.evses.length}}|002b7f|FFFFFF\" \nposition=\"{{item.coordinates.latitude}}, {{item.coordinates.longitude}}\" on-click=\"vm.showDetail(item)\"></marker>\n<info-window id=\"foo-iw\"><div ng-non-bindable=\"\"><h3 style=\"color:#8BC34A\" class=\"font-weight-600\">{{vm.item.name}}\n</h3><p class=\"font-size-14\">{{vm.item.address}}, {{vm.item.postal_code}}, {{vm.item.city}} {{vm.item.country}}</p><p>\nOccupied: {{vm.item.chargerStatus.charging}}, Reserved: {{vm.item.chargerStatus.reserved}}, Available: {{vm.item.chargerStatus.available}}, Out Of Order: {{vm.item.chargerStatus.out_of_order}}\n</p></div></info-window></div></ng-map></div></div></div></div></div>");
$templateCache.put("app/main/charger/charger.html","<div id=\"charger\" class=\"page-layout simple fullwidth\" ng-model=\"vm.parking\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 icon-chart-line\"></i> <span ng-click=\"vm.gotomonitoring()\">\n{{ \'CHARGER.MONITORING_NAV\' | translate}}</span> <i class=\"icon s16 icon-chevron-right\"></i> <span \nng-click=\"vm.gotoparking()\">{{vm.parkingName}}</span> <i class=\"icon s16 icon-chevron-right\"></i> <span>\n{{ \'CHARGER.CHARGER_NAV\' | translate}}:&nbsp;{{vm.chargerId}}</span></div><div class=\"content\" md-background-bg><div \nclass=\"white-bg mb-16\" flex><div class=\"p-16 bb\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start end\" flex><md-icon md-font-icon=\"icon-gas-station\" class=\"icon indigo-fg s48\"></md-icon><div flex>\n<span class=\"h2\" style=\"color:rgb(124,179,66)\">Charger: {{vm.charger.uid}}</span> <span class=\"ml-8 mr-8\">/</span> \n<span class=\"h4\">{{vm.charger.status}}</span></div></div></div><div class=\"p-16\" layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\" flex><div class=\"\" flex><div layout=\"row\" layout-align=\"start center\" class=\"h4 p-8\">\n<md-icon md-font-icon=\"icon-pulse\" class=\"icon indigo-fg mr-8\"></md-icon><div class=\"\" flex><span \nclass=\"h4 indigo-fg mr-16\">Status:</span><span>{{vm.charger.status}}</span></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"h4 p-8\"><md-icon md-font-icon=\"icon-home-modern\" class=\"icon indigo-fg mr-8\">\n</md-icon><div class=\"\" flex><span class=\"h4 indigo-fg mr-16\">Floor Level:</span><span>{{vm.charger.floor_level}}\n</span></div></div></div><div flex><div layout=\"row\" layout-align=\"start center\" class=\"h4 p-8\"><md-icon \nmd-font-icon=\"meister-icon-connector-open-v\" class=\"icon indigo-fg mr-8\"></md-icon><div class=\"\" flex><span \nclass=\"h4 indigo-fg mr-16\">Connectors</span><span>{{vm.charger.connectors.length}}</span></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"h4 p-8\"><md-icon md-font-icon=\"icon-timetable\" class=\"icon indigo-fg mr-8\">\n</md-icon><div class=\"\" flex><span class=\"mr-8 indigo-fg\">Last Update:</span> <span>\n{{vm.charger.last_updated | date:\'dd/MM/yyyy HH:mm\'}}</span></div></div></div></div></div><div \nng-show=\"vm.charger.capabilities.length > 0\" class=\"white-bg mb-16 p-16\" flex><div class=\"font-size-14 mb-8\" \nlayout=\"row\" layout-align=\"start center\" flex><span flex>Capabilities</span></div><div class=\"m-8\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div data-ng-repeat=\"capability in vm.charger.capabilities\" class=\"p-16 mr-16\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"{{vm.capabilities[capability].icon}}\" \nclass=\"icon mr-8\"></md-icon><span flex>{{vm.capabilities[capability].name}}</span></div></div></div><div \nng-show=\"vm.charger.statusSchedule.length > 0\" class=\"white-bg mb-16 p-16\" flex><div class=\"font-size-14 mb-8\" \nlayout=\"row\" layout-align=\"start center\" flex><span flex>Status Schedule</span></div><div class=\"b m-8\" flex><table \nclass=\"simple hovered\" ms-responsive-table flex><thead><tr><th class=\"black-fg\">Start Date</th><th class=\"black-fg\">\nEnd Date</th><th class=\"black-fg\">Status</th></tr></thead><tbody><tr \ndata-ng-repeat=\"result in vm.charger.statusSchedule\"><td><span>{{result.period_begin | date: \'dd/MM/yyyy HH:mm\' }}\n</span></td><td><span>{{result.period_end | date: \'dd/MM/yyyy HH:mm\' }}</span></td><td><span>{{result.status}}</span>\n</td></tr></tbody></table></div></div><div class=\"white-bg connectors mb-16\" flex><div class=\"p-16 bb\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h3 m-0\">Connectors</span></div><div \nclass=\"search-wrapper pt-16 pr-16 pl-16\" flex><input id=\"search\" class=\"search\" ng-model=\"search\" name=\"search\" \ntype=\"text\" placeholder=\"{{ \'MONITORING.ACTIONS.SEARCH_PLACEHOLDER\' | translate}}\"></div><div class=\"list p-16\" \nlayout=\"row\" layout-align=\"start center\" layout-wrap flex><div class=\"list-item m-8\" \ndir-paginate=\"connector in filtered = (vm.charger.connectors | filter: search | itemsPerPage: vm.itemsPerPage)\"><div \nclass=\"item-header p-16\" layout=\"row\" layout-align=\"space-between center\"><h3 class=\"m-0\">Connector: {{connector.id}}\n</h3><small>{{ connector.format }} / {{ connector.power_type }}</small></div><div class=\"item-body p-16\" layout=\"row\" \nlayout-align=\"start start\"><div class=\"mr-16\" layout=\"column\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"meister-icon-connector-open-v\" class=\"icon icon-status\" \nng-class=\"connector.amperage > 0 ? \'CHARGING\' : \'AVAILABLE\'\"></md-icon><div class=\"text-status\" \nng-class=\"connector.amperage > 0 ? \'CHARGING\' : \'AVAILABLE\'\">{{ connector.amperage > 0 ? \'CHARGING\' : \'AVAILABLE\' }}\n</div></div><div flex><h4 class=\"m-0 font-weight-500\">{{ connector.standard }}</h4><div>\n{{connector.locked === \'ON\' ? \'Locked\' : \'Unlocked\'}}</div><div>Max Voltage: {{ connector.max_voltage }}V</div><div>\nMax Amperage:{{ connector.max_amperage }}A</div><div>Max Power: {{ connector.max_electric_power }}kW</div></div></div>\n<div class=\"item-footer p-16\" layout=\"row\" layout-align=\"space-between center\"><div><b>F:</b>\n {{ connector.frequency | number:1 }}Hz</div><div><b>V:</b> {{ connector.voltage | number:1 }}V</div><div><b>A:</b>\n {{ connector.amperage | number:1 }}A</div><div><b>P:</b> {{ connector.active_power | number:1 }}W</div></div></div>\n<div class=\"list-item m-8\" ng-if=\"filtered.length === 0\"><div class=\"item-body p-16\" layout=\"row\" \nlayout-align=\"start center\"><div><md-icon md-font-icon=\"meister-icon-connector-closed-v\" \nclass=\"icon icon-status mr-16\"></md-icon></div><div flex><span class=\"font-size-14 font-weight-400 p-16\">\nNo available chargers</span></div></div></div></div><div class=\"separator\"></div><div class=\"pagination-wrapper\" \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"pages\" layout=\"row\" layout-align=\"start center\">\n<label for=\"search\">Items per page:</label><input type=\"number\" min=\"5\" max=\"20\" step=\"5\" class=\"form-control\" \nng-model=\"vm.itemsPerPage\"></div><dir-pagination-controls auto-hide=\"false\"></dir-pagination-controls></div></div>\n</div></div>");
$templateCache.put("app/main/parking/parking.html","<div id=\"parking\" class=\"page-layout simple fullwidth\" ng-model=\"vm.parking\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 icon-chart-line\"></i> <span ng-click=\"vm.gotomonitoring()\">\n{{ \'MONITORING.MONITORING_NAV\' | translate}}</span> <i class=\"icon s16 icon-chevron-right\"></i> <span>\nLOCATION:&nbsp;{{vm.parking.name}}</span></div><div class=\"content\" md-background-bg><div class=\"white-bg mb-16\" flex>\n<div class=\"p-16 bb\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start end\" \nclass=\"\"><md-icon md-font-icon=\"icon-parking\" class=\"icon indigo-fg s48\"></md-icon><div flex><span class=\"h2\" \nstyle=\"color:rgb(124,179,66)\">{{vm.parking.name}}</span> <span class=\"ml-8 mr-8\">/</span> <span class=\"grey-fg h4\">\n{{vm.locationTypes[vm.parking.type].name}}</span></div></div></div><div class=\"p-16\" layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\" flex><div class=\"\" flex><div layout=\"row\" layout-align=\"start center\" \nclass=\"h4 p-8\"><md-icon md-font-icon=\"icon-account-key\" class=\"icon indigo-fg mr-8\"></md-icon><div class=\"\" flex><span \nclass=\"h4 indigo-fg mr-16\">Owner:</span><span>{{vm.parking.owner.name}}</span></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"h4 p-8\"><md-icon md-font-icon=\"icon-account\" class=\"icon indigo-fg mr-8\"></md-icon>\n<div class=\"\" flex><span class=\"h4 indigo-fg mr-16\">Operator:</span><span>{{vm.parking.operator.name}}</span></div>\n</div><div layout=\"row\" layout-align=\"start center\" class=\"h4 p-8\"><md-icon md-font-icon=\"icon-home-modern\" \nclass=\"icon indigo-fg mr-8\"></md-icon><div class=\"\" layout=\"row\" flex><span class=\"h4 indigo-fg mr-8\">Facilities:\n</span><div layout=\"row\" ng-if=\"vm.parking.facilities.length > 0\"><span class=\"mr-8\" \nng-repeat=\"facility in vm.parking.facilities track by $index\">{{vm.facilities[facility].name}}<span \nng-if=\"$index != vm.parking.facilities.length-1\">,</span></span></div></div></div></div><div class=\"\" flex><div \nlayout=\"row\" layout-align=\"start center\" class=\"h4 p-8\"><md-icon md-font-icon=\"icon-clock\" class=\"icon indigo-fg mr-8\">\n</md-icon><div class=\"\" flex><span class=\"mr-8 indigo-fg\">Opening Times:</span><span \nng-if=\"vm.parking.opening_times.twentyfourseven\">24/7</span></div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"h4 p-8\"><md-icon md-font-icon=\"meister-icon-charging\" class=\"icon indigo-fg mr-8\"></md-icon><div class=\"\" flex>\n<span class=\"mr-8 indigo-fg\">Charging when closed:</span> <span>{{vm.parking.charging_when_closed ? \'YES\' : \'NO\'}}\n</span></div></div><div layout=\"row\" layout-align=\"start center\" class=\"h4 p-8\"><md-icon \nmd-font-icon=\"meister-icon-connector-closed-v\" class=\"icon indigo-fg mr-8\"></md-icon><div class=\"\" flex><span \nclass=\"mr-8 indigo-fg\">Chargers:</span><span>{{vm.chargersNo}}</span></div></div></div></div></div><div \nclass=\"white-bg chargers mb-16\" flex><div class=\"p-16 bb\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"h3 m-0\">Chargers</span><md-button class=\"md-raised indigo-bg white-fg m-0\" \nng-click=\"vm.controlCharger($event, vm.parking.id, null, \'ADD\')\" aria-label=\"Add Charger\"><md-icon \nmd-font-icon=\"icon-battery-plus\" class=\"icon\"></md-icon>Add Charger</md-button></div><div \nclass=\"search-wrapper pt-16 pr-16 pl-16\" flex><input id=\"search\" class=\"search\" ng-model=\"search\" name=\"search\" \ntype=\"text\" placeholder=\"{{ \'MONITORING.ACTIONS.SEARCH_PLACEHOLDER\' | translate}}\"></div><div class=\"list p-16\" \nlayout=\"row\" layout-align=\"start center\" layout-wrap flex><div class=\"list-item m-8\" \ndir-paginate=\"charger in filtered = (vm.parking.evses | filter: search | itemsPerPage: vm.itemsPerPage)\"><div \nclass=\"item-header p-16\" layout=\"row\" layout-align=\"space-between center\"><h3 class=\"m-0\" \nng-click=\"vm.goToCharger(charger.uid)\">Charger: {{charger.uid}}</h3><div><md-button class=\"md-icon-button\" \nng-click=\"vm.controlCharger($event, vm.parking.id, charger, \'EDIT\')\" aria-label=\"Edit Charger\"><md-tooltip \nmd-direction=\"left\">Edit Charger</md-tooltip><md-icon md-font-icon=\"icon-pencil\" class=\"icon\"></md-icon></md-button>\n<md-button class=\"md-icon-button\" ng-click=\"vm.controlCharger($event, vm.parking.id, charger, \'DELETE\')\" \naria-label=\"Delete Charger\"><md-tooltip md-direction=\"left\">Delete Charger</md-tooltip><md-icon \nmd-font-icon=\"icon-trash\" class=\"icon\"></md-icon></md-button></div></div><div class=\"item-body p-16\" layout=\"row\" \nlayout-align=\"start start\"><div class=\"mr-16\" layout=\"column\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-gas-station\" class=\"icon icon-status\" ng-class=\"charger.status\"></md-icon><div class=\"text-status\" \nng-class=\"charger.status\">{{charger.status}}</div></div><div flex><div>Connectors: {{charger.connectors.length}}</div>\n<div>Floor Level: {{charger.floor_level}}</div></div></div><div class=\"item-footer p-16 text-right\"><span>\nUpdate: {{charger.last_updated | date:\'dd/MM/yyyy HH:mm\'}}</span></div></div><div class=\"list-item m-8\" \nng-if=\"filtered.length === 0\"><div class=\"item-body p-16\" layout=\"row\" layout-align=\"start center\"><div><md-icon \nmd-font-icon=\"icon-gas-station\" class=\"icon icon-status mr-16\"></md-icon></div><div flex><span \nclass=\"font-size-14 font-weight-400 p-16\">No available chargers</span></div></div></div></div><div class=\"separator\">\n</div><div class=\"pagination-wrapper\" layout=\"row\" layout-align=\"space-between center\" flex><div class=\"pages\" \nlayout=\"row\" layout-align=\"start center\"><label for=\"search\">Items per page:</label><input type=\"number\" min=\"5\" \nmax=\"20\" step=\"5\" class=\"form-control\" ng-model=\"vm.itemsPerPage\"></div><dir-pagination-controls auto-hide=\"false\">\n</dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/main/platform-users/platform-users.html","<div id=\"platform-users\" class=\"page-layout simple fullwidth\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 icon-sitemap\"></i> <span class=\"item\">\n{{ \'PLATFORM_USERS.PLATFORM_USERS_NAV\' | translate}}</span></div><div class=\"content\" md-background-bg><div \nclass=\"white-bg\" flex><div class=\"p-16 bb\" layout=\"row\" layout-align=\"space-between center\"><span class=\"h3 m-0\">Users\n</span><md-button class=\"md-raised indigo-bg white-fg m-0\" ng-click=\"vm.controlPlatformUser($event, null, \'ADD\')\" \naria-label=\"Add Charger\"><md-icon md-font-icon=\"icon-battery-plus\" class=\"icon\"></md-icon>Add User</md-button></div>\n<div class=\"p-16\" flex><md-table-container><table class=\"linked hovered\" data-md-table md-progress=\"promise\"><thead \nng-if=\"!vm.platformUsersTable.options.decapitate\" md-head data-md-order=\"vm.platformUsersTable.query.order\"><tr md-row>\n<th md-column>#</th><th md-column md:order:by=\"firstName\">First Name</th><th md-column md:order:by=\"lastName\">Last Name\n</th><th md-column md:order:by=\"username\">Username</th><th md-column md:order:by=\"email\">Email</th><th md-column \nmd:order:by=\"country_code\">Country Code</th><th md-column md:order:by=\"party_id\">Party ID</th><th md-column \nmd:order:by=\"roles\">Role</th><th md-column md:order:by=\"creationDate\"><span>Created</span></th><th md-column><span>\nActions</span></th></tr></thead><tbody md-body><tr md-row ng-if=\"!vm.tmpResults.length\"><td md-cell colspan=\"10\"><div \nclass=\"p-25\"><p>No data available in table...</p></div></td></tr><tr md-row \nng-if=\"vm.tmpResults.length && vm.platformUsersTable.filter.search && !(vm.tmpResults|filter:vm.platformUsersTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"10\"><div class=\"p-25\"><h3>Nothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"user in vm.tmpResults | filter: vm.platformUsersTable.filter.search | orderBy: vm.platformUsersTable.query.order | limitTo: vm.platformUsersTable.query.limit : (vm.platformUsersTable.query.page - 1) * vm.platformUsersTable.query.limit\">\n<td md-cell><md-icon ng-if=\"user.active\" md-font-icon=\"icon-checkbox-marked-circle-outline green-fg\" class=\"icon\" \naria-hidden=\"true\"></md-icon><md-icon ng-if=\"!user.active\" md-font-icon=\"icon-close-circle red-fg\" class=\"icon\" \naria-hidden=\"true\"></md-icon></td><td md-cell><span>{{user.firstName}}</span></td><td md-cell><span>{{user.lastName}}\n</span></td><td md-cell><span>{{user.username}}</span></td><td md-cell><span>{{user.email}}</span></td><td md-cell>\n<span>{{user.country_code}}</span></td><td md-cell><span>{{user.party_id}}</span></td><td md-cell><span \nng-if=\"user.roles === \'ROLE_CPO\'\">CPO</span> <span ng-if=\"user.roles === \'ROLE_DSO\'\">DSO</span> <span \nng-if=\"user.roles === \'ROLE_EV_FLEET_MANAGER\'\">EV Fleet Manager</span> <span ng-if=\"user.roles === \'ROLE_ADMIN\'\">\nAdministrator</span></td><td md-cell><span>{{user.creationDate | date:\'dd/MM/yyyy HH:mm\'}}</span></td><td md-cell>\n<md-button class=\"md-icon-button\" ng-click=\"vm.controlPlatformUser($event, user, \'EDIT\')\" aria-label=\"Edit User\">\n<md-tooltip md-direction=\"left\">Edit User</md-tooltip><md-icon md-font-icon=\"icon-pencil\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-if=\"user.id != vm.user.id\" \nng-click=\"vm.controlPlatformUser($event, user, \'DELETE\')\" aria-label=\"Delete User\"><md-tooltip md-direction=\"left\">\nDelete User</md-tooltip><md-icon md-font-icon=\"icon-trash\" class=\"icon\"></md-icon></md-button></td></tr></tbody>\n</table></md-table-container><data-md-table-pagination ng-if=\"vm.tmpResults.length\" class=\"noborder\" \nmd-limit=\"vm.platformUsersTable.query.limit\" md-limit-options=\"vm.platformUsersTable.limitOptions\" \nmd-page=\"vm.platformUsersTable.query.page\" \nmd-total=\"{{(vm.tmpResults|filter:vm.platformUsersTable.filter.search).length}}\" \nmd-boundary-links=\"vm.platformUsersTable.options.boundaryLinks\"></data-md-table-pagination></div></div></div></div>");
$templateCache.put("app/main/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed fullwidth\"><div id=\"myProfile\"><div class=\"header p-16 bb\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div \nclass=\"user-info\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start end\"><div \nclass=\"\" layout=\"column\" layout-align=\"center center\"><img id=\"profile-image\" class=\"avatar huge\" \nng-src=\"assets/images/avatars/profile.jpg\"></div><div class=\"\" layout=\"column\" layout-align=\"center center\" \nlayout-align-gt-sm=\"center start\"><span class=\"font-size-28\">{{vm.user.firstname}} {{vm.user.lastname}}</span> <span \nclass=\"font-size-22\">{{vm.roles[vm.user.role]}}</span> <span class=\"font-size-16\">{{vm.user.email}}</span></div></div>\n</div><div class=\"content\" flex><md-tabs md-selected=\"vm.selectedIndex\" md-border-bottom md-dynamic-height><md-tab>\n<md-tab-label><span translate=\"PROFILE.ABOUT\">About</span></md-tab-label><md-tab-body><md-content class=\"userinfo-tab\" \nng-include=\"\'app/main/profile/tabs/userinfo/userinfo.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label>\n<span translate=\"PROFILE.USER_SETTINGS\">User Settings</span></md-tab-label><md-tab-body><md-content \nclass=\"usersettings-tab\" ng-include=\"\'app/main/profile/tabs/usersettings/usersettings.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/request/request.html","<div id=\"request\" class=\"page-layout simple fullwidth\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 icon-bell\"></i> <span ng-click=\"vm.goBack()\">\n{{ \'REQUEST.REQUESTS_NAV\' | translate}}</span> <i class=\"icon s16 icon-chevron-right\"></i> <span class=\"item\">\n{{ \'REQUEST.REQUEST_NAV\' | translate}}: {{vm.request.id}}</span></div><div class=\"content\" md-background-bg><div \nclass=\"white-bg mb-16\" flex><div class=\"p-16 bb\"><span class=\"h3 m-0\">Request</span></div><div class=\"p-16\" \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex><div class=\"ms-responsive-table-wrapper p-8\" flex>\n<table class=\"simple\" ms-responsive-table><tbody><tr><td><span class=\"font-weight-500\">ID</span></td><td><span>\n{{vm.request.id}}</span></td></tr><tr><td><span class=\"font-weight-500\">Created</span></td><td><span>\n{{vm.request.timestamp | date:\'dd/MM/yyyy HH:mm\'}}</span></td></tr><tr><td><span class=\"font-weight-500\">Type</span>\n</td><td><span>{{vm.request.requestType}}</span></td></tr><tr><td><span class=\"font-weight-500\">Activate</span></td>\n<td><span>{{vm.request.activation === 1 ? \'Activate\' : \'Deactivate\'}}</span></td></tr><tr><td><span \nclass=\"font-weight-500\">Action</span></td><td><span>\n{{vm.request.action.value}}{{vm.request.action.unit}} at {{vm.request.action.section}}</span></td></tr><tr><td><span \nclass=\"font-weight-500\">Status</span></td><td><span>{{vm.request.requestStatus}}</span><md-button \nng-if=\"vm.request.requestStatus == \'ACCEPTED\'\" class=\"md-icon-button\" aria-label=\"{{vm.request.requestStatus}}\">\n<md-tooltip md-direction=\"left\">Accepted</md-tooltip><md-icon md-font-icon=\"icon-check-circle green-fg\" class=\"icon\" \naria-hidden=\"true\"></md-icon></md-button><md-button ng-if=\"vm.request.requestStatus == \'REJECTED\'\" \nclass=\"md-icon-button\" aria-label=\"{{vm.request.requestStatus}}\"><md-tooltip md-direction=\"left\">Rejected</md-tooltip>\n<md-icon md-font-icon=\"icon-close-circle red-fg\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button><md-button \nng-if=\"vm.request.requestStatus == \'PENDING\'\" class=\"md-icon-button\" aria-label=\"{{vm.request.requestStatus}}\">\n<md-tooltip md-direction=\"left\">Pending</md-tooltip><md-icon md-font-icon=\"icon-clock orange-fg\" class=\"icon\" \naria-hidden=\"true\"></md-icon></md-button></td></tr><tr ng-if=\"vm.request.requestStatus == \'PENDING\'\"><td colspan=\"2\">\n<md-button ng-click=\"vm.cpoResponse(\'ACCEPTED\',vm.request.id)\" class=\"md-raised md-accent white-fg\" \naria-label=\"Accept\"><md-icon md-font-icon=\"icon-check-circle\" class=\"icon white-fg\" aria-hidden=\"true\"></md-icon><span>\nAccept</span></md-button><md-button ng-click=\"vm.cpoResponse(\'REJECTED\',vm.request.id)\" \nclass=\"md-raised md-warn white-fg\" aria-label=\"Reject\"><md-icon md-font-icon=\"icon-close-circle-outline\" \nclass=\"icon white-fg\" aria-hidden=\"true\"></md-icon><span>Reject</span></md-button></td></tr></tbody></table></div><div \nclass=\"ms-responsive-table-wrapper p-8\" flex><table class=\"simple\" ms-responsive-table><tbody><tr><td><span \nclass=\"font-weight-500\">Start Time</span></td><td><span>{{vm.request.start_time | date:\'dd/MM/yyyy HH:mm\'}}</span></td>\n</tr><tr><td><span class=\"font-weight-500\">End Time</span></td><td><span>\n{{vm.request.end_time | date:\'dd/MM/yyyy HH:mm\'}}</span></td></tr><tr><td><span class=\"font-weight-500\">Reward</span>\n</td><td><span>{{vm.request.reward}}€</span></td></tr><tr><td><span class=\"font-weight-500\">Penalty</span></td><td>\n<span>{{vm.request.penalty}}€</span></td></tr><tr><td><span class=\"font-weight-500\">Cost</span></td><td \nng-if=\"vm.request.requestStatus === \'ACCEPTED\'\"><span ng-if=\"vm.historicalResult.cost\" class=\"mr-8\"><b>Acceptance</b>\n: {{(vm.historicalResult.cost - vm.request.reward) | number:3}}€</span></td><td \nng-if=\"vm.request.requestStatus === \'REJECTED\'\"><span ng-if=\"vm.historicalResult.costNoOpt\" class=\"mr-8\"><b>Rejection\n</b>: {{(vm.historicalResult.costNoOpt - vm.request.penalty) | number:3}}€</span></td><td \nng-if=\"vm.request.requestStatus === \'PENDING\'\"><span ng-if=\"vm.exchange.cost\" class=\"mr-8\"><b>Acceptance</b>\n: {{(vm.exchange.cost - vm.request.reward) | number:3}}€</span> <span ng-if=\"vm.exchange.costNoOpt\" class=\"mr-8\"><b>\nRejection</b>: {{(vm.exchange.costNoOpt - vm.request.penalty) | number:3}}€</span> <span ng-if=\"vm.exchange.message\" \nclass=\"red-fg mr-8\">{{vm.exchange.message}}</span> <span ng-if=\"!vm.exchange.cost && !vm.exchange.message\" \nclass=\"mr-8\">Not Calculated Yet!</span><md-button ng-disabled=\"!vm.allowCalculate\" \nng-if=\"vm.request.requestType === \'MAXPRED\' || vm.request.requestType === \'LOCRES\' || vm.request.requestType === \'HARMON\'\" \nclass=\"md-raised md-mini m-0\" ng-click=\"vm.calculate(vm.request.id)\" aria-label=\"Calculate\"><span>Calculate</span>\n</md-button><md-progress-circular ng-show=\"!vm.allowCalculate\" class=\"md-warn\" md-mode=\"indeterminate\" \nmd-diameter=\"24\"></md-progress-circular></td></tr></tbody></table></div></div></div><div \nng-if=\"vm.request.requestStatus != \'PENDING\' && vm.request.activation != 0\" class=\"white-bg mb-16\" flex><div \nclass=\"p-16 bb\" layout=\"row\" layout-align=\"space-between center\"><span class=\"h3 m-0\">Optimized Charger Power Exchange\n</span></div><div ng-if=\"vm.chart.data.length > 0\" class=\"p-16\" flex><canvas id=\"bar\" class=\"chart chart-bar\" \nchart-data=\"vm.chart.data\" chart-labels=\"vm.chart.labels\" chart-options=\"vm.chart.options\" \nchart-colors=\"vm.chart.colors\" chart-series=\"vm.chart.series\"></canvas></div><div class=\"p-16\" flex>\n<md-table-container><table class=\"hovered\" data-md-table md-progress=\"promise\"><thead \nng-if=\"!vm.historicalTable.options.decapitate\" md-head data-md-order=\"vm.historicalTable.query.order\"><tr md-row><th \nclass=\"indigo-fg\" md-column md:order:by=\"location\">Location</th><th class=\"indigo-fg\" md-column md:order:by=\"charger\">\nCharger</th><th class=\"indigo-fg\" md-column md:order:by=\"connector\"><span>Connector</span></th><th class=\"indigo-fg\" \nmd-column md:order:by=\"timestamp\"><span>Start Time</span></th><th class=\"indigo-fg\" md-column md:order:by=\"power\">\n<span>Power</span></th></tr></thead><tbody md-body><tr md-row ng-if=\"!vm.historicalResult.data.length\"><td md-cell \ncolspan=\"5\"><div class=\"p-25\"><span class=\"h4\">\n{{vm.historicalResult[\'message\'] ? vm.historicalResult[\'message\'] : \'No data available in table...\'}}</span></div></td>\n</tr><tr md-row \nng-if=\"vm.historicalResult.data.length && vm.historicalTable.filter.search && !(vm.historicalResult.data|filter:vm.historicalTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"5\"><div class=\"p-25\"><h3>Nothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"result in vm.historicalResult.data | filter: vm.historicalTable.filter.search | orderBy: vm.historicalTable.query.order | limitTo: vm.historicalTable.query.limit : (vm.historicalTable.query.page - 1) * vm.historicalTable.query.limit\">\n<td md-cell><span>{{result.location}}</span></td><td md-cell><span>{{result.charger}}</span></td><td md-cell><span>\n{{result.connector}}</span></td><td md-cell><span>{{result.timestamp | date: \'dd/MM/yyyy HH:mm\' }}</span></td><td \nmd-cell><span>{{result.power}}kW</span></td></tr></tbody></table></md-table-container><data-md-table-pagination \nng-if=\"vm.historicalResult.data.length\" class=\"noborder\" md-limit=\"vm.historicalTable.query.limit\" \nmd-limit-options=\"vm.historicalTable.limitOptions\" md-page=\"vm.historicalTable.query.page\" \nmd-total=\"{{(vm.historicalResult.data|filter:vm.historicalTable.filter.search).length}}\" \nmd-boundary-links=\"vm.historicalTable.options.boundaryLinks\"></data-md-table-pagination></div></div><div \nng-if=\"vm.request.requestStatus === \'PENDING\'\" class=\"white-bg mb-16\" flex><div class=\"p-16 bb\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h3 m-0\">Optimize Charger Power Exchange</span></div><div class=\"p-16\" \nng-if=\"vm.exchange.data.length\" flex><canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"vm.chartX.data\" \nchart-labels=\"vm.chartX.labels\" chart-options=\"vm.chartX.options\" chart-colors=\"vm.chartX.colors\" \nchart-series=\"vm.chartX.series\"></canvas></div><div class=\"p-16\" flex><md-table-container><table class=\"hovered\" \ndata-md-table md-progress=\"promise\"><thead ng-if=\"!vm.exchangeTable.options.decapitate\" md-head \ndata-md-order=\"vm.exchangeTable.query.order\"><tr md-row><th class=\"indigo-fg\" md-column md:order:by=\"location\">Location\n</th><th class=\"indigo-fg\" md-column md:order:by=\"Charger\">Charger</th><th class=\"indigo-fg\" md-column \nmd:order:by=\"connector\"><span>Connector</span></th><th class=\"indigo-fg\" md-column md:order:by=\"timestamp\"><span>\nStart Time</span></th><th class=\"indigo-fg\" md-column md:order:by=\"power\"><span>Power</span></th></tr></thead><tbody \nmd-body><tr md-row ng-if=\"!vm.exchange.data.length\"><td md-cell colspan=\"5\"><div class=\"p-25\"><span class=\"h4\">\n{{vm.exchange[\'message\'] ? vm.exchange[\'message\'] : \'No data available in table...\'}}</span></div></td></tr><tr md-row \nng-if=\"vm.exchange.data.length && vm.exchangeTable.filter.search && !(vm.exchange.data|filter:vm.exchangeTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"5\"><div class=\"p-25\"><h3>Nothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"result in vm.exchange.data | filter: vm.exchangeTable.filter.search | orderBy: vm.exchangeTable.query.order | limitTo: vm.exchangeTable.query.limit : (vm.exchangeTable.query.page - 1) * vm.exchangeTable.query.limit\">\n<td md-cell><span>{{result.location}}</span></td><td md-cell><span>{{result.charger}}</span></td><td md-cell><span>\n{{result.connector}}</span></td><td md-cell><span>{{result.timestamp | date: \'dd/MM/yyyy HH:mm\' }}</span></td><td \nmd-cell><span>{{result.power}}kW</span></td></tr></tbody></table></md-table-container><data-md-table-pagination \nng-if=\"vm.exchange.data.length\" class=\"noborder\" md-limit=\"vm.exchangeTable.query.limit\" \nmd-limit-options=\"vm.exchangeTable.limitOptions\" md-page=\"vm.exchangeTable.query.page\" \nmd-total=\"{{(vm.exchange.data|filter:vm.exchangeTable.filter.search).length}}\" \nmd-boundary-links=\"vm.exchangeTable.options.boundaryLinks\"></data-md-table-pagination></div><div class=\"p-16\" flex>\n</div></div><div ng-if=\"vm.request.requestStatus === \'PENDING\'\" class=\"white-bg mb-16\" flex><div class=\"p-16 bb\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"h3 m-0\">Electric Vehicles SoC Deviation</span></div><div \nclass=\"p-16\" flex><md-table-container><table class=\"hovered\" data-md-table md-progress=\"promise\"><thead \nng-if=\"!vm.socTable.options.decapitate\" md-head data-md-order=\"vm.socTable.query.order\"><tr md-row><th \nclass=\"indigo-fg\" md-column md:order:by=\"id\">Name</th><th class=\"indigo-fg\" md-column md:order:by=\"deviation\">\nSoC Deviation</th><th class=\"indigo-fg\" md-column md:order:by=\"soc_desired\"><span>SoC Desired</span></th><th \nclass=\"indigo-fg\" md-column md:order:by=\"soc_final\"><span>SoC Final</span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"!vm.exchange.deviations.length\"><td md-cell colspan=\"5\"><div class=\"p-25\"><span class=\"h4\">\n{{vm.soc[\'message\'] ? vm.soc[\'message\'] : \'No data available in table...\'}}</span></div></td></tr><tr md-row \nng-if=\"vm.exchange.deviations.length && vm.socTable.filter.search && !(vm.exchange.deviations|filter:vm.socTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"5\"><div class=\"p-25\"><h3>Nothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"result in vm.exchange.deviations | filter: vm.socTable.filter.search | orderBy: vm.socTable.query.order | limitTo: vm.socTable.query.limit : (vm.socTable.query.page - 1) * vm.socTable.query.limit\">\n<td md-cell><span>{{result.id}}</span></td><td md-cell><span>{{result.deviation | number:1}}</span></td><td md-cell>\n<span>{{result.soc_desired}}</span></td><td md-cell><span>{{result.soc_desired - result.deviation | number:1}}</span>\n</td></tr></tbody></table></md-table-container><data-md-table-pagination ng-if=\"vm.exchange.deviations.length\" \nclass=\"noborder\" md-limit=\"vm.socTable.query.limit\" md-limit-options=\"vm.socTable.limitOptions\" \nmd-page=\"vm.socTable.query.page\" md-total=\"{{(vm.exchange.deviations|filter:vm.socTable.filter.search).length}}\" \nmd-boundary-links=\"vm.socTable.options.boundaryLinks\"></data-md-table-pagination></div></div></div></div>");
$templateCache.put("app/main/requests/requests.html","<div id=\"requests\" class=\"page-layout simple fullwidth\"><div class=\"top-toolbar white-bg md-whiteframe-1dp\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"select-wrapper mr-16\" layout=\"row\" layout-align=\"start center\"><span class=\"mr-8\">Status</span>\n<md-input-container class=\"m-0\" flex><md-select name=\"status\" ng-model=\"vm.selectedStatus\" aria-label=\"Select Status\">\n<md-option ng-repeat=\"status in vm.allStatuses\" value=\"{{status.value}}\">{{status.title}}</md-option></md-select>\n</md-input-container></div><div class=\"daterange-wrapper\"><div class=\"daterange\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-calendar\" class=\"icon mr-8\" aria-hidden=\"true\"></md-icon>\n<input flex date-range-picker id=\"daterange\" min=\"\'2016-01-01\'\" name=\"daterange\" \nclass=\"form-control date-picker md-background-bg md-hue-1\" type=\"text\" ng-model=\"vm.dates\" options=\"vm.dateOptions\">\n</div></div></div></div><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><i class=\"icon s16 icon-bell\">\n</i> <span class=\"item\">{{ \'REQUESTS.REQUESTS_NAV\' | translate}}</span></div><div class=\"content\" md-background-bg><div\n class=\"white-bg\" flex><div class=\"p-16 bb\"><span class=\"h3 m-0\">Requests</span></div><div class=\"p-16\" flex>\n<md-table-container><table class=\"linked hovered\" data-md-table md-progress=\"promise\"><thead \nng-if=\"!vm.requestsTable.options.decapitate\" md-head data-md-order=\"vm.requestsTable.query.order\"><tr md-row><th \nmd-column md:order:by=\"timestamp\">Created</th><th md-column md:order:by=\"requestType\">Type</th><th md-column \nmd:order:by=\"activation\">Activation</th><th md-column>Action</th><th md-column md:order:by=\"start_time\"><span>\nStart Time</span></th><th md-column md:order:by=\"end_time\"><span>End Time</span></th><th md-column \nmd:order:by=\"reward\"><span>Reward</span></th><th md-column md:order:by=\"penalty\"><span>Penalty</span></th><th \nmd-column md:order:by=\"requestStatus\"><span>Status</span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"!vm.tmpResults.length\"><td md-cell colspan=\"9\"><div class=\"p-25\"><p>No data available in table...</p></div></td>\n</tr><tr md-row \nng-if=\"vm.tmpResults.length && vm.requestsTable.filter.search && !(vm.tmpResults|filter:vm.requestsTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"9\"><div class=\"p-25\"><h3>Nothing found...</h3></div></td></tr><tr md-row \nng-click=\"vm.goToRequest(result.id)\" \ndata-ng-repeat=\"result in vm.tmpResults | filter: vm.requestsTable.filter.search | orderBy: vm.requestsTable.query.order | limitTo: vm.requestsTable.query.limit : (vm.requestsTable.query.page - 1) * vm.requestsTable.query.limit\">\n<td md-cell><span>{{result.timestamp | date:\'dd/MM/yyyy HH:mm\'}}</span></td><td md-cell><span>{{result.requestType}}\n</span></td><td md-cell><span>{{result.activation === 1 ? \'Activate\' : \'Deactivate\'}}</span></td><td md-cell><span>\n{{result.action.value}}{{result.action.unit}} at {{result.action.section}}</span></td><td md-cell><span>\n{{result.start_time | date:\'dd/MM/yyyy HH:mm\'}}</span></td><td md-cell><span>\n{{result.end_time | date:\'dd/MM/yyyy HH:mm\'}}</span></td><td md-cell><span>{{result.reward}}€</span></td><td md-cell>\n<span>{{result.penalty}}€</span></td><td md-cell><md-button ng-if=\"result.requestStatus == \'ACCEPTED\'\" \nclass=\"md-icon-button\" aria-label=\"{{result.requestStatus}}\"><md-tooltip md-direction=\"left\">Accepted</md-tooltip>\n<md-icon md-font-icon=\"icon-check-circle green-fg\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button><md-button \nng-if=\"result.requestStatus == \'REJECTED\'\" class=\"md-icon-button\" aria-label=\"{{result.requestStatus}}\"><md-tooltip \nmd-direction=\"left\">Rejected</md-tooltip><md-icon md-font-icon=\"icon-close-circle red-fg\" class=\"icon\" \naria-hidden=\"true\"></md-icon></md-button><md-button ng-if=\"result.requestStatus == \'PENDING\'\" class=\"md-icon-button\" \naria-label=\"{{result.requestStatus}}\"><md-tooltip md-direction=\"left\">Pending</md-tooltip><md-icon \nmd-font-icon=\"icon-clock orange-fg\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table>\n</md-table-container><data-md-table-pagination ng-if=\"vm.tmpResults.length\" class=\"noborder\" \nmd-limit=\"vm.requestsTable.query.limit\" md-limit-options=\"vm.requestsTable.limitOptions\" \nmd-page=\"vm.requestsTable.query.page\" md-total=\"{{(vm.tmpResults|filter:vm.requestsTable.filter.search).length}}\" \nmd-boundary-links=\"vm.requestsTable.options.boundaryLinks\"></data-md-table-pagination></div></div></div></div>");
$templateCache.put("app/main/session/session.html","<div id=\"session\" class=\"page-layout simple fullwidth\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 icon-sitemap\"></i> <span ng-click=\"vm.goBack()\">\n{{ \'SESSION.SESSIONS_NAV\' | translate}}</span> <i class=\"icon s16 icon-chevron-right\"></i> <span class=\"item\">\n{{ \'SESSION.SESSION_NAV\' | translate}}: {{vm.session.id}}</span></div><div class=\"content\" md-background-bg><div \nclass=\"white-bg mb-16\" flex><div class=\"p-16 bb\"><span class=\"h3 m-0\">Session</span></div><div class=\"p-16\" \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex><div class=\"ms-responsive-table-wrapper p-8\" flex>\n<table class=\"simple\" ms-responsive-table><tbody><tr><td><span class=\"font-weight-500\">ID</span></td><td><span>\n{{vm.session.id}}</span></td></tr><tr><td><span class=\"font-weight-500\">Last Updated</span></td><td><span>\n{{vm.session.last_updated | date:\'dd/MM/yyyy HH:mm\'}}</span></td></tr><tr><td><span class=\"font-weight-500\">location ID\n</span></td><td><span>{{vm.session.location_id}}</span></td></tr><tr><td><span class=\"font-weight-500\">Connector ID\n</span></td><td><span>{{vm.session.connector_id}}</span></td></tr><tr><td><span class=\"font-weight-500\">EVSE UID</span>\n</td><td><span>{{vm.session.evse_uid}}</span></td></tr><tr><td><span class=\"font-weight-500\">Authentication</span></td>\n<td><span>{{vm.session.auth_method}}</span></td></tr><tr><td><span class=\"font-weight-500\">Status</span></td><td>\n<md-button ng-if=\"vm.session.status == \'PENDING\'\" class=\"md-icon-button\" aria-label=\"{{vm.session.status}}\"><md-icon \nmd-font-icon=\"icon-clock grey-fg\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button><md-button \nng-if=\"vm.session.status == \'COMPLETED\'\" class=\"md-icon-button\" aria-label=\"{{vm.session.status}}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle-outline green-fg\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button>\n<md-button ng-if=\"vm.session.status == \'ACTIVE\'\" class=\"md-icon-button\" aria-label=\"{{vm.session.status}}\"><md-icon \nmd-font-icon=\"icon-play-circle-outline green-fg\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button><md-button \nng-if=\"vm.session.status == \'INVALID\'\" class=\"md-icon-button\" aria-label=\"{{vm.session.status}}\"><md-icon \nmd-font-icon=\"icon-close-circle red-fg\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button><md-button \nng-if=\"vm.session.status == \'RESERVATION\'\" class=\"md-icon-button\" aria-label=\"{{vm.session.status}}\"><md-icon \nmd-font-icon=\"icon-timer orange-fg\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button><span>{{vm.session.status}}\n</span></td></tr></tbody></table></div><div class=\"ms-responsive-table-wrapper p-8\" flex><table class=\"simple\" \nms-responsive-table><tbody><tr><td><span class=\"font-weight-500\">Start Time</span></td><td><span>\n{{vm.session.start_date_time | date:\'dd/MM/yyyy HH:mm\'}}</span></td></tr><tr><td><span class=\"font-weight-500\">End Time\n</span></td><td><span>{{vm.session.end_date_time | date:\'dd/MM/yyyy HH:mm\'}}</span></td></tr><tr><td><span \nclass=\"font-weight-500\">Consumption</span></td><td><span>{{vm.session.kwh}}kWh</span></td></tr><tr><td><span \nclass=\"font-weight-500\">Power Steering</span></td><td><span ng-if=\"vm.session.power_steered==null\">-</span> <span \nng-if=\"vm.session.power_steered!=null\">{{vm.session.power_steered ? \'YES\' : \'NO\'}}</span></td></tr><tr><td><span \nclass=\"font-weight-500\">Currency</span></td><td><span>{{vm.session.currency}}</span></td></tr><tr><td><span \nclass=\"font-weight-500\">Total Cost</span></td><td><span>{{vm.session.total_cost.excl_vat}} {{vm.session.currency}}\n</span></td></tr><tr><td><span class=\"font-weight-500\">Total Cost (VAT included)</span></td><td><span>\n{{vm.session.total_cost.incl_vat}} {{vm.session.currency}}</span></td></tr></tbody></table></div></div></div><div \nng-if=\"vm.showChargingProfile\" class=\"white-bg mb-16\" flex><div class=\"p-16 bb\"><span class=\"h3 m-0\">Charging Profile\n</span></div><div class=\"p-16\" layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex><div \nclass=\"ms-responsive-table-wrapper p-8\" flex><table class=\"simple\" ms-responsive-table><tbody><tr><td><span \nclass=\"font-weight-500\">ID</span></td><td><span>{{vm.chargingProfile.id}}</span></td></tr><tr><td><span \nclass=\"font-weight-500\">Charging Rate Unit</span></td><td><span>{{vm.chargingProfile.charging_rate_unit}}</span></td>\n</tr><tr><td><span class=\"font-weight-500\">Charging Rate (min)</span></td><td><span>\n{{vm.chargingProfile.min_charging_rate}}</span></td></tr></tbody></table></div><div \nclass=\"ms-responsive-table-wrapper p-8\" flex><table class=\"simple\" ms-responsive-table><tbody><tr><td><span \nclass=\"font-weight-500\">Started</span></td><td><span>{{vm.chargingProfile.start_date_time | date:\'dd/MM/yyyy HH:mm\'}}\n</span></td></tr><tr><td><span class=\"font-weight-500\">Created</span></td><td><span>\n{{vm.chargingProfile.created_date_time | date:\'dd/MM/yyyy HH:mm\'}}</span></td></tr></tbody></table></div></div><div \nclass=\"p-16\"><canvas height=\"230\" id=\"line\" class=\"chart chart-line\" chart-data=\"vm.chart.data\" \nchart-labels=\"vm.chart.labels\" chart-colors=\"vm.chart.colors\" chart-series=\"vm.chart.series\" \nchart-options=\"vm.chart.options\"></canvas></div></div><div \nng-if=\"vm.session.charging_periods && vm.session.charging_periods.length > 0\" class=\"white-bg mb-16\" flex><div \nclass=\"p-16 bb\" layout=\"row\" layout-align=\"space-between center\"><span class=\"h3 m-0\">Charging Periods</span></div><div\n class=\"p-16\" flex><md-table-container><table class=\"hovered\" data-md-table md-progress=\"promise\"><thead \nng-if=\"!vm.chargingPeriodsTable.options.decapitate\" md-head data-md-order=\"vm.chargingPeriodsTable.query.order\"><tr \nmd-row><th class=\"indigo-fg text-center\">#</th><th class=\"indigo-fg\" md-column md:order:by=\"start_date_time\">Start Time\n</th><th class=\"indigo-fg\" md-column md:order:by=\"tarrif_id\"><span>Tarrif ID</span></th><th class=\"indigo-fg\" \nmd-column><span>Dimentions</span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"!vm.session.charging_periods.length\"><td md-cell colspan=\"4\"><div class=\"p-25\"><span class=\"h4\">\n{{vm.soc[\'message\'] ? vm.soc[\'message\'] : \'No data available in table...\'}}</span></div></td></tr><tr md-row \nng-if=\"vm.session.charging_periods.length && vm.chargingPeriodsTable.filter.search && !(vm.session.charging_periods|filter:vm.chargingPeriodsTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"4\"><div class=\"p-25\"><h3>Nothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"result in vm.session.charging_periods | filter: vm.chargingPeriodsTable.filter.search | orderBy: vm.chargingPeriodsTable.query.order | limitTo: vm.chargingPeriodsTable.query.limit : (vm.chargingPeriodsTable.query.page - 1) * vm.chargingPeriodsTable.query.limit\">\n<td md-cell><span>{{$index+1}}</span></td><td md-cell><span>{{result.start_date_time | date:\'dd/MM/yyyy HH:mm\'}}</span>\n</td><td md-cell><span>{{result.tarrif_id}}</span></td><td md-cell><div class=\"dimension\" \nng-repeat=\"dimension in result.dimensions\"><span>Type: {{dimension.type}}</span> <span>Volume: {{dimension.volume}}\n</span></div></td></tr></tbody></table></md-table-container><data-md-table-pagination \nng-if=\"vm.session.charging_periods.length\" class=\"noborder\" md-limit=\"vm.chargingPeriodsTable.query.limit\" \nmd-limit-options=\"vm.chargingPeriodsTable.limitOptions\" md-page=\"vm.chargingPeriodsTable.query.page\" \nmd-total=\"{{(vm.session.charging_periods|filter:vm.chargingPeriodsTable.filter.search).length}}\" \nmd-boundary-links=\"vm.chargingPeriodsTable.options.boundaryLinks\"></data-md-table-pagination></div></div></div></div>");
$templateCache.put("app/main/sessions/sessions.html","<div id=\"sessions\" class=\"page-layout simple fullwidth\"><div class=\"top-toolbar white-bg md-whiteframe-1dp\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"select-wrapper mr-16\" layout=\"row\" layout-align=\"start center\"><span class=\"mr-8\">Status</span>\n<md-input-container class=\"m-0\" flex><md-select name=\"status\" ng-model=\"vm.selectedStatus\" aria-label=\"Select Status\">\n<md-option ng-repeat=\"status in vm.allStatuses\" value=\"{{status.value}}\">{{status.title}}</md-option></md-select>\n</md-input-container></div><div class=\"daterange-wrapper\"><div class=\"daterange\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-calendar\" class=\"icon mr-8\" aria-hidden=\"true\"></md-icon>\n<input flex date-range-picker id=\"daterange\" min=\"\'2016-01-01\'\" name=\"daterange\" \nclass=\"form-control date-picker md-background-bg md-hue-1\" type=\"text\" ng-model=\"vm.dates\" options=\"vm.dateOptions\">\n</div></div></div></div><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 icon-sitemap\"></i> <span class=\"item\">{{ \'SESSIONS.SESSIONS_NAV\' | translate}}</span></div><div \nclass=\"content\" md-background-bg><div class=\"white-bg\" flex><div class=\"p-16 bb\"><span class=\"h3 m-0\">Sessions</span>\n</div><div class=\"p-16\" flex><md-table-container><table class=\"linked hovered\" data-md-table md-progress=\"promise\">\n<thead ng-if=\"!vm.sessionsTable.options.decapitate\" md-head data-md-order=\"vm.sessionsTable.query.order\"><tr md-row><th\n md-column md:order:by=\"id\">ID</th><th md-column md:order:by=\"evse_uid\">EVSE ID</th><th md-column \nmd:order:by=\"last_updated\"><span>Updated</span></th><th md-column md:order:by=\"start_date_time\"><span>Start Time</span>\n</th><th md-column md:order:by=\"end_date_time\"><span>End Time</span></th><th md-column md:order:by=\"kwh\"><span>\nConsumption</span></th><th md-column md:order:by=\"power_steered\"><span>Power Steering</span></th><th md-column \nmd:order:by=\"status\"><span>Status</span></th></tr></thead><tbody md-body><tr md-row ng-if=\"!vm.tmpResults.length\"><td \nmd-cell colspan=\"8\"><div class=\"p-25\"><p>No data available in table...</p></div></td></tr><tr md-row \nng-if=\"vm.tmpResults.length && vm.sessionsTable.filter.search && !(vm.tmpResults|filter:vm.sessionsTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"8\"><div class=\"p-25\"><h3>Nothing found...</h3></div></td></tr><tr md-row \nng-click=\"vm.goToSession(result.id)\" \ndata-ng-repeat=\"result in vm.tmpResults | filter: vm.sessionsTable.filter.search | orderBy: vm.sessionsTable.query.order | limitTo: vm.sessionsTable.query.limit : (vm.sessionsTable.query.page - 1) * vm.sessionsTable.query.limit\">\n<td md-cell><span>{{result.id}}</span></td><td md-cell><span>{{result.evse_uid}}</span></td><td md-cell><span>\n{{result.last_updated | date:\'dd/MM/yyyy HH:mm\'}}</span></td><td md-cell><span>\n{{result.start_date_time | date:\'dd/MM/yyyy HH:mm\'}}</span></td><td md-cell><span>\n{{result.end_date_time | date:\'dd/MM/yyyy HH:mm\'}}</span></td><td md-cell><span>{{result.kwh}}kWh</span></td><td \nmd-cell><span ng-if=\"result.power_steered==null\">-</span> <span ng-if=\"result.power_steered!=null\">\n{{result.power_steered ? \'YES\' : \'NO\'}}</span></td><td md-cell><md-button ng-if=\"result.status == \'PENDING\'\" \nclass=\"md-icon-button\" aria-label=\"{{result.status}}\"><md-tooltip md-direction=\"left\">Pending</md-tooltip><md-icon \nmd-font-icon=\"icon-clock grey-fg\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button><md-button \nng-if=\"result.status == \'COMPLETED\'\" class=\"md-icon-button\" aria-label=\"{{result.status}}\"><md-tooltip \nmd-direction=\"left\">Completed</md-tooltip><md-icon md-font-icon=\"icon-checkbox-marked-circle-outline green-fg\" \nclass=\"icon\" aria-hidden=\"true\"></md-icon></md-button><md-button ng-if=\"result.status == \'ACTIVE\'\" \nclass=\"md-icon-button\" aria-label=\"{{result.status}}\"><md-tooltip md-direction=\"left\">Active</md-tooltip><md-icon \nmd-font-icon=\"icon-play-circle-outline green-fg\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button><md-button \nng-if=\"result.status == \'INVALID\'\" class=\"md-icon-button\" aria-label=\"{{result.status}}\"><md-tooltip \nmd-direction=\"left\">Invalid</md-tooltip><md-icon md-font-icon=\"icon-close-circle red-fg\" class=\"icon\" \naria-hidden=\"true\"></md-icon></md-button><md-button ng-if=\"result.status == \'RESERVATION\'\" class=\"md-icon-button\" \naria-label=\"{{result.status}}\"><md-tooltip md-direction=\"left\">Reservation</md-tooltip><md-icon \nmd-font-icon=\"icon-timer orange-fg\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table>\n</md-table-container><data-md-table-pagination ng-if=\"vm.tmpResults.length\" class=\"noborder\" \nmd-limit=\"vm.sessionsTable.query.limit\" md-limit-options=\"vm.sessionsTable.limitOptions\" \nmd-page=\"vm.sessionsTable.query.page\" md-total=\"{{(vm.tmpResults|filter:vm.sessionsTable.filter.search).length}}\" \nmd-boundary-links=\"vm.sessionsTable.options.boundaryLinks\"></data-md-table-pagination></div></div></div></div>");
$templateCache.put("app/main/settings/settings.html","<div id=\"settings\" class=\"page-layout simple fullwidth\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 icon-cog\"></i> <span class=\"item\">\n{{ \'SETTINGS.SETTINGS_NAV\' | translate}}</span></div><div class=\"content\" md-background-bg><h1>{{vm.helloText}}</h1>\n</div></div>");
$templateCache.put("app/main/tokens/tokens.html","<div id=\"tokens\" class=\"page-layout simple fullwidth\"><div class=\"top-toolbar white-bg md-whiteframe-1dp\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"select-wrapper mr-16\" layout=\"row\" layout-align=\"start center\"><span class=\"mr-8\">Owner Type</span>\n<md-input-container class=\"m-0\" flex><md-select name=\"ownerType\" ng-model=\"vm.selectedOwnerType\" \naria-label=\"Select OwnerType\"><md-option value=\"-1\">All</md-option><md-option ng-repeat=\"type in vm.ownerTypes\" \nvalue=\"{{type.value}}\">{{type.name}}</md-option></md-select></md-input-container></div><div \nclass=\"select-wrapper mr-16\" layout=\"row\" layout-align=\"start center\"><span class=\"mr-8\">Token Type</span>\n<md-input-container class=\"m-0\" flex><md-select name=\"tokenType\" ng-model=\"vm.selectedTokenType\" \naria-label=\"Select Token Type\"><md-option value=\"-1\">All</md-option><md-option ng-repeat=\"type in vm.tokenTypes\" \nvalue=\"{{type.value}}\">{{type.name}}</md-option></md-select></md-input-container></div><div class=\"text-wrapper mr-16\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"mr-8\">Owner ID</span><md-input-container class=\"m-0\" flex><input \nstyle=\"text-transform: uppercase\" ng-model=\"vm.selectedOwnerID\" type=\"text\" maxlength=\"5\" \nonkeydown=\"return /\\p{L}/u.test(event.key)\" aria-label=\"Type Owner\"></md-input-container></div><div \nclass=\"text-wrapper mr-16\" layout=\"row\" layout-align=\"start center\"><span class=\"mr-8\">Client ID</span>\n<md-input-container class=\"m-0\" flex><input style=\"text-transform: uppercase\" ng-model=\"vm.selectedClientID\" \ntype=\"text\" maxlength=\"5\" onkeydown=\"return /\\p{L}/u.test(event.key)\" aria-label=\"Type Client\"></md-input-container>\n</div></div></div><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><i class=\"icon s16 icon-bell\"></i> \n<span class=\"item\">{{ \'TOKENS.TOKENS_NAV\' | translate}}</span></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"md-fab md-mini md-icon-button\" \nng-click=\"vm.controlToken($event, null, \'ADD_OWN\')\" aria-label=\"CREATE Token\"><md-tooltip md-direction=\"left\">\nCreate Token</md-tooltip><md-icon md-font-icon=\"icon-key\" class=\"icon\" style=\"color:#fff\"></md-icon></md-button><span>\nCreate Token</span><div class=\"seperator\"></div><md-button class=\"md-fab md-mini md-default md-icon-button\" \nng-click=\"vm.controlToken($event, null, \'ADD_FOREIGN\')\" aria-label=\"ADD Foreign Token\"><md-tooltip md-direction=\"left\">\nADD Foreign Token</md-tooltip><md-icon md-font-icon=\"icon-key-plus\" class=\"icon\" style=\"color:#fff\"></md-icon>\n</md-button><span>ADD Foreign Token</span></div><div class=\"content\" md-background-bg><div class=\"white-bg\" flex><div \nclass=\"p-16 bb\" layout=\"row\" layout-align=\"space-between center\" flex><div layout=\"row\"><span class=\"h3 m-0 mr-16\">\nTokens</span><div class=\"loader\" ng-class=\"[vm.spinnerHidden ? \'hidden\' : \'\']\"><md-progress-circular \nclass=\"md-accent md-hue-1\" md-diameter=\"24\"></md-progress-circular></div></div><div class=\"search-wrapper\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"search white-bg\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input type=\"text\" \nng-model=\"vm.tokensTable.filter.search\" placeholder=\"Search\" flex></div></div></div><div class=\"p-16\" flex>\n<md-table-container><table class=\"hovered\" data-md-table md-progress=\"promise\"><thead \nng-if=\"!vm.tokensTable.options.decapitate\" md-head data-md-order=\"vm.tokensTable.query.order\"><tr md-row><th md-column \nmd:order:by=\"credentials_token_client_ID\">Client ID</th><th md-column md:order:by=\"credentials_token_owner_ID\">Owner ID\n</th><th md-column md:order:by=\"credentials_token_owner_type\">Owner</th><th md-column \nmd:order:by=\"credentials_token_type\">Type</th><th md-column md:order:by=\"token\">Token</th><th md-column \nmd:order:by=\"url\">Url</th><th md-column>Roles</th><th md-column>Actions</th></tr></thead><tbody md-body><tr md-row \nng-if=\"!vm.tmpResults.length\"><td md-cell colspan=\"8\"><div class=\"p-25\"><p>No data available in table...</p></div></td>\n</tr><tr md-row \nng-if=\"vm.tmpResults.length && vm.tokensTable.filter.search && !(vm.tmpResults|filter:vm.tokensTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"8\"><div class=\"p-25\"><h3>Nothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"result in vm.tmpResults | filter: vm.tokensTable.filter.search | orderBy: vm.tokensTable.query.order | limitTo: vm.tokensTable.query.limit : (vm.tokensTable.query.page - 1) * vm.tokensTable.query.limit\">\n<td md-cell><span>{{result.credentials_token_client_ID}}</span></td><td md-cell><span>\n{{result.credentials_token_owner_ID}}</span></td><td md-cell><span>\n{{vm.ownerTypes[result.credentials_token_owner_type].name}}</span></td><td md-cell><span>\n{{vm.tokenTypes[result.credentials_token_type].name}}</span></td><td md-cell><span>\n{{ result.token | limitTo: 20 }}{{result.token.length > 20 ? \'...\' : \'\'}}</span><md-icon id=\"token-alert\" \nng-show=\"result.token.length > 0\" ng-click=\"vm.showToken(result.token, $event)\" md-font-icon=\"icon-open-in-new\" \nclass=\"icon s16\" aria-hidden=\"true\"></md-icon></td><td md-cell><span>{{result.url}}</span></td><td md-cell><md-list \nclass=\"md-dense\" ng-show=\"result.roles.length > 0\" flex><md-list-item class=\"md-2-line\" \nng-repeat=\"role in result.roles\"><md-icon md-font-icon=\"icon-account-outline\" class=\"icon mr-8\" aria-hidden=\"true\">\n</md-icon><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ role.role }} ({{ role.country_code }} {{ role.party_id }})<p>{{role.business_details.name}}<br>\n{{role.business_details.website}}</p></h3></div></md-list-item></md-list></td><td md-cell><md-button \nng-if=\"result.token.length != 0\" class=\"md-icon-button\" ng-click=\"vm.copyTokenToClipboard(result.token)\" \naria-label=\"Copy Token\"><md-tooltip md-direction=\"top\"><span>Copy Token to Clipboard</span></md-tooltip><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"\" aria-hidden=\"true\"></md-icon></md-button><md-button \nng-if=\"result.credentials_token_type != 3\" class=\"md-icon-button\" \nng-click=\"vm.controlToken($event, result.token, \'DELETE\')\" aria-label=\"Delete Token\"><md-tooltip md-direction=\"top\">\n<span>Delete Token</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"\" aria-hidden=\"true\"></md-icon>\n</md-button><md-button ng-if=\"result.credentials_token_type === 0 && result.credentials_token_owner_type === 1\" \nng-disabled=\"!vm.spinnerHidden\" style=\"text-transform:none\" class=\"md-icon-button\" \nng-click=\"vm.registerToken(result.credentials_token_owner_ID)\" aria-label=\"Register Token\"><md-tooltip \nmd-direction=\"top\"><span>Register Token</span></md-tooltip><md-icon md-font-icon=\"icon-account-key\" aria-hidden=\"true\">\n</md-icon></md-button></td></tr></tbody></table></md-table-container><data-md-table-pagination \nng-if=\"vm.tmpResults.length\" class=\"noborder\" md-limit=\"vm.tokensTable.query.limit\" \nmd-limit-options=\"vm.tokensTable.limitOptions\" md-page=\"vm.tokensTable.query.page\" \nmd-total=\"{{(vm.tmpResults|filter:vm.tokensTable.filter.search).length}}\" \nmd-boundary-links=\"vm.tokensTable.options.boundaryLinks\"></data-md-table-pagination></div></div></div></div>");
$templateCache.put("app/main/users/users.html","<div id=\"users\" class=\"page-layout simple fullwidth\"><div class=\"top-toolbar white-bg md-whiteframe-1dp\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"daterange-wrapper\"><div class=\"daterange\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-calendar\" class=\"icon mr-8\" aria-hidden=\"true\"></md-icon><input flex date-range-picker \nid=\"daterange\" min=\"\'2016-01-01\'\" name=\"daterange\" class=\"form-control date-picker md-background-bg md-hue-1\" \ntype=\"text\" ng-model=\"vm.dates\" options=\"vm.dateOptions\"></div></div></div></div><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 icon-bell\"></i> <span class=\"item\">{{ \'USERS.USERS_NAV\' | translate}}\n</span></div><div class=\"content\" md-background-bg><div class=\"white-bg mb-16\" flex><div class=\"p-16 bb\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3 m-0\">Internal Users</div><div class=\"search-wrapper\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"search white-bg\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input type=\"text\" \nng-model=\"vm.internalUsersTable.filter.search\" placeholder=\"Search\" flex></div></div></div><div class=\"p-16\" flex>\n<md-table-container><table class=\"hovered\" data-md-table md-progress=\"promise\"><thead \nng-if=\"!vm.internalUsersTable.options.decapitate\" md-head data-md-order=\"vm.internalUsersTable.query.order\"><tr md-row>\n<th md-column md:order:by=\"uid\">ID</th><th md-column md:order:by=\"contract_id\">Contract</th><th md-column \nmd:order:by=\"group_id\">Group</th><th md-column md:order:by=\"default_profile_type\">Profile</th><th md-column \nmd:order:by=\"type\">Type</th><th md-column md:order:by=\"visual_number\">VNumber</th><th md-column \nmd:order:by=\"last_updated\">Updated</th><th md-column md:order:by=\"issuer\">Issuer</th><th md-column \nmd:order:by=\"energy_contract\"><span>Energy Contract</span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"!vm.internalResults.length\"><td md-cell colspan=\"9\"><div class=\"p-25\"><p>No data available in table...</p></div>\n</td></tr><tr md-row \nng-if=\"vm.internalResults.length && vm.internalUsersTable.filter.search && !(vm.internalResults|filter:vm.internalUsersTable.filter.search).length\">\n<td md-cell colspan=\"9\"><div class=\"p-25\"><h3>Nothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"result in vm.internalResults | filter: vm.internalUsersTable.filter.search | orderBy: vm.internalUsersTable.query.order | limitTo: vm.internalUsersTable.query.limit : (vm.internalUsersTable.query.page - 1) * vm.internalUsersTable.query.limit\">\n<td md-cell><span>{{result.uid}}</span></td><td md-cell><span>{{result.contract_id}}</span></td><td md-cell><span>\n{{result.group_id}}</span></td><td md-cell><span>{{result.default_profile_type}}</span></td><td md-cell><span>\n{{result.type}}</span></td><td md-cell><span>{{result.visual_number}}</span></td><td md-cell><span>\n{{result.last_updated | date:\'dd/MM/yyyy HH:mm\'}}</span></td><td md-cell><span>{{result.issuer}}</span></td><td \nmd-cell><span>{{result.energy_contract.contract_id}}<br>{{result.energy_contract.supplier_name}}</span></td></tr>\n</tbody></table></md-table-container><data-md-table-pagination ng-if=\"vm.internalResults.length\" class=\"noborder\" \nmd-limit=\"vm.internalUsersTable.query.limit\" md-limit-options=\"vm.internalUsersTable.limitOptions\" \nmd-page=\"vm.internalUsersTable.query.page\" \nmd-total=\"{{(vm.internalResults|filter:vm.internalUsersTable.filter.search).length}}\" \nmd-boundary-links=\"vm.internalUsersTable.options.boundaryLinks\"></data-md-table-pagination></div></div><div \nclass=\"white-bg mb-16\" flex><div class=\"p-16 bb\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3 m-0\">\nExternal Users</div><div class=\"search-wrapper\" layout=\"row\" layout-align=\"end center\"><div class=\"search white-bg\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\">\n</md-icon><input type=\"text\" ng-model=\"vm.externalUsersTable.filter.search\" placeholder=\"Search\" flex></div></div>\n</div><div class=\"p-16\" flex><md-table-container><table class=\"hovered\" data-md-table md-progress=\"promise\"><thead \nng-if=\"!vm.externalUsersTable.options.decapitate\" md-head data-md-order=\"vm.externalUsersTable.query.order\"><tr md-row>\n<th md-column md:order:by=\"uid\">ID</th><th md-column md:order:by=\"contract_id\">Contract</th><th md-column \nmd:order:by=\"country_code\">Country</th><th md-column md:order:by=\"party_id\">Party</th><th md-column \nmd:order:by=\"group_id\">Group</th><th md-column md:order:by=\"default_profile_type\">Profile</th><th md-column \nmd:order:by=\"type\">Type</th><th md-column md:order:by=\"visual_number\">VNumber</th><th md-column \nmd:order:by=\"last_updated\">Updated</th><th md-column md:order:by=\"issuer\">Issuer</th><th md-column \nmd:order:by=\"energy_contract\"><span>Energy Contract</span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"!vm.externalResults.length\"><td md-cell colspan=\"11\"><div class=\"p-25\"><p>No data available in table...</p>\n</div></td></tr><tr md-row \nng-if=\"vm.externalResults.length && vm.externalUsersTable.filter.search && !(vm.externalResults|filter:vm.externalUsersTable.filter.search).length\">\n<td md-cell colspan=\"11\"><div class=\"p-25\"><h3>Nothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"result in vm.externalResults | filter: vm.externalUsersTable.filter.search | orderBy: vm.externalUsersTable.query.order | limitTo: vm.externalUsersTable.query.limit : (vm.externalUsersTable.query.page - 1) * vm.externalUsersTable.query.limit\">\n<td md-cell><span>{{result.uid}}</span></td><td md-cell><span>{{result.contract_id}}</span></td><td md-cell><span>\n{{result.country_code}}</span></td><td md-cell><span>{{result.party_id}}</span></td><td md-cell><span>\n{{result.group_id}}</span></td><td md-cell><span>{{result.default_profile_type}}</span></td><td md-cell><span>\n{{result.type}}</span></td><td md-cell><span>{{result.visual_number}}</span></td><td md-cell><span>\n{{result.last_updated | date:\'dd/MM/yyyy HH:mm\'}}</span></td><td md-cell><span>{{result.issuer}}</span></td><td \nmd-cell><span>{{result.energy_contract.contract_id}}<br>{{result.energy_contract.supplier_name}}</span></td></tr>\n</tbody></table></md-table-container><data-md-table-pagination ng-if=\"vm.externalResults.length\" class=\"noborder\" \nmd-limit=\"vm.externalUsersTable.query.limit\" md-limit-options=\"vm.externalUsersTable.limitOptions\" \nmd-page=\"vm.externalUsersTable.query.page\" \nmd-total=\"{{(vm.externalResults|filter:vm.externalUsersTable.filter.search).length}}\" \nmd-boundary-links=\"vm.externalUsersTable.options.boundaryLinks\"></data-md-table-pagination></div></div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img \nsrc=\"assets/images/logos/meister.png\"></div><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div>\n<form name=\"loginForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"username\" \nng-model=\"vm.form.username\" placeholder=\"Username\" translate translate-attr-placeholder=\"LOGIN.USERNAME\" required><div \nng-messages=\"loginForm.username.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" autocomplete=\"off\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span>\n</md-checkbox></div><md-button type=\"submit\" ng-click=\"vm.handleLogin()\" class=\"md-raised md-accent submit-button\" \naria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"register\" layout=\"column\" \nlayout-align=\"center center\"><a href=\"\" class=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">\nForgot Password?</a></div></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">M</span><span class=\"logo-text\">MEISTER\n</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"pl-16\"><img \nsrc=\"assets/images/logos/meister.png\" style=\"width:160px\"></div><h3 class=\"pl-8 pr-8 toolbar-subtitle\" \nstyle=\"color:#002B7F\" hide show-gt-sm>SMART CHARGING</h3></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\">\n</md-progress-circular><md-button id=\"notifications\" class=\"md-icon-button\" ng-click=\"\" aria-label=\"Notifications\" \ntranslate translate-attr-aria-label=\"TOOLBAR.NOTIFICATIONS\"><md-icon md-font-icon=\"icon-bell\" class=\"icon\"></md-icon>\n</md-button><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\">\n<md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div><span \nclass=\"username\" hide show-gt-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\">\n<md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n</div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"project-logo\" layout=\"row\" \nlayout-align=\"start center\"><img src=\"assets/images/logos/meister.png\" style=\"width:160px\"> <span class=\"logo-text h3\">\nSMART CHARGING</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><md-menu ng-if=\"vm.user.role === \'ROLE_CPO\'\" id=\"notifications-menu\" \nmd-position-mode=\"left bottom\"><md-button class=\"notifications-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"notifications\"><notification-icon animation=\"bounce\" disappear-animation=\"bounce\" \ncount=\"vm.unseenNotifications.length\"><md-icon md-font-icon=\"icon-bell\" class=\"icon\"></md-icon></notification-icon>\n</md-button><md-menu-content style=\"max-width:650px\" id=\"notifications-menu-content\"><md-list \nng-if=\"vm.unseenNotifications.length>0\"><md-list-item \nng-click=\"vm.goToRequest(notification.id, notification.metadata.requestId)\" class=\"md-2-line\" \nng-repeat=\"notification in vm.unseenNotifications | orderBy: \'-createdDate\'\"><md-icon md-font-icon=\"icon-bell\" \nstyle=\"color: #5cb85c; margin-right: 16px\" class=\"icon\" ng-if=\"notification.type==\'DRevent\'\"></md-icon><div \nclass=\"md-list-item-text\" layout=\"column\"><span class=\"m-0 p-0 font-size-10\">\n{{notification.createdDate | date: \'dd/MM/yyyy HH:mm\' }}</span><h3 class=\"m-0\">{{notification.title}}</h3><p>\n{{notification.message}}</p></div><md-divider></md-divider></md-list-item></md-list><md-list \nng-if=\"vm.unseenNotifications.length==0\"><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-bell\" class=\"icon mr-8\"></md-icon><span class=\"\">\nNo new request!</span></div></md-list-item></md-list></md-menu-content></md-menu><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"></div><span class=\"username\" hide show-gt-sm>\n{{vm.user.firstname}} - {{vm.user.lastname}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide \nshow-gt-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/car/dialogs/controlPlan/controlPlan.html","<md-dialog class=\"control-plan-dialog\" aria-label=\"vm.action\"><md-toolbar class=\"md-primary\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span translate=\"{{vm.action}} Plan\"></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MONITORING.DIALOGS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" aria-hidden=\"true\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><form id=\"socForm\" name=\"socForm\" ng-submit=\"vm.save()\" \nnovalidate><div class=\"form-content\"><div ng-if=\"vm.action===\'SELECT\'\"><div layout=\"column\" layout-align=\"start start\" \nflex><h3>SoC Management</h3><div class=\"input-block\" flex><md-input-container class=\"m-0\" flex><label>SoC initial\n</label><input ng-model=\"vm.soc.initial\" type=\"number\" step=\"1\" min=\"{{vm.car.soc}}\" ng-max=\"{{vm.soc.final}}\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container class=\"m-0\" flex><label>SoC final</label>\n<input ng-model=\"vm.soc.final\" type=\"number\" step=\"1\" min=\"{{vm.soc.initial+1}}\" ng-max=\"vm.calcFinalSoc()\"><div \nclass=\"hint font-size-12 text-right\"><span class=\"mr-4\">max:</span><span ng-bind=\"vm.calcFinalSoc()\"></span></div>\n</md-input-container></div></div></div><p class=\"message\" ng-if=\"vm.action===\'DELETE\'\">\nAre you sure you want to delete this charging plan?</p></div><md-dialog-actions layout=\"row\" class=\"\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"socForm.$pristine || socForm.$invalid\" \nng-show=\"vm.action===\'SELECT\'\" type=\"submit\" aria-label=\"Select\" class=\"save-button md-raised\" \nng-class=\"{\'md-primary\': socForm.$dirty}\">SELECT</md-button><md-button ng-if=\"vm.action===\'DELETE\'\" \nng-click=\"vm.save()\" aria-label=\"Delete\" class=\"save-button md-primary md-raised\">DELETE</md-button></div>\n</md-dialog-actions></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/monitoring/dialogs/controlParking/controlParking.html","<md-dialog class=\"control-parking-dialog\" aria-label=\"vm.action\"><md-toolbar class=\"blue-grey-bg\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"MONITORING.DIALOGS.{{vm.action}}\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MONITORING.DIALOGS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"form-content\"><div ng-if=\"vm.action===\'ADD\' || vm.action===\'EDIT\'\"><div layout=\"column\" \nlayout-align=\"start start\"><h3 class=\"mt-0\">Location Information</h3><div class=\"input-block\" flex><md-input-container \nclass=\"m-0\" flex><label>Name</label><input ng-model=\"vm.parking.name\" type=\"text\" ng-required=\"true\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container class=\"m-0\" flex><label>Location Type\n</label><md-select class=\"pb-24\" name=\"type\" ng-model=\"vm.parking.type\" required><md-option \nng-repeat=\"item in vm.locationTypes\" ng-value=\"item\">{{item}}</md-option></md-select></md-input-container>\n<md-input-container class=\"m-0\" flex><label>Facilities</label><md-select class=\"pb-24\" name=\"facilities\" \nng-model=\"vm.parking.facilities\" multiple=\"multiple\"><md-option ng-value=\"facility\" \nng-repeat=\"facility in vm.facilities\">{{facility}}</md-option></md-select></md-input-container><md-input-container \nclass=\"m-0\" flex><md-switch class=\"mt-0 mb-24\" ng-model=\"vm.parking.opening_times.twentyfourseven\" \naria-label=\"twentyfourseven\">24/7:</md-switch></md-input-container><md-input-container class=\"m-0\" flex><md-switch \nclass=\"mt-0 mb-24\" ng-model=\"vm.parking.charging_when_closed\" aria-label=\"twentyfourseven\">Charging when closed:\n</md-switch></md-input-container></div><div class=\"input-block\" flex><md-input-container class=\"m-0\" flex><label>\nAddress</label><input type=\"address\" name=\"address\" ng-model=\"vm.parking.address\" required></md-input-container>\n<md-input-container class=\"m-0\" flex><label>Postal Code</label><input type=\"text\" name=\"postal_code\" \nng-model=\"vm.parking.postal_code\" required></md-input-container><md-input-container class=\"m-0\" flex><label>City\n</label><input type=\"text\" name=\"city\" ng-model=\"vm.parking.city\" required></md-input-container><md-input-container \nclass=\"m-0\" flex><label>State</label><input type=\"text\" name=\"state\" ng-model=\"vm.parking.state\"></md-input-container>\n<md-input-container class=\"m-0\" flex><label>Country</label><md-select class=\"pb-24\" name=\"country\" \nng-model=\"vm.parking.country\" required><md-option ng-repeat=\"item in vm.countryListAlpha3\" ng-value=\"item.iso3\">\n{{item.name}}, {{item.iso3}}</md-option></md-select></md-input-container></div><div class=\"input-block\" flex>\n<md-input-container class=\"m-0\" flex><label>Latitude</label><input type=\"number\" name=\"latitude\" \nng-model=\"vm.parking.coordinates.latitude\" step=\"0.01\" min=\"-150\" max=\"150\" required></md-input-container>\n<md-input-container class=\"m-0\" flex><label>Longitude</label><input type=\"number\" name=\"longitude\" \nng-model=\"vm.parking.coordinates.longitude\" step=\"0.01\" min=\"-150\" max=\"120\" required></md-input-container></div><h3 \nclass=\"mt-0\">Owner</h3><div class=\"input-block\" flex><md-input-container class=\"m-0\" flex><label>Owner\'s Name</label>\n<input type=\"text\" name=\"owner_name\" ng-model=\"vm.parking.owner.name\" required></md-input-container><md-input-container\n class=\"m-0\" flex><label>Owner\'s Website</label><input type=\"text\" name=\"owner_website\" \nng-model=\"vm.parking.owner.website\"></md-input-container></div><h3 class=\"mt-0\">Operator</h3><div class=\"input-block\" \nflex><md-input-container class=\"m-0\" flex><label>Operator\'s Name</label><input type=\"text\" name=\"operator_name\" \nng-model=\"vm.parking.operator.name\" required disabled=\"true\"></md-input-container><md-input-container class=\"m-0\" flex>\n<label>Party Id</label><input type=\"text\" name=\"partyid\" ng-model=\"vm.parking.party_id\" required disabled=\"true\">\n</md-input-container><md-input-container class=\"m-0\" flex><label>Country</label><md-select class=\"pb-24\" \nname=\"country_code\" ng-model=\"vm.parking.country_code\" required disabled=\"true\"><md-option \nng-repeat=\"item in vm.countryListAlpha2\" ng-value=\"item.iso2\">{{item.name}}, {{item.iso2}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex><md-input-container class=\"m-0\" flex><label>Operator\'s Website\n</label><input type=\"text\" name=\"operator_website\" ng-model=\"vm.parking.operator.website\"></md-input-container></div>\n<h3 class=\"mt-0\">Suboperator</h3><div class=\"input-block\" flex><md-input-container class=\"m-0\" flex><label>\nSuboperator\'s Name</label><input type=\"text\" name=\"suboperator_name\" ng-model=\"vm.parking.suboperator.name\">\n</md-input-container><md-input-container class=\"m-0\" flex><label>Suboperator\'s Website</label><input type=\"text\" \nname=\"suboperator_website\" ng-model=\"vm.parking.suboperator.website\"></md-input-container></div></div></div><p \nclass=\"message\" ng-if=\"vm.action===\'DELETE\'\">Are you sure you want to delete location: \"{{vm.parking.name}}\"?</p></div>\n<md-dialog-actions layout=\"row\" class=\"p-0\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-if=\"vm.action===\'ADD\' || vm.action===\'EDIT\'\" ng-click=\"vm.save()\" aria-label=\"Save\" \nclass=\"save-button blue-grey-bg white-fg md-raised\">SAVE</md-button><md-button ng-if=\"vm.action===\'DELETE\'\" \nng-click=\"vm.save()\" aria-label=\"Delete\" class=\"save-button blue-grey-bg white-fg md-raised\">DELETE</md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/parking/dialogs/controlCharger/controlCharger.html","<md-dialog class=\"control-charger-dialog\" aria-label=\"vm.action\"><md-toolbar class=\"blue-grey-bg\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span translate=\"{{vm.action}} Charger\">\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MONITORING.DIALOGS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" aria-hidden=\"true\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"form-content\"><div \nng-if=\"vm.action===\'ADD\' || vm.action===\'EDIT\'\"><div layout=\"column\" layout-align=\"start start\" flex><h3 class=\"mt-0\">\nCharger</h3><div class=\"input-block\" flex><md-input-container class=\"m-0\" flex><label>Status</label><md-select \nclass=\"pb-24\" name=\"status\" ng-model=\"vm.charger.status\" required><md-option ng-repeat=\"item in vm.statuses\" \nng-value=\"item\">{{item}}</md-option></md-select></md-input-container><md-input-container class=\"m-0\" flex><label>\nCapabilities</label><md-select class=\"pb-24\" name=\"capabilities\" ng-model=\"vm.charger.capabilities\" \nmultiple=\"multiple\" required><md-option ng-value=\"capability\" ng-repeat=\"capability in vm.capabilities\">{{capability}}\n</md-option></md-select></md-input-container><md-input-container class=\"m-0\" flex><label>Floor Level</label><input \nng-model=\"vm.charger.floor_level\" type=\"text\" ng-required=\"true\"></md-input-container></div><div style=\"width:100%\" \nclass=\"mt-0\" layout=\"row\" layout-align=\"start center\" flex><div class=\"h3\" flex>Connectors</div><md-button \nng-if=\"vm.charger.connectors.length < 4\" class=\"md-fab md-mini indigo-bg\" ng-click=\"vm.addConnector()\" \naria-label=\"Add Connector\"><md-icon md-font-icon=\"icon-plus\" class=\"white-fg\" aria-hidden=\"true\"></md-icon></md-button>\n</div><div ng-repeat=\"connector in vm.charger.connectors\" class=\"input-block p-16 m-8 b\" layout=\"column\" flex><div \nlayout=\"row\" layout-align=\"start center\"><md-input-container class=\"m-0\" flex><label>ID</label><input \nng-model=\"connector.id\" type=\"text\" ng-required=\"true\"></md-input-container><md-input-container class=\"m-0\" flex>\n<label>Standard</label><md-select class=\"pb-24\" name=\"standard\" ng-model=\"connector.standard\" required><md-option \nng-repeat=\"item in vm.standards\" ng-value=\"item\">{{item}}</md-option></md-select></md-input-container>\n<md-input-container class=\"m-0\" flex><label>Format</label><md-select class=\"pb-24\" name=\"format\" \nng-model=\"connector.format\" required><md-option ng-repeat=\"item in vm.formats\" ng-value=\"item\">{{item}}</md-option>\n</md-select></md-input-container><md-input-container class=\"m-0\" flex><label>Power Type</label><md-select \nclass=\"pb-24\" name=\"power_type\" ng-model=\"connector.power_type\" required><md-option ng-repeat=\"item in vm.powerTypes\" \nng-value=\"item\">{{item}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"m-0\" flex><label>Max Voltage</label><input type=\"number\" \nname=\"max_voltage\" ng-model=\"connector.max_voltage\" step=\"10\" min=\"0\" required></md-input-container><md-input-container\n class=\"m-0\" flex><label>Max Amperage</label><input type=\"number\" name=\"max_amperage\" \nng-model=\"connector.max_amperage\" step=\"10\" min=\"0\" required></md-input-container><md-input-container class=\"m-0\" flex>\n<label>Max Electric Power</label><input type=\"number\" name=\"max_electric_power\" \nng-model=\"connector.max_electric_power\" step=\"10\" min=\"0\" required></md-input-container></div></div></div></div><p \nclass=\"message\" ng-if=\"vm.action===\'DELETE\'\">Are you sure you want to delete charger: \"{{vm.charger.uid}}\"?</p></div>\n<md-dialog-actions layout=\"row\" class=\"\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-if=\"vm.action===\'ADD\' || vm.action===\'EDIT\'\" ng-click=\"vm.save()\" aria-label=\"Save\" \nclass=\"save-button blue-grey-bg white-fg md-raised\">SAVE</md-button><md-button ng-if=\"vm.action===\'DELETE\'\" \nng-click=\"vm.save()\" aria-label=\"Delete\" class=\"save-button blue-grey-bg white-fg md-raised\">DELETE</md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/platform-users/dialogs/controlPlatformUser/controlPlatformUser.html","<md-dialog class=\"control-platform-user-dialog\" aria-label=\"vm.action\"><md-toolbar class=\"blue-grey-bg\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"{{vm.action}} Platform User\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MONITORING.DIALOGS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"form-content\"><div ng-if=\"vm.action===\'ADD\' || vm.action===\'EDIT\'\"><div layout=\"column\" \nlayout-align=\"start start\" flex><h3 class=\"mt-0\">Platform User</h3><div class=\"input-block\" flex><md-input-container \nflex><label>Role</label><md-select name=\"roles\" ng-model=\"vm.platformUser.roles\" required><md-option \nng-repeat=\"item in vm.allRoles\" ng-value=\"item.value\">{{item.title}}</md-option></md-select></md-input-container>\n<md-input-container flex><md-switch ng-model=\"vm.platformUser.active\" aria-label=\"Activate User\" ng-true-value=\"true\" \nng-false-value=\"false\" class=\"md-warn\"><span class=\"ml-8\">\nUser Status: {{ vm.platformUser.active ? \'Active\' : \'Inactive\' }}</span></md-switch></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label>First Name</label><input ng-model=\"vm.platformUser.firstName\" \ntype=\"text\" ng-required=\"true\"></md-input-container><md-input-container flex><label>Last Name</label><input \nng-model=\"vm.platformUser.lastName\" type=\"text\" ng-required=\"true\"></md-input-container><md-input-container flex>\n<label>Email</label><input ng-model=\"vm.platformUser.email\" type=\"email\" ng-required=\"true\"></md-input-container></div>\n<div class=\"input-block\" flex><md-input-container flex><label>Username</label><input \nng-model=\"vm.platformUser.username\" type=\"text\" ng-required=\"true\"></md-input-container><md-input-container flex>\n<label>Password</label><input ng-model=\"vm.platformUser.password\" type=\"password\" ng-required=\"true\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label>Country Code</label><md-select\n name=\"country_code\" ng-model=\"vm.platformUser.country_code\" required><md-option \nng-repeat=\"item in vm.countryListAlpha2\" ng-value=\"item.iso2\">{{item.name + \', \' + item.iso2}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label>Party ID</label><input \nstyle=\"text-transform: uppercase\" ng-model=\"vm.platformUser.party_id\" type=\"text\" maxlength=\"3\" \nonkeydown=\"return /\\p{L}/u.test(event.key)\" required></md-input-container></div></div></div><p class=\"message\" \nng-if=\"vm.action===\'DELETE\'\">\nAre you sure you want to delete user: \"{{vm.platformUser.firstName}} {{vm.platformUser.lastName}}\"?</p></div>\n<md-dialog-actions layout=\"row\" class=\"\"><span class=\"mr-8\" ng-if=\"vm.action===\'EDIT\'\">\nCreated: {{vm.platformUser.creationDate | date:\'dd/MM/yyyy HH:mm\'}}</span><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-if=\"vm.action===\'ADD\' || vm.action===\'EDIT\'\" ng-click=\"vm.save()\" \naria-label=\"Save\" class=\"save-button blue-grey-bg white-fg md-raised\">SAVE</md-button><md-button \nng-if=\"vm.action===\'DELETE\'\" ng-click=\"vm.save()\" aria-label=\"Delete\" \nclass=\"save-button blue-grey-bg white-fg md-raised\">DELETE</md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/profile/tabs/userinfo/userinfo.html","<div class=\"userinfo\" layout=\"row\" layout-wrap><div class=\"about p-16\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"65\"><form name=\"userInfoForm\" id=\"userInfoForm\" ng-submit=\"vm.saveUserInfoForm($event, vm.tempUser)\"><div \nclass=\"profile-box md-whiteframe-1dp mb-16\" layout=\"column\"><header class=\"header-bg p-16\"><span class=\"h3\" \ntranslate=\"PROFILE.PRIVATE_INFORMATION\">Private Information</span></header><div layout=\"row\" \nclass=\"content white-bg p-16\"><div class=\"pr-8\" layout=\"column\" layout-align=\"start center\"><img id=\"profile-image\" \nclass=\"avatar big\" ng-src=\"assets/images/avatars/profile.jpg\"><p class=\"profile-image-import p-0 m-0\" layout=\"column\" \nlayout-align=\"center center\"><input id=\"image-file\" name=\"image-file\" type=\"file\"> <a class=\"mt-8\" \nhref=\"javascript:void(0)\" ng-click=\"vm.openFileExplorer()\"><md-icon md-font-icon class=\"icon icon-camera s20 grey-fg\">\n</md-icon></a></p></div><div layout=\"column\" flex><md-input-container class=\"md-block\"><label><span \ntranslate=\"PROFILE.USERNAME\">Username</span></label><input name=\"username\" type=\"text\" ng-model=\"vm.tempUser.username\" \nplaceholder=\"\" ng-disabled=\"true\" required><div ng-messages=\"userInfoForm.username.$error\"><div ng-message=\"required\">\nThis is required.</div></div></md-input-container><md-input-container class=\"md-block\"><label><span \ntranslate=\"PROFILE.PASSWORD\">Password</span></label><input name=\"password\" type=\"password\" \nng-model=\"vm.tempUser.password\" placeholder=\"\" ng-disabled=\"true\" required><div \nng-messages=\"userInfoForm.password.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label><span translate=\"PROFILE.FIRSTNAME\">Name</span>\n</label><input name=\"firstname\" type=\"text\" ng-model=\"vm.tempUser.firstname\" placeholder=\"\" ng-disabled=\"false\" \nrequired><div ng-messages=\"userInfoForm.firstname.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label><span translate=\"PROFILE.LASTNAME\">Surname</span>\n</label><input name=\"lastname\" type=\"text\" ng-model=\"vm.tempUser.lastname\" placeholder=\"\" ng-disabled=\"false\" required>\n<div ng-messages=\"userInfoForm.lastname.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label><span translate=\"PROFILE.EMAIL\">E-mail</span></label>\n<input name=\"emailAddress\" type=\"text\" placeholder=\"\" ng-model=\"vm.tempUser.email\" ng-disabled=\"false\" required><div \nng-messages=\"userInfoForm.emailAddress.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container></div></div></div><md-button class=\"md-raised md-primary\" type=\"submit\" \nng-disabled=\"userInfoForm.$invalid || userInfoForm.$pristine\">Update</md-button></form></div><div \nclass=\"about-sidebar p-16\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"></div></div>");
$templateCache.put("app/main/profile/tabs/usersettings/usersettings.html","<div class=\"usersettings\" layout=\"row\" layout-wrap><div class=\"settings p-16\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"65\"><div ng-if=\"vm.user.typeid == 74101\" class=\"profile-box md-whiteframe-1dp mb-16\" \nlayout=\"column\"><header class=\"md-accent-bg p-16\"><span class=\"h3\" translate=\"PROFILE.SCHEDULE_AVAILABILITY\">\nSchedule Hourly Availability for DR Events</span></header><div class=\"content white-bg p-16\"><div class=\"slots\" \nflex=\"55\" layout=\"row\" layout-wrap><div class=\"slot\" ng-class=\"{\'green\': slot.value == 1}\" \nng-repeat=\"slot in vm.slots track by $index\" ng-click=\"vm.clickSlot($index, slot.value)\">{{slot.time}}</div></div>\n<md-button class=\"md-primary\" ng-click=\"vm.updateSlots()\">Update</md-button></div></div><div \nng-if=\"vm.user.typeid == 74101\" class=\"profile-box md-whiteframe-1dp mb-16\" layout=\"column\"><header \nclass=\"md-accent-bg p-16\"><span class=\"h3\" translate=\"PROFILE.CONTROL_DEVICES\">Control Devices</span></header><div \nclass=\"content white-bg p-16\"><div ng-if=\"vm.devices.length == 0\" layout=\"column\" layout-align=\"center center\" flex>\n<span class=\"h3\">No devices available!</span></div><div ng-if=\"vm.devices.length > 0\" \nng-repeat=\"devices in vm.devices track by $index\"><div class=\"mb-16\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon class=\"icon s30 blue-fg mr-8\" ng-class=\"devices.icon\"></md-icon><span class=\"h3 blue-fg\" flex>\n{{devices.category}}</span></div><div class=\"ml-16\" ng-repeat=\"device in devices.devices track by $index\" layout=\"row\" \nlayout-align=\"start center\"><md-switch class=\"md-switch m-0 mr-8\" aria-label=\"Switch\" \nng-init=\"device.controllable === 1 ? true : false\" ng-model=\"device.controllable\" \nng-change=\"vm.changeDeviceControllable(devices.category, device.name, device.controllable)\"></md-switch><span>\n{{device.name}}</span></div></div></div></div></div><div ng-if=\"vm.user.typeid == 74101\" \nclass=\"profile-box md-whiteframe-1dp mb-16\" layout=\"column\"><header class=\"md-accent-bg p-16\"><span class=\"h3\">\nComfort Preferences</span></header><div class=\"content white-bg p-16\"><div \nng-repeat=\"comfort in vm.feidDetails.comfort_prefs\"><div ng-if=\"comfort.name == \'temperature\'\"><span class=\"h3\">\n{{comfort.name}}</span><rzslider class=\"custom-slider\" rz-slider-model=\"comfort.characteristics.min\" \nrz-slider-high=\"comfort.characteristics.max\" rz-slider-options=\"vm.sliderTemperatureOptions\"></rzslider></div><div \nng-if=\"comfort.name == \'luminance\'\"><span class=\"h3\">{{comfort.name}}</span><rzslider class=\"custom-slider\" \nrz-slider-model=\"comfort.characteristics.min\" rz-slider-high=\"comfort.characteristics.max\" \nrz-slider-options=\"vm.sliderLuminanceOptions\"></rzslider></div></div></div></div></div><div \nclass=\"settings-sidebar p-16\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"><div \nng-if=\"vm.user.typeid == 74101\" class=\"profile-box md-whiteframe-1dp mb-16\" layout=\"column\"><header \nclass=\"md-accent-bg p-16\"><span class=\"h3\" translate=\"PROFILE.FEID_INFORMATION\">FEID Information</span></header><div \nclass=\"content white-bg p-16\"><div layout=\"column\" layout-align=\"start center\"><span class=\"h3\">\nStatus: {{vm.feidDetails.status}}</span> <span class=\"h4\">FEID: {{vm.feidDetails.feid}}</span> <span class=\"h4\">\nLocation: {{vm.feidDetails.geo_location}}</span> <span class=\"h4\">Contracted Power: {{vm.feidDetails.contracted_power}}\n</span></div></div></div></div></div>");
$templateCache.put("app/main/tokens/dialogs/controlToken/controlToken.html","<md-dialog class=\"control-token-dialog\" aria-label=\"vm.action\"><md-toolbar class=\"blue-grey-bg\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"TOKENS.DIALOGS.{{vm.action}}\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"TOKENS.DIALOGS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"form-content\"><div ng-if=\"vm.action===\'ADD_OWN\'\"><div layout=\"row\" layout-align=\"start start\">\n<md-input-container flex><label>Country</label><md-select name=\"country_code\" ng-model=\"vm.token.country_code\" \nrequired><md-option ng-repeat=\"item in vm.countryListAlpha2\" ng-value=\"item.iso2\">{{item.name + \', \' + item.iso2}}\n</md-option></md-select></md-input-container><md-input-container flex><span>Party</span> <input \nstyle=\"text-transform: uppercase\" ng-model=\"vm.token.party\" type=\"text\" maxlength=\"3\" \nonkeydown=\"return /\\p{L}/u.test(event.key)\"></md-input-container></div></div><div ng-if=\"vm.action===\'ADD_FOREIGN\'\">\n<div layout=\"column\" layout-align=\"start start\"><md-input-container flex><label>Country</label><md-select \nname=\"country_code\" ng-model=\"vm.token.country_code\" required><md-option ng-repeat=\"item in vm.countryListAlpha2\" \nng-value=\"item.iso2\">{{item.name + \', \' + item.iso2}}</md-option></md-select></md-input-container><md-input-container \nflex><span>Party</span> <input style=\"text-transform: uppercase\" ng-model=\"vm.token.party\" type=\"text\" maxlength=\"3\" \nonkeydown=\"return /\\p{L}/u.test(event.key)\"></md-input-container><md-input-container flex><span>Token</span><textarea \nstyle=\"width:100%\" ng-model=\"vm.token.token\" rows=\"5\" ng-required=\"true\" md-select-on-focus></textarea>\n</md-input-container><md-input-container flex><label>URL</label><input ng-model=\"vm.token.url\" type=\"url\" \nng-required=\"true\"></md-input-container></div></div><p class=\"message\" ng-if=\"vm.action===\'DELETE\'\">\nAre you sure you want to delete token: \"{{ vm.token | limitTo: 20 }}{{vm.token.length > 20 ? \'...\' : \'\'}}\"?</p></div>\n<md-dialog-actions layout=\"row\" class=\"p-0\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-if=\"vm.action===\'ADD_OWN\' || vm.action===\'ADD_FOREIGN\'\" ng-click=\"vm.save()\" aria-label=\"Save\" \nclass=\"save-button blue-grey-bg white-fg md-raised\">SAVE</md-button><md-button ng-if=\"vm.action===\'DELETE\'\" \nng-click=\"vm.save()\" aria-label=\"Delete\" class=\"save-button blue-grey-bg white-fg md-raised\">DELETE</md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);